function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("styled-components")) : "function" == typeof define && define.amd ? define(["react", "styled-components"], t) : "object" == typeof exports ? exports.ReactKanban = t(require("react"), require("styled-components")) : e.ReactKanban = t(e.react, e["styled-components"]);
}(window, function (e, t) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 77);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    var n = e.exports = {
      version: "2.6.9"
    };
    "number" == typeof __e && (__e = n);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e, t, n, r, i, o, a, l) {
      if (!e) {
        var u;
        if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, r, i, o, a, l],
            s = 0;
          (u = new Error(t.replace(/%s/g, function () {
            return c[s++];
          }))).name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    };
  }, function (e, t, n) {
    e.exports = n(57)();
  }, function (e, t, n) {
    var r = n(9),
      i = n(2),
      o = n(36),
      a = n(38),
      l = n(22),
      u = function u(e, t, n) {
        var c,
          s,
          d,
          f = e & u.F,
          p = e & u.G,
          m = e & u.S,
          g = e & u.P,
          v = e & u.B,
          b = e & u.W,
          h = p ? i : i[t] || (i[t] = {}),
          y = h.prototype,
          w = p ? r : m ? r[t] : (r[t] || {}).prototype;
        for (c in p && (n = t), n) (s = !f && w && void 0 !== w[c]) && l(h, c) || (d = s ? w[c] : n[c], h[c] = p && "function" != typeof w[c] ? n[c] : v && s ? o(d, r) : b && w[c] == d ? function (e) {
          var t = function t(_t2, n, r) {
            if (this instanceof e) {
              switch (arguments.length) {
                case 0:
                  return new e();
                case 1:
                  return new e(_t2);
                case 2:
                  return new e(_t2, n);
              }
              return new e(_t2, n, r);
            }
            return e.apply(this, arguments);
          };
          return t.prototype = e.prototype, t;
        }(d) : g && "function" == typeof d ? o(Function.call, d) : d, g && ((h.virtual || (h.virtual = {}))[c] = d, e & u.R && y && !y[c] && a(y, c, d)));
      };
    u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, e.exports = u;
  }, function (e, t, n) {
    e.exports = !n(11)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    e.exports = n(53);
  }, function (e, t, n) {
    e.exports = n(69);
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t, n) {
    var r = n(44),
      i = n(27);
    e.exports = Object.keys || function (e) {
      return r(e, i);
    };
  }, function (e, t, n) {
    "use strict";

    !function e() {
      if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) {
        0;
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
        } catch (e) {
          console.error(e);
        }
      }
    }(), e.exports = n(62);
  }, function (e, t, n) {
    var r = n(10);
    e.exports = function (e) {
      if (!r(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, t, n) {
    var r = n(23),
      i = n(24);
    e.exports = function (e) {
      return r(i(e));
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = n(59);
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
      i = {
        childContextTypes: !0,
        contextType: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDefaultProps: !0,
        getDerivedStateFromError: !0,
        getDerivedStateFromProps: !0,
        mixins: !0,
        propTypes: !0,
        type: !0
      },
      o = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
      },
      a = {
        $$typeof: !0,
        compare: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0,
        type: !0
      },
      l = {};
    function u(e) {
      return r.isMemo(e) ? a : l[e.$$typeof] || i;
    }
    l[r.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    };
    var c = Object.defineProperty,
      s = Object.getOwnPropertyNames,
      d = Object.getOwnPropertySymbols,
      f = Object.getOwnPropertyDescriptor,
      p = Object.getPrototypeOf,
      m = Object.prototype;
    e.exports = function e(t, n, r) {
      if ("string" != typeof n) {
        if (m) {
          var i = p(n);
          i && i !== m && e(t, i, r);
        }
        var a = s(n);
        d && (a = a.concat(d(n)));
        for (var l = u(t), g = u(n), v = 0; v < a.length; ++v) {
          var b = a[v];
          if (!(o[b] || r && r[b] || g && g[b] || l && l[b])) {
            var h = f(n, b);
            try {
              c(t, b, h);
            } catch (e) {}
          }
        }
        return t;
      }
      return t;
    };
  }, function (e, t, n) {
    "use strict";

    (function (e, r) {
      var i,
        o = n(31);
      i = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : r;
      var a = Object(o.a)(i);
      t.a = a;
    }).call(this, n(60), n(61)(e));
  }, function (e, t, n) {
    e.exports = n(72);
  }, function (e, t, n) {
    var r = n(14),
      i = n(39),
      o = n(40),
      a = Object.defineProperty;
    t.f = n(6) ? Object.defineProperty : function (e, t, n) {
      if (r(e), t = o(t, !0), r(n), i) try {
        return a(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var r = n(10),
      i = n(9).document,
      o = r(i) && r(i.createElement);
    e.exports = function (e) {
      return o ? i.createElement(e) : {};
    };
  }, function (e, t) {
    var n = {}.hasOwnProperty;
    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    var r = n(45);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == r(e) ? e.split("") : Object(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
      r = Math.floor;
    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    var r = n(49)("keys"),
      i = n(51);
    e.exports = function (e) {
      return r[e] || (r[e] = i(e));
    };
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t, n) {
    var r = n(24);
    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    e.exports = n(34);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t,
        n = e.Symbol;
      return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
    }
    n.d(t, "a", function () {
      return r;
    });
  }, function (e, t, n) {
    e.exports = n(66);
  }, function (e, t, n) {
    e.exports = n(74);
  }, function (e, t, n) {
    n(35);
    var r = n(2).Object;
    e.exports = function (e, t) {
      return r.create(e, t);
    };
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Object", {
      create: n(42)
    });
  }, function (e, t, n) {
    var r = n(37);
    e.exports = function (e, t, n) {
      if (r(e), void 0 === t) return e;
      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };
        case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };
        case 3:
          return function (n, r, i) {
            return e.call(t, n, r, i);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, t, n) {
    var r = n(20),
      i = n(41);
    e.exports = n(6) ? function (e, t, n) {
      return r.f(e, t, i(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    e.exports = !n(6) && !n(11)(function () {
      return 7 != Object.defineProperty(n(21)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(10);
    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, i;
      if (t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;
      if ("function" == typeof (n = e.valueOf) && !r(i = n.call(e))) return i;
      if (!t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(14),
      i = n(43),
      o = n(27),
      a = n(26)("IE_PROTO"),
      l = function l() {},
      _u2 = function u() {
        var e,
          t = n(21)("iframe"),
          r = o.length;
        for (t.style.display = "none", n(52).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _u2 = e.F; r--;) delete _u2.prototype[o[r]];
        return _u2();
      };
    e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (l.prototype = r(e), n = new l(), l.prototype = null, n[a] = e) : n = _u2(), void 0 === t ? n : i(n, t);
    };
  }, function (e, t, n) {
    var r = n(20),
      i = n(14),
      o = n(12);
    e.exports = n(6) ? Object.defineProperties : function (e, t) {
      i(e);
      for (var n, a = o(t), l = a.length, u = 0; l > u;) r.f(e, n = a[u++], t[n]);
      return e;
    };
  }, function (e, t, n) {
    var r = n(22),
      i = n(15),
      o = n(46)(!1),
      a = n(26)("IE_PROTO");
    e.exports = function (e, t) {
      var n,
        l = i(e),
        u = 0,
        c = [];
      for (n in l) n != a && r(l, n) && c.push(n);
      for (; t.length > u;) r(l, n = t[u++]) && (~o(c, n) || c.push(n));
      return c;
    };
  }, function (e, t) {
    var n = {}.toString;
    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var r = n(15),
      i = n(47),
      o = n(48);
    e.exports = function (e) {
      return function (t, n, a) {
        var l,
          u = r(t),
          c = i(u.length),
          s = o(a, c);
        if (e && n != n) {
          for (; c > s;) if ((l = u[s++]) != l) return !0;
        } else for (; c > s; s++) if ((e || s in u) && u[s] === n) return e || s || 0;
        return !e && -1;
      };
    };
  }, function (e, t, n) {
    var r = n(25),
      i = Math.min;
    e.exports = function (e) {
      return e > 0 ? i(r(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var r = n(25),
      i = Math.max,
      o = Math.min;
    e.exports = function (e, t) {
      return (e = r(e)) < 0 ? i(e + t, 0) : o(e, t);
    };
  }, function (e, t, n) {
    var r = n(2),
      i = n(9),
      o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
    (e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: r.version,
      mode: n(50) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t) {
    var n = 0,
      r = Math.random();
    e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
    };
  }, function (e, t, n) {
    var r = n(9).document;
    e.exports = r && r.documentElement;
  }, function (e, t, n) {
    n(54), e.exports = n(2).Object.assign;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S + r.F, "Object", {
      assign: n(55)
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
      i = n(12),
      o = n(56),
      a = n(28),
      l = n(29),
      u = n(23),
      c = Object.assign;
    e.exports = !c || n(11)(function () {
      var e = {},
        t = {},
        n = Symbol(),
        r = "abcdefghijklmnopqrst";
      return e[n] = 7, r.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != c({}, e)[n] || Object.keys(c({}, t)).join("") != r;
    }) ? function (e, t) {
      for (var n = l(e), c = arguments.length, s = 1, d = o.f, f = a.f; c > s;) for (var p, m = u(arguments[s++]), g = d ? i(m).concat(d(m)) : i(m), v = g.length, b = 0; v > b;) p = g[b++], r && !f.call(m, p) || (n[p] = m[p]);
      return n;
    } : c;
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    "use strict";

    var r = n(58);
    function i() {}
    function o() {}
    o.resetWarningCache = i, e.exports = function () {
      function e(e, t, n, i, o, a) {
        if (a !== r) {
          var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw l.name = "Invariant Violation", l;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: o,
        resetWarningCache: i
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    /** @license React v16.9.0
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = "function" == typeof Symbol && Symbol.for,
      i = r ? Symbol.for("react.element") : 60103,
      o = r ? Symbol.for("react.portal") : 60106,
      a = r ? Symbol.for("react.fragment") : 60107,
      l = r ? Symbol.for("react.strict_mode") : 60108,
      u = r ? Symbol.for("react.profiler") : 60114,
      c = r ? Symbol.for("react.provider") : 60109,
      s = r ? Symbol.for("react.context") : 60110,
      d = r ? Symbol.for("react.async_mode") : 60111,
      f = r ? Symbol.for("react.concurrent_mode") : 60111,
      p = r ? Symbol.for("react.forward_ref") : 60112,
      m = r ? Symbol.for("react.suspense") : 60113,
      g = r ? Symbol.for("react.suspense_list") : 60120,
      v = r ? Symbol.for("react.memo") : 60115,
      b = r ? Symbol.for("react.lazy") : 60116,
      h = r ? Symbol.for("react.fundamental") : 60117,
      y = r ? Symbol.for("react.responder") : 60118;
    function w(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch (t) {
          case i:
            switch (e = e.type) {
              case d:
              case f:
              case a:
              case u:
              case l:
              case m:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case p:
                  case c:
                    return e;
                  default:
                    return t;
                }
            }
          case b:
          case v:
          case o:
            return t;
        }
      }
    }
    function x(e) {
      return w(e) === f;
    }
    t.typeOf = w, t.AsyncMode = d, t.ConcurrentMode = f, t.ContextConsumer = s, t.ContextProvider = c, t.Element = i, t.ForwardRef = p, t.Fragment = a, t.Lazy = b, t.Memo = v, t.Portal = o, t.Profiler = u, t.StrictMode = l, t.Suspense = m, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === a || e === f || e === u || e === l || e === m || e === g || "object" == typeof e && null !== e && (e.$$typeof === b || e.$$typeof === v || e.$$typeof === c || e.$$typeof === s || e.$$typeof === p || e.$$typeof === h || e.$$typeof === y);
    }, t.isAsyncMode = function (e) {
      return x(e) || w(e) === d;
    }, t.isConcurrentMode = x, t.isContextConsumer = function (e) {
      return w(e) === s;
    }, t.isContextProvider = function (e) {
      return w(e) === c;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === i;
    }, t.isForwardRef = function (e) {
      return w(e) === p;
    }, t.isFragment = function (e) {
      return w(e) === a;
    }, t.isLazy = function (e) {
      return w(e) === b;
    }, t.isMemo = function (e) {
      return w(e) === v;
    }, t.isPortal = function (e) {
      return w(e) === o;
    }, t.isProfiler = function (e) {
      return w(e) === u;
    }, t.isStrictMode = function (e) {
      return w(e) === l;
    }, t.isSuspense = function (e) {
      return w(e) === m;
    };
  }, function (e, t) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function get() {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function get() {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }
      return t;
    };
  }, function (e, t, n) {
    "use strict";

    /** @license React v16.12.0
     * react-dom.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var r = n(0),
      i = n(63),
      o = n(64);
    function a(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    if (!r) throw Error(a(227));
    var l = null,
      u = {};
    function c() {
      if (l) for (var e in u) {
        var t = u[e],
          n = l.indexOf(e);
        if (!(-1 < n)) throw Error(a(96, e));
        if (!d[n]) {
          if (!t.extractEvents) throw Error(a(97, e));
          for (var r in d[n] = t, n = t.eventTypes) {
            var i = void 0,
              o = n[r],
              c = t,
              p = r;
            if (f.hasOwnProperty(p)) throw Error(a(99, p));
            f[p] = o;
            var m = o.phasedRegistrationNames;
            if (m) {
              for (i in m) m.hasOwnProperty(i) && s(m[i], c, p);
              i = !0;
            } else o.registrationName ? (s(o.registrationName, c, p), i = !0) : i = !1;
            if (!i) throw Error(a(98, r, e));
          }
        }
      }
    }
    function s(e, t, n) {
      if (p[e]) throw Error(a(100, e));
      p[e] = t, m[e] = t.eventTypes[n].dependencies;
    }
    var d = [],
      f = {},
      p = {},
      m = {};
    function g(e, t, n, r, i, o, a, l, u) {
      var c = Array.prototype.slice.call(arguments, 3);
      try {
        t.apply(n, c);
      } catch (e) {
        this.onError(e);
      }
    }
    var v = !1,
      b = null,
      h = !1,
      y = null,
      w = {
        onError: function onError(e) {
          v = !0, b = e;
        }
      };
    function x(e, t, n, r, i, o, a, l, u) {
      v = !1, b = null, g.apply(w, arguments);
    }
    var E = null,
      C = null,
      S = null;
    function T(e, t, n) {
      var r = e.type || "unknown-event";
      e.currentTarget = S(n), function (e, t, n, r, i, o, l, u, c) {
        if (x.apply(this, arguments), v) {
          if (!v) throw Error(a(198));
          var s = b;
          v = !1, b = null, h || (h = !0, y = s);
        }
      }(r, t, void 0, e), e.currentTarget = null;
    }
    function O(e, t) {
      if (null == t) throw Error(a(30));
      return null == e ? t : Array.isArray(e) ? Array.isArray(t) ? (e.push.apply(e, t), e) : (e.push(t), e) : Array.isArray(t) ? [e].concat(t) : [e, t];
    }
    function k(e, t, n) {
      Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
    }
    var P = null;
    function D(e) {
      if (e) {
        var t = e._dispatchListeners,
          n = e._dispatchInstances;
        if (Array.isArray(t)) for (var r = 0; r < t.length && !e.isPropagationStopped(); r++) T(e, t[r], n[r]);else t && T(e, t, n);
        e._dispatchListeners = null, e._dispatchInstances = null, e.isPersistent() || e.constructor.release(e);
      }
    }
    function I(e) {
      if (null !== e && (P = O(P, e)), e = P, P = null, e) {
        if (k(e, D), P) throw Error(a(95));
        if (h) throw e = y, h = !1, y = null, e;
      }
    }
    var N = {
      injectEventPluginOrder: function injectEventPluginOrder(e) {
        if (l) throw Error(a(101));
        l = Array.prototype.slice.call(e), c();
      },
      injectEventPluginsByName: function injectEventPluginsByName(e) {
        var t,
          n = !1;
        for (t in e) if (e.hasOwnProperty(t)) {
          var r = e[t];
          if (!u.hasOwnProperty(t) || u[t] !== r) {
            if (u[t]) throw Error(a(102, t));
            u[t] = r, n = !0;
          }
        }
        n && c();
      }
    };
    function R(e, t) {
      var n = e.stateNode;
      if (!n) return null;
      var r = E(n);
      if (!r) return null;
      n = r[t];
      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
          (r = !r.disabled) || (r = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !r;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (n && "function" != typeof n) throw Error(a(231, t, typeof n));
      return n;
    }
    var _ = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    _.hasOwnProperty("ReactCurrentDispatcher") || (_.ReactCurrentDispatcher = {
      current: null
    }), _.hasOwnProperty("ReactCurrentBatchConfig") || (_.ReactCurrentBatchConfig = {
      suspense: null
    });
    var A = /^(.*)[\\\/]/,
      L = "function" == typeof Symbol && Symbol.for,
      j = L ? Symbol.for("react.element") : 60103,
      M = L ? Symbol.for("react.portal") : 60106,
      B = L ? Symbol.for("react.fragment") : 60107,
      F = L ? Symbol.for("react.strict_mode") : 60108,
      z = L ? Symbol.for("react.profiler") : 60114,
      U = L ? Symbol.for("react.provider") : 60109,
      G = L ? Symbol.for("react.context") : 60110,
      W = L ? Symbol.for("react.concurrent_mode") : 60111,
      H = L ? Symbol.for("react.forward_ref") : 60112,
      V = L ? Symbol.for("react.suspense") : 60113,
      q = L ? Symbol.for("react.suspense_list") : 60120,
      $ = L ? Symbol.for("react.memo") : 60115,
      K = L ? Symbol.for("react.lazy") : 60116;
    L && Symbol.for("react.fundamental"), L && Symbol.for("react.responder"), L && Symbol.for("react.scope");
    var Q = "function" == typeof Symbol && Symbol.iterator;
    function Y(e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = Q && e[Q] || e["@@iterator"]) ? e : null;
    }
    function X(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;
      switch (e) {
        case B:
          return "Fragment";
        case M:
          return "Portal";
        case z:
          return "Profiler";
        case F:
          return "StrictMode";
        case V:
          return "Suspense";
        case q:
          return "SuspenseList";
      }
      if ("object" == typeof e) switch (e.$$typeof) {
        case G:
          return "Context.Consumer";
        case U:
          return "Context.Provider";
        case H:
          var t = e.render;
          return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
        case $:
          return X(e.type);
        case K:
          if (e = 1 === e._status ? e._result : null) return X(e);
      }
      return null;
    }
    function J(e) {
      var t = "";
      do {
        e: switch (e.tag) {
          case 3:
          case 4:
          case 6:
          case 7:
          case 10:
          case 9:
            var n = "";
            break e;
          default:
            var r = e._debugOwner,
              i = e._debugSource,
              o = X(e.type);
            n = null, r && (n = X(r.type)), r = o, o = "", i ? o = " (at " + i.fileName.replace(A, "") + ":" + i.lineNumber + ")" : n && (o = " (created by " + n + ")"), n = "\n    in " + (r || "Unknown") + o;
        }
        t += n, e = e.return;
      } while (e);
      return t;
    }
    var Z = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
      ee = null,
      te = null,
      ne = null;
    function re(e) {
      if (e = C(e)) {
        if ("function" != typeof ee) throw Error(a(280));
        var t = E(e.stateNode);
        ee(e.stateNode, e.type, t);
      }
    }
    function ie(e) {
      te ? ne ? ne.push(e) : ne = [e] : te = e;
    }
    function oe() {
      if (te) {
        var e = te,
          t = ne;
        if (ne = te = null, re(e), t) for (e = 0; e < t.length; e++) re(t[e]);
      }
    }
    function ae(e, t) {
      return e(t);
    }
    function le(e, t, n, r) {
      return e(t, n, r);
    }
    function ue() {}
    var ce = ae,
      se = !1,
      de = !1;
    function fe() {
      null === te && null === ne || (ue(), oe());
    }
    new Map();
    var pe = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      me = Object.prototype.hasOwnProperty,
      ge = {},
      ve = {};
    function be(e, t, n, r, i, o) {
      this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o;
    }
    var he = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
      he[e] = new be(e, 0, !1, e, null, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
      var t = e[0];
      he[t] = new be(t, 1, !1, e[1], null, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
      he[e] = new be(e, 2, !1, e.toLowerCase(), null, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
      he[e] = new be(e, 2, !1, e, null, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
      he[e] = new be(e, 3, !1, e.toLowerCase(), null, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
      he[e] = new be(e, 3, !0, e, null, !1);
    }), ["capture", "download"].forEach(function (e) {
      he[e] = new be(e, 4, !1, e, null, !1);
    }), ["cols", "rows", "size", "span"].forEach(function (e) {
      he[e] = new be(e, 6, !1, e, null, !1);
    }), ["rowSpan", "start"].forEach(function (e) {
      he[e] = new be(e, 5, !1, e.toLowerCase(), null, !1);
    });
    var ye = /[\-:]([a-z])/g;
    function we(e) {
      return e[1].toUpperCase();
    }
    function xe(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
          return e;
        default:
          return "";
      }
    }
    function Ee(e, t, n, r) {
      var i = he.hasOwnProperty(t) ? he[t] : null;
      (null !== i ? 0 === i.type : !r && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function (e, t, n, r) {
        if (null == t || function (e, t, n, r) {
          if (null !== n && 0 === n.type) return !1;
          switch (typeof t) {
            case "function":
            case "symbol":
              return !0;
            case "boolean":
              return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
            default:
              return !1;
          }
        }(e, t, n, r)) return !0;
        if (r) return !1;
        if (null !== n) switch (n.type) {
          case 3:
            return !t;
          case 4:
            return !1 === t;
          case 5:
            return isNaN(t);
          case 6:
            return isNaN(t) || 1 > t;
        }
        return !1;
      }(t, n, i, r) && (n = null), r || null === i ? function (e) {
        return !!me.call(ve, e) || !me.call(ge, e) && (pe.test(e) ? ve[e] = !0 : (ge[e] = !0, !1));
      }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : i.mustUseProperty ? e[i.propertyName] = null === n ? 3 !== i.type && "" : n : (t = i.attributeName, r = i.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (i = i.type) || 4 === i && !0 === n ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
    }
    function Ce(e) {
      var t = e.type;
      return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
    }
    function Se(e) {
      e._valueTracker || (e._valueTracker = function (e) {
        var t = Ce(e) ? "checked" : "value",
          n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
          r = "" + e[t];
        if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
          var i = n.get,
            o = n.set;
          return Object.defineProperty(e, t, {
            configurable: !0,
            get: function get() {
              return i.call(this);
            },
            set: function set(e) {
              r = "" + e, o.call(this, e);
            }
          }), Object.defineProperty(e, t, {
            enumerable: n.enumerable
          }), {
            getValue: function getValue() {
              return r;
            },
            setValue: function setValue(e) {
              r = "" + e;
            },
            stopTracking: function stopTracking() {
              e._valueTracker = null, delete e[t];
            }
          };
        }
      }(e));
    }
    function Te(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var n = t.getValue(),
        r = "";
      return e && (r = Ce(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
    }
    function Oe(e, t) {
      var n = t.checked;
      return i({}, t, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != n ? n : e._wrapperState.initialChecked
      });
    }
    function ke(e, t) {
      var n = null == t.defaultValue ? "" : t.defaultValue,
        r = null != t.checked ? t.checked : t.defaultChecked;
      n = xe(null != t.value ? t.value : n), e._wrapperState = {
        initialChecked: r,
        initialValue: n,
        controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
      };
    }
    function Pe(e, t) {
      null != (t = t.checked) && Ee(e, "checked", t, !1);
    }
    function De(e, t) {
      Pe(e, t);
      var n = xe(t.value),
        r = t.type;
      if (null != n) "number" === r ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if ("submit" === r || "reset" === r) return void e.removeAttribute("value");
      t.hasOwnProperty("value") ? Ne(e, t.type, n) : t.hasOwnProperty("defaultValue") && Ne(e, t.type, xe(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
    }
    function Ie(e, t, n) {
      if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
        var r = t.type;
        if (!("submit" !== r && "reset" !== r || void 0 !== t.value && null !== t.value)) return;
        t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
      }
      "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !e.defaultChecked, e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
    }
    function Ne(e, t, n) {
      "number" === t && e.ownerDocument.activeElement === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
    }
    function Re(e, t) {
      return e = i({
        children: void 0
      }, t), (t = function (e) {
        var t = "";
        return r.Children.forEach(e, function (e) {
          null != e && (t += e);
        }), t;
      }(t.children)) && (e.children = t), e;
    }
    function _e(e, t, n, r) {
      if (e = e.options, t) {
        t = {};
        for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
        for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
      } else {
        for (n = "" + xe(n), t = null, i = 0; i < e.length; i++) {
          if (e[i].value === n) return e[i].selected = !0, void (r && (e[i].defaultSelected = !0));
          null !== t || e[i].disabled || (t = e[i]);
        }
        null !== t && (t.selected = !0);
      }
    }
    function Ae(e, t) {
      if (null != t.dangerouslySetInnerHTML) throw Error(a(91));
      return i({}, t, {
        value: void 0,
        defaultValue: void 0,
        children: "" + e._wrapperState.initialValue
      });
    }
    function Le(e, t) {
      var n = t.value;
      if (null == n) {
        if (n = t.defaultValue, null != (t = t.children)) {
          if (null != n) throw Error(a(92));
          if (Array.isArray(t)) {
            if (!(1 >= t.length)) throw Error(a(93));
            t = t[0];
          }
          n = t;
        }
        null == n && (n = "");
      }
      e._wrapperState = {
        initialValue: xe(n)
      };
    }
    function je(e, t) {
      var n = xe(t.value),
        r = xe(t.defaultValue);
      null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != r && (e.defaultValue = "" + r);
    }
    function Me(e) {
      var t = e.textContent;
      t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
      var t = e.replace(ye, we);
      he[t] = new be(t, 1, !1, e, null, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
      var t = e.replace(ye, we);
      he[t] = new be(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
      var t = e.replace(ye, we);
      he[t] = new be(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (e) {
      he[e] = new be(e, 1, !1, e.toLowerCase(), null, !1);
    }), he.xlinkHref = new be("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (e) {
      he[e] = new be(e, 1, !1, e.toLowerCase(), null, !0);
    });
    var Be = {
      html: "http://www.w3.org/1999/xhtml",
      mathml: "http://www.w3.org/1998/Math/MathML",
      svg: "http://www.w3.org/2000/svg"
    };
    function Fe(e) {
      switch (e) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    function ze(e, t) {
      return null == e || "http://www.w3.org/1999/xhtml" === e ? Fe(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
    }
    var Ue,
      Ge = function (e) {
        return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (t, n, r, i) {
          MSApp.execUnsafeLocalFunction(function () {
            return e(t, n);
          });
        } : e;
      }(function (e, t) {
        if (e.namespaceURI !== Be.svg || "innerHTML" in e) e.innerHTML = t;else {
          for ((Ue = Ue || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Ue.firstChild; e.firstChild;) e.removeChild(e.firstChild);
          for (; t.firstChild;) e.appendChild(t.firstChild);
        }
      });
    function We(e, t) {
      if (t) {
        var n = e.firstChild;
        if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
      }
      e.textContent = t;
    }
    function He(e, t) {
      var n = {};
      return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
    }
    var Ve = {
        animationend: He("Animation", "AnimationEnd"),
        animationiteration: He("Animation", "AnimationIteration"),
        animationstart: He("Animation", "AnimationStart"),
        transitionend: He("Transition", "TransitionEnd")
      },
      qe = {},
      $e = {};
    function Ke(e) {
      if (qe[e]) return qe[e];
      if (!Ve[e]) return e;
      var t,
        n = Ve[e];
      for (t in n) if (n.hasOwnProperty(t) && t in $e) return qe[e] = n[t];
      return e;
    }
    Z && ($e = document.createElement("div").style, "AnimationEvent" in window || (delete Ve.animationend.animation, delete Ve.animationiteration.animation, delete Ve.animationstart.animation), "TransitionEvent" in window || delete Ve.transitionend.transition);
    var Qe = Ke("animationend"),
      Ye = Ke("animationiteration"),
      Xe = Ke("animationstart"),
      Je = Ke("transitionend"),
      Ze = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
    function et(e) {
      var t = e,
        n = e;
      if (e.alternate) for (; t.return;) t = t.return;else {
        e = t;
        do {
          0 != (1026 & (t = e).effectTag) && (n = t.return), e = t.return;
        } while (e);
      }
      return 3 === t.tag ? n : null;
    }
    function tt(e) {
      if (13 === e.tag) {
        var t = e.memoizedState;
        if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
      }
      return null;
    }
    function nt(e) {
      if (et(e) !== e) throw Error(a(188));
    }
    function rt(e) {
      if (!(e = function (e) {
        var t = e.alternate;
        if (!t) {
          if (null === (t = et(e))) throw Error(a(188));
          return t !== e ? null : e;
        }
        for (var n = e, r = t;;) {
          var i = n.return;
          if (null === i) break;
          var o = i.alternate;
          if (null === o) {
            if (null !== (r = i.return)) {
              n = r;
              continue;
            }
            break;
          }
          if (i.child === o.child) {
            for (o = i.child; o;) {
              if (o === n) return nt(i), e;
              if (o === r) return nt(i), t;
              o = o.sibling;
            }
            throw Error(a(188));
          }
          if (n.return !== r.return) n = i, r = o;else {
            for (var l = !1, u = i.child; u;) {
              if (u === n) {
                l = !0, n = i, r = o;
                break;
              }
              if (u === r) {
                l = !0, r = i, n = o;
                break;
              }
              u = u.sibling;
            }
            if (!l) {
              for (u = o.child; u;) {
                if (u === n) {
                  l = !0, n = o, r = i;
                  break;
                }
                if (u === r) {
                  l = !0, r = o, n = i;
                  break;
                }
                u = u.sibling;
              }
              if (!l) throw Error(a(189));
            }
          }
          if (n.alternate !== r) throw Error(a(190));
        }
        if (3 !== n.tag) throw Error(a(188));
        return n.stateNode.current === n ? e : t;
      }(e))) return null;
      for (var t = e;;) {
        if (5 === t.tag || 6 === t.tag) return t;
        if (t.child) t.child.return = t, t = t.child;else {
          if (t === e) break;
          for (; !t.sibling;) {
            if (!t.return || t.return === e) return null;
            t = t.return;
          }
          t.sibling.return = t.return, t = t.sibling;
        }
      }
      return null;
    }
    var it,
      ot,
      at,
      lt = !1,
      ut = [],
      ct = null,
      st = null,
      dt = null,
      ft = new Map(),
      pt = new Map(),
      mt = [],
      gt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
      vt = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
    function bt(e, t, n, r) {
      return {
        blockedOn: e,
        topLevelType: t,
        eventSystemFlags: 32 | n,
        nativeEvent: r
      };
    }
    function ht(e, t) {
      switch (e) {
        case "focus":
        case "blur":
          ct = null;
          break;
        case "dragenter":
        case "dragleave":
          st = null;
          break;
        case "mouseover":
        case "mouseout":
          dt = null;
          break;
        case "pointerover":
        case "pointerout":
          ft.delete(t.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          pt.delete(t.pointerId);
      }
    }
    function yt(e, t, n, r, i) {
      return null === e || e.nativeEvent !== i ? (e = bt(t, n, r, i), null !== t && null !== (t = pr(t)) && ot(t), e) : (e.eventSystemFlags |= r, e);
    }
    function wt(e) {
      var t = fr(e.target);
      if (null !== t) {
        var n = et(t);
        if (null !== n) if (13 === (t = n.tag)) {
          if (null !== (t = tt(n))) return e.blockedOn = t, void o.unstable_runWithPriority(e.priority, function () {
            at(n);
          });
        } else if (3 === t && n.stateNode.hydrate) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
      }
      e.blockedOn = null;
    }
    function xt(e) {
      if (null !== e.blockedOn) return !1;
      var t = Nn(e.topLevelType, e.eventSystemFlags, e.nativeEvent);
      if (null !== t) {
        var n = pr(t);
        return null !== n && ot(n), e.blockedOn = t, !1;
      }
      return !0;
    }
    function Et(e, t, n) {
      xt(e) && n.delete(t);
    }
    function Ct() {
      for (lt = !1; 0 < ut.length;) {
        var e = ut[0];
        if (null !== e.blockedOn) {
          null !== (e = pr(e.blockedOn)) && it(e);
          break;
        }
        var t = Nn(e.topLevelType, e.eventSystemFlags, e.nativeEvent);
        null !== t ? e.blockedOn = t : ut.shift();
      }
      null !== ct && xt(ct) && (ct = null), null !== st && xt(st) && (st = null), null !== dt && xt(dt) && (dt = null), ft.forEach(Et), pt.forEach(Et);
    }
    function St(e, t) {
      e.blockedOn === t && (e.blockedOn = null, lt || (lt = !0, o.unstable_scheduleCallback(o.unstable_NormalPriority, Ct)));
    }
    function Tt(e) {
      function t(t) {
        return St(t, e);
      }
      if (0 < ut.length) {
        St(ut[0], e);
        for (var n = 1; n < ut.length; n++) {
          var r = ut[n];
          r.blockedOn === e && (r.blockedOn = null);
        }
      }
      for (null !== ct && St(ct, e), null !== st && St(st, e), null !== dt && St(dt, e), ft.forEach(t), pt.forEach(t), n = 0; n < mt.length; n++) (r = mt[n]).blockedOn === e && (r.blockedOn = null);
      for (; 0 < mt.length && null === (n = mt[0]).blockedOn;) wt(n), null === n.blockedOn && mt.shift();
    }
    function Ot(e) {
      return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
    }
    function kt(e) {
      do {
        e = e.return;
      } while (e && 5 !== e.tag);
      return e || null;
    }
    function Pt(e, t, n) {
      (t = R(e, n.dispatchConfig.phasedRegistrationNames[t])) && (n._dispatchListeners = O(n._dispatchListeners, t), n._dispatchInstances = O(n._dispatchInstances, e));
    }
    function Dt(e) {
      if (e && e.dispatchConfig.phasedRegistrationNames) {
        for (var t = e._targetInst, n = []; t;) n.push(t), t = kt(t);
        for (t = n.length; 0 < t--;) Pt(n[t], "captured", e);
        for (t = 0; t < n.length; t++) Pt(n[t], "bubbled", e);
      }
    }
    function It(e, t, n) {
      e && n && n.dispatchConfig.registrationName && (t = R(e, n.dispatchConfig.registrationName)) && (n._dispatchListeners = O(n._dispatchListeners, t), n._dispatchInstances = O(n._dispatchInstances, e));
    }
    function Nt(e) {
      e && e.dispatchConfig.registrationName && It(e._targetInst, null, e);
    }
    function Rt(e) {
      k(e, Dt);
    }
    function _t() {
      return !0;
    }
    function At() {
      return !1;
    }
    function Lt(e, t, n, r) {
      for (var i in this.dispatchConfig = e, this._targetInst = t, this.nativeEvent = n, e = this.constructor.Interface) e.hasOwnProperty(i) && ((t = e[i]) ? this[i] = t(n) : "target" === i ? this.target = r : this[i] = n[i]);
      return this.isDefaultPrevented = (null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue) ? _t : At, this.isPropagationStopped = At, this;
    }
    function jt(e, t, n, r) {
      if (this.eventPool.length) {
        var i = this.eventPool.pop();
        return this.call(i, e, t, n, r), i;
      }
      return new this(e, t, n, r);
    }
    function Mt(e) {
      if (!(e instanceof this)) throw Error(a(279));
      e.destructor(), 10 > this.eventPool.length && this.eventPool.push(e);
    }
    function Bt(e) {
      e.eventPool = [], e.getPooled = jt, e.release = Mt;
    }
    i(Lt.prototype, {
      preventDefault: function preventDefault() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = _t);
      },
      stopPropagation: function stopPropagation() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = _t);
      },
      persist: function persist() {
        this.isPersistent = _t;
      },
      isPersistent: At,
      destructor: function destructor() {
        var e,
          t = this.constructor.Interface;
        for (e in t) this[e] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = At, this._dispatchInstances = this._dispatchListeners = null;
      }
    }), Lt.Interface = {
      type: null,
      target: null,
      currentTarget: function currentTarget() {
        return null;
      },
      eventPhase: null,
      bubbles: null,
      cancelable: null,
      timeStamp: function timeStamp(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: null,
      isTrusted: null
    }, Lt.extend = function (e) {
      function t() {}
      function n() {
        return r.apply(this, arguments);
      }
      var r = this;
      t.prototype = r.prototype;
      var o = new t();
      return i(o, n.prototype), n.prototype = o, n.prototype.constructor = n, n.Interface = i({}, r.Interface, e), n.extend = r.extend, Bt(n), n;
    }, Bt(Lt);
    var Ft = Lt.extend({
        animationName: null,
        elapsedTime: null,
        pseudoElement: null
      }),
      zt = Lt.extend({
        clipboardData: function clipboardData(e) {
          return "clipboardData" in e ? e.clipboardData : window.clipboardData;
        }
      }),
      Ut = Lt.extend({
        view: null,
        detail: null
      }),
      Gt = Ut.extend({
        relatedTarget: null
      });
    function Wt(e) {
      var t = e.keyCode;
      return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
    }
    var Ht = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      },
      Vt = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      },
      qt = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
      };
    function $t(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : !!(e = qt[e]) && !!t[e];
    }
    function Kt() {
      return $t;
    }
    for (var Qt = Ut.extend({
        key: function key(e) {
          if (e.key) {
            var t = Ht[e.key] || e.key;
            if ("Unidentified" !== t) return t;
          }
          return "keypress" === e.type ? 13 === (e = Wt(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? Vt[e.keyCode] || "Unidentified" : "";
        },
        location: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        repeat: null,
        locale: null,
        getModifierState: Kt,
        charCode: function charCode(e) {
          return "keypress" === e.type ? Wt(e) : 0;
        },
        keyCode: function keyCode(e) {
          return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        },
        which: function which(e) {
          return "keypress" === e.type ? Wt(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
        }
      }), Yt = 0, Xt = 0, Jt = !1, Zt = !1, en = Ut.extend({
        screenX: null,
        screenY: null,
        clientX: null,
        clientY: null,
        pageX: null,
        pageY: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        getModifierState: Kt,
        button: null,
        buttons: null,
        relatedTarget: function relatedTarget(e) {
          return e.relatedTarget || (e.fromElement === e.srcElement ? e.toElement : e.fromElement);
        },
        movementX: function movementX(e) {
          if (("movementX" in e)) return e.movementX;
          var t = Yt;
          return Yt = e.screenX, Jt ? "mousemove" === e.type ? e.screenX - t : 0 : (Jt = !0, 0);
        },
        movementY: function movementY(e) {
          if (("movementY" in e)) return e.movementY;
          var t = Xt;
          return Xt = e.screenY, Zt ? "mousemove" === e.type ? e.screenY - t : 0 : (Zt = !0, 0);
        }
      }), tn = en.extend({
        pointerId: null,
        width: null,
        height: null,
        pressure: null,
        tangentialPressure: null,
        tiltX: null,
        tiltY: null,
        twist: null,
        pointerType: null,
        isPrimary: null
      }), nn = en.extend({
        dataTransfer: null
      }), rn = Ut.extend({
        touches: null,
        targetTouches: null,
        changedTouches: null,
        altKey: null,
        metaKey: null,
        ctrlKey: null,
        shiftKey: null,
        getModifierState: Kt
      }), on = Lt.extend({
        propertyName: null,
        elapsedTime: null,
        pseudoElement: null
      }), an = en.extend({
        deltaX: function deltaX(e) {
          return ("deltaX" in e) ? e.deltaX : ("wheelDeltaX" in e) ? -e.wheelDeltaX : 0;
        },
        deltaY: function deltaY(e) {
          return ("deltaY" in e) ? e.deltaY : ("wheelDeltaY" in e) ? -e.wheelDeltaY : ("wheelDelta" in e) ? -e.wheelDelta : 0;
        },
        deltaZ: null,
        deltaMode: null
      }), ln = [["blur", "blur", 0], ["cancel", "cancel", 0], ["click", "click", 0], ["close", "close", 0], ["contextmenu", "contextMenu", 0], ["copy", "copy", 0], ["cut", "cut", 0], ["auxclick", "auxClick", 0], ["dblclick", "doubleClick", 0], ["dragend", "dragEnd", 0], ["dragstart", "dragStart", 0], ["drop", "drop", 0], ["focus", "focus", 0], ["input", "input", 0], ["invalid", "invalid", 0], ["keydown", "keyDown", 0], ["keypress", "keyPress", 0], ["keyup", "keyUp", 0], ["mousedown", "mouseDown", 0], ["mouseup", "mouseUp", 0], ["paste", "paste", 0], ["pause", "pause", 0], ["play", "play", 0], ["pointercancel", "pointerCancel", 0], ["pointerdown", "pointerDown", 0], ["pointerup", "pointerUp", 0], ["ratechange", "rateChange", 0], ["reset", "reset", 0], ["seeked", "seeked", 0], ["submit", "submit", 0], ["touchcancel", "touchCancel", 0], ["touchend", "touchEnd", 0], ["touchstart", "touchStart", 0], ["volumechange", "volumeChange", 0], ["drag", "drag", 1], ["dragenter", "dragEnter", 1], ["dragexit", "dragExit", 1], ["dragleave", "dragLeave", 1], ["dragover", "dragOver", 1], ["mousemove", "mouseMove", 1], ["mouseout", "mouseOut", 1], ["mouseover", "mouseOver", 1], ["pointermove", "pointerMove", 1], ["pointerout", "pointerOut", 1], ["pointerover", "pointerOver", 1], ["scroll", "scroll", 1], ["toggle", "toggle", 1], ["touchmove", "touchMove", 1], ["wheel", "wheel", 1], ["abort", "abort", 2], [Qe, "animationEnd", 2], [Ye, "animationIteration", 2], [Xe, "animationStart", 2], ["canplay", "canPlay", 2], ["canplaythrough", "canPlayThrough", 2], ["durationchange", "durationChange", 2], ["emptied", "emptied", 2], ["encrypted", "encrypted", 2], ["ended", "ended", 2], ["error", "error", 2], ["gotpointercapture", "gotPointerCapture", 2], ["load", "load", 2], ["loadeddata", "loadedData", 2], ["loadedmetadata", "loadedMetadata", 2], ["loadstart", "loadStart", 2], ["lostpointercapture", "lostPointerCapture", 2], ["playing", "playing", 2], ["progress", "progress", 2], ["seeking", "seeking", 2], ["stalled", "stalled", 2], ["suspend", "suspend", 2], ["timeupdate", "timeUpdate", 2], [Je, "transitionEnd", 2], ["waiting", "waiting", 2]], un = {}, cn = {}, sn = 0; sn < ln.length; sn++) {
      var dn = ln[sn],
        fn = dn[0],
        pn = dn[1],
        mn = dn[2],
        gn = "on" + (pn[0].toUpperCase() + pn.slice(1)),
        vn = {
          phasedRegistrationNames: {
            bubbled: gn,
            captured: gn + "Capture"
          },
          dependencies: [fn],
          eventPriority: mn
        };
      un[pn] = vn, cn[fn] = vn;
    }
    var bn = {
        eventTypes: un,
        getEventPriority: function getEventPriority(e) {
          return void 0 !== (e = cn[e]) ? e.eventPriority : 2;
        },
        extractEvents: function extractEvents(e, t, n, r) {
          var i = cn[e];
          if (!i) return null;
          switch (e) {
            case "keypress":
              if (0 === Wt(n)) return null;
            case "keydown":
            case "keyup":
              e = Qt;
              break;
            case "blur":
            case "focus":
              e = Gt;
              break;
            case "click":
              if (2 === n.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              e = en;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              e = nn;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              e = rn;
              break;
            case Qe:
            case Ye:
            case Xe:
              e = Ft;
              break;
            case Je:
              e = on;
              break;
            case "scroll":
              e = Ut;
              break;
            case "wheel":
              e = an;
              break;
            case "copy":
            case "cut":
            case "paste":
              e = zt;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              e = tn;
              break;
            default:
              e = Lt;
          }
          return Rt(t = e.getPooled(i, t, n, r)), t;
        }
      },
      hn = o.unstable_UserBlockingPriority,
      yn = o.unstable_runWithPriority,
      wn = bn.getEventPriority,
      xn = 10,
      En = [];
    function Cn(e) {
      var t = e.targetInst,
        n = t;
      do {
        if (!n) {
          e.ancestors.push(n);
          break;
        }
        var r = n;
        if (3 === r.tag) r = r.stateNode.containerInfo;else {
          for (; r.return;) r = r.return;
          r = 3 !== r.tag ? null : r.stateNode.containerInfo;
        }
        if (!r) break;
        5 !== (t = n.tag) && 6 !== t || e.ancestors.push(n), n = fr(r);
      } while (n);
      for (n = 0; n < e.ancestors.length; n++) {
        t = e.ancestors[n];
        var i = Ot(e.nativeEvent);
        r = e.topLevelType;
        for (var o = e.nativeEvent, a = e.eventSystemFlags, l = null, u = 0; u < d.length; u++) {
          var c = d[u];
          c && (c = c.extractEvents(r, t, o, i, a)) && (l = O(l, c));
        }
        I(l);
      }
    }
    var Sn = !0;
    function Tn(e, t) {
      On(t, e, !1);
    }
    function On(e, t, n) {
      switch (wn(t)) {
        case 0:
          var r = kn.bind(null, t, 1);
          break;
        case 1:
          r = Pn.bind(null, t, 1);
          break;
        default:
          r = In.bind(null, t, 1);
      }
      n ? e.addEventListener(t, r, !0) : e.addEventListener(t, r, !1);
    }
    function kn(e, t, n) {
      se || ue();
      var r = In,
        i = se;
      se = !0;
      try {
        le(r, e, t, n);
      } finally {
        (se = i) || fe();
      }
    }
    function Pn(e, t, n) {
      yn(hn, In.bind(null, e, t, n));
    }
    function Dn(e, t, n, r) {
      if (En.length) {
        var i = En.pop();
        i.topLevelType = e, i.eventSystemFlags = t, i.nativeEvent = n, i.targetInst = r, e = i;
      } else e = {
        topLevelType: e,
        eventSystemFlags: t,
        nativeEvent: n,
        targetInst: r,
        ancestors: []
      };
      try {
        if (t = Cn, n = e, de) t(n, void 0);else {
          de = !0;
          try {
            ce(t, n, void 0);
          } finally {
            de = !1, fe();
          }
        }
      } finally {
        e.topLevelType = null, e.nativeEvent = null, e.targetInst = null, e.ancestors.length = 0, En.length < xn && En.push(e);
      }
    }
    function In(e, t, n) {
      if (Sn) if (0 < ut.length && -1 < gt.indexOf(e)) e = bt(null, e, t, n), ut.push(e);else {
        var r = Nn(e, t, n);
        null === r ? ht(e, n) : -1 < gt.indexOf(e) ? (e = bt(r, e, t, n), ut.push(e)) : function (e, t, n, r) {
          switch (t) {
            case "focus":
              return ct = yt(ct, e, t, n, r), !0;
            case "dragenter":
              return st = yt(st, e, t, n, r), !0;
            case "mouseover":
              return dt = yt(dt, e, t, n, r), !0;
            case "pointerover":
              var i = r.pointerId;
              return ft.set(i, yt(ft.get(i) || null, e, t, n, r)), !0;
            case "gotpointercapture":
              return i = r.pointerId, pt.set(i, yt(pt.get(i) || null, e, t, n, r)), !0;
          }
          return !1;
        }(r, e, t, n) || (ht(e, n), Dn(e, t, n, null));
      }
    }
    function Nn(e, t, n) {
      var r = Ot(n);
      if (null !== (r = fr(r))) {
        var i = et(r);
        if (null === i) r = null;else {
          var o = i.tag;
          if (13 === o) {
            if (null !== (r = tt(i))) return r;
            r = null;
          } else if (3 === o) {
            if (i.stateNode.hydrate) return 3 === i.tag ? i.stateNode.containerInfo : null;
            r = null;
          } else i !== r && (r = null);
        }
      }
      return Dn(e, t, n, r), null;
    }
    function Rn(e) {
      if (!Z) return !1;
      var t = ((e = "on" + e) in document);
      return t || ((t = document.createElement("div")).setAttribute(e, "return;"), t = "function" == typeof t[e]), t;
    }
    var _n = new ("function" == typeof WeakMap ? WeakMap : Map)();
    function An(e) {
      var t = _n.get(e);
      return void 0 === t && (t = new Set(), _n.set(e, t)), t;
    }
    function Ln(e, t, n) {
      if (!n.has(e)) {
        switch (e) {
          case "scroll":
            On(t, "scroll", !0);
            break;
          case "focus":
          case "blur":
            On(t, "focus", !0), On(t, "blur", !0), n.add("blur"), n.add("focus");
            break;
          case "cancel":
          case "close":
            Rn(e) && On(t, e, !0);
            break;
          case "invalid":
          case "submit":
          case "reset":
            break;
          default:
            -1 === Ze.indexOf(e) && Tn(e, t);
        }
        n.add(e);
      }
    }
    var jn = {
        animationIterationCount: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      },
      Mn = ["Webkit", "ms", "Moz", "O"];
    function Bn(e, t, n) {
      return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || jn.hasOwnProperty(e) && jn[e] ? ("" + t).trim() : t + "px";
    }
    function Fn(e, t) {
      for (var n in e = e.style, t) if (t.hasOwnProperty(n)) {
        var r = 0 === n.indexOf("--"),
          i = Bn(n, t[n], r);
        "float" === n && (n = "cssFloat"), r ? e.setProperty(n, i) : e[n] = i;
      }
    }
    Object.keys(jn).forEach(function (e) {
      Mn.forEach(function (t) {
        t = t + e.charAt(0).toUpperCase() + e.substring(1), jn[t] = jn[e];
      });
    });
    var zn = i({
      menuitem: !0
    }, {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    });
    function Un(e, t) {
      if (t) {
        if (zn[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(a(137, e, ""));
        if (null != t.dangerouslySetInnerHTML) {
          if (null != t.children) throw Error(a(60));
          if (!("object" == typeof t.dangerouslySetInnerHTML && "__html" in t.dangerouslySetInnerHTML)) throw Error(a(61));
        }
        if (null != t.style && "object" != typeof t.style) throw Error(a(62, ""));
      }
    }
    function Gn(e, t) {
      if (-1 === e.indexOf("-")) return "string" == typeof t.is;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function Wn(e, t) {
      var n = An(e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument);
      t = m[t];
      for (var r = 0; r < t.length; r++) Ln(t[r], e, n);
    }
    function Hn() {}
    function Vn(e) {
      if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
      try {
        return e.activeElement || e.body;
      } catch (t) {
        return e.body;
      }
    }
    function qn(e) {
      for (; e && e.firstChild;) e = e.firstChild;
      return e;
    }
    function $n(e, t) {
      var n,
        r = qn(e);
      for (e = 0; r;) {
        if (3 === r.nodeType) {
          if (n = e + r.textContent.length, e <= t && n >= t) return {
            node: r,
            offset: t - e
          };
          e = n;
        }
        e: {
          for (; r;) {
            if (r.nextSibling) {
              r = r.nextSibling;
              break e;
            }
            r = r.parentNode;
          }
          r = void 0;
        }
        r = qn(r);
      }
    }
    function Kn() {
      for (var e = window, t = Vn(); t instanceof e.HTMLIFrameElement;) {
        try {
          var n = "string" == typeof t.contentWindow.location.href;
        } catch (e) {
          n = !1;
        }
        if (!n) break;
        t = Vn((e = t.contentWindow).document);
      }
      return t;
    }
    function Qn(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
    }
    var Yn = "$",
      Xn = "/$",
      Jn = "$?",
      Zn = "$!",
      er = null,
      tr = null;
    function nr(e, t) {
      switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!t.autoFocus;
      }
      return !1;
    }
    function rr(e, t) {
      return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
    }
    var ir = "function" == typeof setTimeout ? setTimeout : void 0,
      or = "function" == typeof clearTimeout ? clearTimeout : void 0;
    function ar(e) {
      for (; null != e; e = e.nextSibling) {
        var t = e.nodeType;
        if (1 === t || 3 === t) break;
      }
      return e;
    }
    function lr(e) {
      e = e.previousSibling;
      for (var t = 0; e;) {
        if (8 === e.nodeType) {
          var n = e.data;
          if (n === Yn || n === Zn || n === Jn) {
            if (0 === t) return e;
            t--;
          } else n === Xn && t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    var ur = Math.random().toString(36).slice(2),
      cr = "__reactInternalInstance$" + ur,
      sr = "__reactEventHandlers$" + ur,
      dr = "__reactContainere$" + ur;
    function fr(e) {
      var t = e[cr];
      if (t) return t;
      for (var n = e.parentNode; n;) {
        if (t = n[dr] || n[cr]) {
          if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for (e = lr(e); null !== e;) {
            if (n = e[cr]) return n;
            e = lr(e);
          }
          return t;
        }
        n = (e = n).parentNode;
      }
      return null;
    }
    function pr(e) {
      return !(e = e[cr] || e[dr]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
    }
    function mr(e) {
      if (5 === e.tag || 6 === e.tag) return e.stateNode;
      throw Error(a(33));
    }
    function gr(e) {
      return e[sr] || null;
    }
    var vr = null,
      br = null,
      hr = null;
    function yr() {
      if (hr) return hr;
      var e,
        t,
        n = br,
        r = n.length,
        i = "value" in vr ? vr.value : vr.textContent,
        o = i.length;
      for (e = 0; e < r && n[e] === i[e]; e++);
      var a = r - e;
      for (t = 1; t <= a && n[r - t] === i[o - t]; t++);
      return hr = i.slice(e, 1 < t ? 1 - t : void 0);
    }
    var wr = Lt.extend({
        data: null
      }),
      xr = Lt.extend({
        data: null
      }),
      Er = [9, 13, 27, 32],
      Cr = Z && "CompositionEvent" in window,
      Sr = null;
    Z && "documentMode" in document && (Sr = document.documentMode);
    var Tr = Z && "TextEvent" in window && !Sr,
      Or = Z && (!Cr || Sr && 8 < Sr && 11 >= Sr),
      kr = String.fromCharCode(32),
      Pr = {
        beforeInput: {
          phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
          },
          dependencies: ["compositionend", "keypress", "textInput", "paste"]
        },
        compositionEnd: {
          phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
          },
          dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
        },
        compositionStart: {
          phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
          },
          dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
        },
        compositionUpdate: {
          phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
          },
          dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
        }
      },
      Dr = !1;
    function Ir(e, t) {
      switch (e) {
        case "keyup":
          return -1 !== Er.indexOf(t.keyCode);
        case "keydown":
          return 229 !== t.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
          return !0;
        default:
          return !1;
      }
    }
    function Nr(e) {
      return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
    }
    var Rr = !1;
    var _r = {
        eventTypes: Pr,
        extractEvents: function extractEvents(e, t, n, r) {
          var i;
          if (Cr) e: {
            switch (e) {
              case "compositionstart":
                var o = Pr.compositionStart;
                break e;
              case "compositionend":
                o = Pr.compositionEnd;
                break e;
              case "compositionupdate":
                o = Pr.compositionUpdate;
                break e;
            }
            o = void 0;
          } else Rr ? Ir(e, n) && (o = Pr.compositionEnd) : "keydown" === e && 229 === n.keyCode && (o = Pr.compositionStart);
          return o ? (Or && "ko" !== n.locale && (Rr || o !== Pr.compositionStart ? o === Pr.compositionEnd && Rr && (i = yr()) : (br = "value" in (vr = r) ? vr.value : vr.textContent, Rr = !0)), o = wr.getPooled(o, t, n, r), i ? o.data = i : null !== (i = Nr(n)) && (o.data = i), Rt(o), i = o) : i = null, (e = Tr ? function (e, t) {
            switch (e) {
              case "compositionend":
                return Nr(t);
              case "keypress":
                return 32 !== t.which ? null : (Dr = !0, kr);
              case "textInput":
                return (e = t.data) === kr && Dr ? null : e;
              default:
                return null;
            }
          }(e, n) : function (e, t) {
            if (Rr) return "compositionend" === e || !Cr && Ir(e, t) ? (e = yr(), hr = br = vr = null, Rr = !1, e) : null;
            switch (e) {
              case "paste":
                return null;
              case "keypress":
                if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                  if (t.char && 1 < t.char.length) return t.char;
                  if (t.which) return String.fromCharCode(t.which);
                }
                return null;
              case "compositionend":
                return Or && "ko" !== t.locale ? null : t.data;
              default:
                return null;
            }
          }(e, n)) ? ((t = xr.getPooled(Pr.beforeInput, t, n, r)).data = e, Rt(t)) : t = null, null === i ? t : null === t ? i : [i, t];
        }
      },
      Ar = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
      };
    function Lr(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return "input" === t ? !!Ar[e.type] : "textarea" === t;
    }
    var jr = {
      change: {
        phasedRegistrationNames: {
          bubbled: "onChange",
          captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
      }
    };
    function Mr(e, t, n) {
      return (e = Lt.getPooled(jr.change, e, t, n)).type = "change", ie(n), Rt(e), e;
    }
    var Br = null,
      Fr = null;
    function zr(e) {
      I(e);
    }
    function Ur(e) {
      if (Te(mr(e))) return e;
    }
    function Gr(e, t) {
      if ("change" === e) return t;
    }
    var Wr = !1;
    function Hr() {
      Br && (Br.detachEvent("onpropertychange", Vr), Fr = Br = null);
    }
    function Vr(e) {
      if ("value" === e.propertyName && Ur(Fr)) if (e = Mr(Fr, e, Ot(e)), se) I(e);else {
        se = !0;
        try {
          ae(zr, e);
        } finally {
          se = !1, fe();
        }
      }
    }
    function qr(e, t, n) {
      "focus" === e ? (Hr(), Fr = n, (Br = t).attachEvent("onpropertychange", Vr)) : "blur" === e && Hr();
    }
    function $r(e) {
      if ("selectionchange" === e || "keyup" === e || "keydown" === e) return Ur(Fr);
    }
    function Kr(e, t) {
      if ("click" === e) return Ur(t);
    }
    function Qr(e, t) {
      if ("input" === e || "change" === e) return Ur(t);
    }
    Z && (Wr = Rn("input") && (!document.documentMode || 9 < document.documentMode));
    var Yr,
      Xr = {
        eventTypes: jr,
        _isInputEventSupported: Wr,
        extractEvents: function extractEvents(e, t, n, r) {
          var i = t ? mr(t) : window,
            o = i.nodeName && i.nodeName.toLowerCase();
          if ("select" === o || "input" === o && "file" === i.type) var a = Gr;else if (Lr(i)) {
            if (Wr) a = Qr;else {
              a = $r;
              var l = qr;
            }
          } else (o = i.nodeName) && "input" === o.toLowerCase() && ("checkbox" === i.type || "radio" === i.type) && (a = Kr);
          if (a && (a = a(e, t))) return Mr(a, n, r);
          l && l(e, i, t), "blur" === e && (e = i._wrapperState) && e.controlled && "number" === i.type && Ne(i, "number", i.value);
        }
      },
      Jr = {
        mouseEnter: {
          registrationName: "onMouseEnter",
          dependencies: ["mouseout", "mouseover"]
        },
        mouseLeave: {
          registrationName: "onMouseLeave",
          dependencies: ["mouseout", "mouseover"]
        },
        pointerEnter: {
          registrationName: "onPointerEnter",
          dependencies: ["pointerout", "pointerover"]
        },
        pointerLeave: {
          registrationName: "onPointerLeave",
          dependencies: ["pointerout", "pointerover"]
        }
      },
      Zr = {
        eventTypes: Jr,
        extractEvents: function extractEvents(e, t, n, r, i) {
          var o = "mouseover" === e || "pointerover" === e,
            a = "mouseout" === e || "pointerout" === e;
          if (o && 0 == (32 & i) && (n.relatedTarget || n.fromElement) || !a && !o) return null;
          if (i = r.window === r ? r : (i = r.ownerDocument) ? i.defaultView || i.parentWindow : window, a ? (a = t, null !== (t = (t = n.relatedTarget || n.toElement) ? fr(t) : null) && (t !== (o = et(t)) || 5 !== t.tag && 6 !== t.tag) && (t = null)) : a = null, a === t) return null;
          if ("mouseout" === e || "mouseover" === e) var l = en,
            u = Jr.mouseLeave,
            c = Jr.mouseEnter,
            s = "mouse";else "pointerout" !== e && "pointerover" !== e || (l = tn, u = Jr.pointerLeave, c = Jr.pointerEnter, s = "pointer");
          if (e = null == a ? i : mr(a), i = null == t ? i : mr(t), (u = l.getPooled(u, a, n, r)).type = s + "leave", u.target = e, u.relatedTarget = i, (r = l.getPooled(c, t, n, r)).type = s + "enter", r.target = i, r.relatedTarget = e, s = t, (l = a) && s) e: {
            for (e = s, a = 0, t = c = l; t; t = kt(t)) a++;
            for (t = 0, i = e; i; i = kt(i)) t++;
            for (; 0 < a - t;) c = kt(c), a--;
            for (; 0 < t - a;) e = kt(e), t--;
            for (; a--;) {
              if (c === e || c === e.alternate) break e;
              c = kt(c), e = kt(e);
            }
            c = null;
          } else c = null;
          for (e = c, c = []; l && l !== e && (null === (a = l.alternate) || a !== e);) c.push(l), l = kt(l);
          for (l = []; s && s !== e && (null === (a = s.alternate) || a !== e);) l.push(s), s = kt(s);
          for (s = 0; s < c.length; s++) It(c[s], "bubbled", u);
          for (s = l.length; 0 < s--;) It(l[s], "captured", r);
          return n === Yr ? (Yr = null, [u]) : (Yr = n, [u, r]);
        }
      };
    var ei = "function" == typeof Object.is ? Object.is : function (e, t) {
        return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
      },
      ti = Object.prototype.hasOwnProperty;
    function ni(e, t) {
      if (ei(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var n = Object.keys(e),
        r = Object.keys(t);
      if (n.length !== r.length) return !1;
      for (r = 0; r < n.length; r++) if (!ti.call(t, n[r]) || !ei(e[n[r]], t[n[r]])) return !1;
      return !0;
    }
    var ri = Z && "documentMode" in document && 11 >= document.documentMode,
      ii = {
        select: {
          phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
          },
          dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
        }
      },
      oi = null,
      ai = null,
      li = null,
      ui = !1;
    function ci(e, t) {
      var n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
      return ui || null == oi || oi !== Vn(n) ? null : ("selectionStart" in (n = oi) && Qn(n) ? n = {
        start: n.selectionStart,
        end: n.selectionEnd
      } : n = {
        anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
        anchorOffset: n.anchorOffset,
        focusNode: n.focusNode,
        focusOffset: n.focusOffset
      }, li && ni(li, n) ? null : (li = n, (e = Lt.getPooled(ii.select, ai, e, t)).type = "select", e.target = oi, Rt(e), e));
    }
    var si = {
      eventTypes: ii,
      extractEvents: function extractEvents(e, t, n, r) {
        var i,
          o = r.window === r ? r.document : 9 === r.nodeType ? r : r.ownerDocument;
        if (!(i = !o)) {
          e: {
            o = An(o), i = m.onSelect;
            for (var a = 0; a < i.length; a++) if (!o.has(i[a])) {
              o = !1;
              break e;
            }
            o = !0;
          }
          i = !o;
        }
        if (i) return null;
        switch (o = t ? mr(t) : window, e) {
          case "focus":
            (Lr(o) || "true" === o.contentEditable) && (oi = o, ai = t, li = null);
            break;
          case "blur":
            li = ai = oi = null;
            break;
          case "mousedown":
            ui = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            return ui = !1, ci(n, r);
          case "selectionchange":
            if (ri) break;
          case "keydown":
          case "keyup":
            return ci(n, r);
        }
        return null;
      }
    };
    N.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), E = gr, C = pr, S = mr, N.injectEventPluginsByName({
      SimpleEventPlugin: bn,
      EnterLeaveEventPlugin: Zr,
      ChangeEventPlugin: Xr,
      SelectEventPlugin: si,
      BeforeInputEventPlugin: _r
    }), new Set();
    var di = [],
      fi = -1;
    function pi(e) {
      0 > fi || (e.current = di[fi], di[fi] = null, fi--);
    }
    function mi(e, t) {
      di[++fi] = e.current, e.current = t;
    }
    var gi = {},
      vi = {
        current: gi
      },
      bi = {
        current: !1
      },
      hi = gi;
    function yi(e, t) {
      var n = e.type.contextTypes;
      if (!n) return gi;
      var r = e.stateNode;
      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
      var i,
        o = {};
      for (i in n) o[i] = t[i];
      return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = o), o;
    }
    function wi(e) {
      return null != (e = e.childContextTypes);
    }
    function xi(e) {
      pi(bi), pi(vi);
    }
    function Ei(e) {
      pi(bi), pi(vi);
    }
    function Ci(e, t, n) {
      if (vi.current !== gi) throw Error(a(168));
      mi(vi, t), mi(bi, n);
    }
    function Si(e, t, n) {
      var r = e.stateNode;
      if (e = t.childContextTypes, "function" != typeof r.getChildContext) return n;
      for (var o in r = r.getChildContext()) if (!(o in e)) throw Error(a(108, X(t) || "Unknown", o));
      return i({}, n, {}, r);
    }
    function Ti(e) {
      var t = e.stateNode;
      return t = t && t.__reactInternalMemoizedMergedChildContext || gi, hi = vi.current, mi(vi, t), mi(bi, bi.current), !0;
    }
    function Oi(e, t, n) {
      var r = e.stateNode;
      if (!r) throw Error(a(169));
      n ? (t = Si(e, t, hi), r.__reactInternalMemoizedMergedChildContext = t, pi(bi), pi(vi), mi(vi, t)) : pi(bi), mi(bi, n);
    }
    var ki = o.unstable_runWithPriority,
      Pi = o.unstable_scheduleCallback,
      Di = o.unstable_cancelCallback,
      Ii = o.unstable_shouldYield,
      Ni = o.unstable_requestPaint,
      Ri = o.unstable_now,
      _i = o.unstable_getCurrentPriorityLevel,
      Ai = o.unstable_ImmediatePriority,
      Li = o.unstable_UserBlockingPriority,
      ji = o.unstable_NormalPriority,
      Mi = o.unstable_LowPriority,
      Bi = o.unstable_IdlePriority,
      Fi = {},
      zi = void 0 !== Ni ? Ni : function () {},
      Ui = null,
      Gi = null,
      Wi = !1,
      Hi = Ri(),
      Vi = 1e4 > Hi ? Ri : function () {
        return Ri() - Hi;
      };
    function qi() {
      switch (_i()) {
        case Ai:
          return 99;
        case Li:
          return 98;
        case ji:
          return 97;
        case Mi:
          return 96;
        case Bi:
          return 95;
        default:
          throw Error(a(332));
      }
    }
    function $i(e) {
      switch (e) {
        case 99:
          return Ai;
        case 98:
          return Li;
        case 97:
          return ji;
        case 96:
          return Mi;
        case 95:
          return Bi;
        default:
          throw Error(a(332));
      }
    }
    function Ki(e, t) {
      return e = $i(e), ki(e, t);
    }
    function Qi(e, t, n) {
      return e = $i(e), Pi(e, t, n);
    }
    function Yi(e) {
      return null === Ui ? (Ui = [e], Gi = Pi(Ai, Ji)) : Ui.push(e), Fi;
    }
    function Xi() {
      if (null !== Gi) {
        var e = Gi;
        Gi = null, Di(e);
      }
      Ji();
    }
    function Ji() {
      if (!Wi && null !== Ui) {
        Wi = !0;
        var e = 0;
        try {
          var t = Ui;
          Ki(99, function () {
            for (; e < t.length; e++) {
              var n = t[e];
              do {
                n = n(!0);
              } while (null !== n);
            }
          }), Ui = null;
        } catch (t) {
          throw null !== Ui && (Ui = Ui.slice(e + 1)), Pi(Ai, Xi), t;
        } finally {
          Wi = !1;
        }
      }
    }
    var Zi = 3;
    function eo(e, t, n) {
      return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
    }
    function to(e, t) {
      if (e && e.defaultProps) for (var n in t = i({}, t), e = e.defaultProps) void 0 === t[n] && (t[n] = e[n]);
      return t;
    }
    var no = {
        current: null
      },
      ro = null,
      io = null,
      oo = null;
    function ao() {
      oo = io = ro = null;
    }
    function lo(e, t) {
      var n = e.type._context;
      mi(no, n._currentValue), n._currentValue = t;
    }
    function uo(e) {
      var t = no.current;
      pi(no), e.type._context._currentValue = t;
    }
    function co(e, t) {
      for (; null !== e;) {
        var n = e.alternate;
        if (e.childExpirationTime < t) e.childExpirationTime = t, null !== n && n.childExpirationTime < t && (n.childExpirationTime = t);else {
          if (!(null !== n && n.childExpirationTime < t)) break;
          n.childExpirationTime = t;
        }
        e = e.return;
      }
    }
    function so(e, t) {
      ro = e, oo = io = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (Va = !0), e.firstContext = null);
    }
    function fo(e, t) {
      if (oo !== e && !1 !== t && 0 !== t) if ("number" == typeof t && 1073741823 !== t || (oo = e, t = 1073741823), t = {
        context: e,
        observedBits: t,
        next: null
      }, null === io) {
        if (null === ro) throw Error(a(308));
        io = t, ro.dependencies = {
          expirationTime: 0,
          firstContext: t,
          responders: null
        };
      } else io = io.next = t;
      return e._currentValue;
    }
    var po = !1;
    function mo(e) {
      return {
        baseState: e,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }
    function go(e) {
      return {
        baseState: e.baseState,
        firstUpdate: e.firstUpdate,
        lastUpdate: e.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
      };
    }
    function vo(e, t) {
      return {
        expirationTime: e,
        suspenseConfig: t,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
      };
    }
    function bo(e, t) {
      null === e.lastUpdate ? e.firstUpdate = e.lastUpdate = t : (e.lastUpdate.next = t, e.lastUpdate = t);
    }
    function ho(e, t) {
      var n = e.alternate;
      if (null === n) {
        var r = e.updateQueue,
          i = null;
        null === r && (r = e.updateQueue = mo(e.memoizedState));
      } else r = e.updateQueue, i = n.updateQueue, null === r ? null === i ? (r = e.updateQueue = mo(e.memoizedState), i = n.updateQueue = mo(n.memoizedState)) : r = e.updateQueue = go(i) : null === i && (i = n.updateQueue = go(r));
      null === i || r === i ? bo(r, t) : null === r.lastUpdate || null === i.lastUpdate ? (bo(r, t), bo(i, t)) : (bo(r, t), i.lastUpdate = t);
    }
    function yo(e, t) {
      var n = e.updateQueue;
      null === (n = null === n ? e.updateQueue = mo(e.memoizedState) : wo(e, n)).lastCapturedUpdate ? n.firstCapturedUpdate = n.lastCapturedUpdate = t : (n.lastCapturedUpdate.next = t, n.lastCapturedUpdate = t);
    }
    function wo(e, t) {
      var n = e.alternate;
      return null !== n && t === n.updateQueue && (t = e.updateQueue = go(t)), t;
    }
    function xo(e, t, n, r, o, a) {
      switch (n.tag) {
        case 1:
          return "function" == typeof (e = n.payload) ? e.call(a, r, o) : e;
        case 3:
          e.effectTag = -4097 & e.effectTag | 64;
        case 0:
          if (null == (o = "function" == typeof (e = n.payload) ? e.call(a, r, o) : e)) break;
          return i({}, r, o);
        case 2:
          po = !0;
      }
      return r;
    }
    function Eo(e, t, n, r, i) {
      po = !1;
      for (var o = (t = wo(e, t)).baseState, a = null, l = 0, u = t.firstUpdate, c = o; null !== u;) {
        var s = u.expirationTime;
        s < i ? (null === a && (a = u, o = c), l < s && (l = s)) : (ku(s, u.suspenseConfig), c = xo(e, 0, u, c, n, r), null !== u.callback && (e.effectTag |= 32, u.nextEffect = null, null === t.lastEffect ? t.firstEffect = t.lastEffect = u : (t.lastEffect.nextEffect = u, t.lastEffect = u))), u = u.next;
      }
      for (s = null, u = t.firstCapturedUpdate; null !== u;) {
        var d = u.expirationTime;
        d < i ? (null === s && (s = u, null === a && (o = c)), l < d && (l = d)) : (c = xo(e, 0, u, c, n, r), null !== u.callback && (e.effectTag |= 32, u.nextEffect = null, null === t.lastCapturedEffect ? t.firstCapturedEffect = t.lastCapturedEffect = u : (t.lastCapturedEffect.nextEffect = u, t.lastCapturedEffect = u))), u = u.next;
      }
      null === a && (t.lastUpdate = null), null === s ? t.lastCapturedUpdate = null : e.effectTag |= 32, null === a && null === s && (o = c), t.baseState = o, t.firstUpdate = a, t.firstCapturedUpdate = s, Pu(l), e.expirationTime = l, e.memoizedState = c;
    }
    function Co(e, t, n) {
      null !== t.firstCapturedUpdate && (null !== t.lastUpdate && (t.lastUpdate.next = t.firstCapturedUpdate, t.lastUpdate = t.lastCapturedUpdate), t.firstCapturedUpdate = t.lastCapturedUpdate = null), So(t.firstEffect, n), t.firstEffect = t.lastEffect = null, So(t.firstCapturedEffect, n), t.firstCapturedEffect = t.lastCapturedEffect = null;
    }
    function So(e, t) {
      for (; null !== e;) {
        var n = e.callback;
        if (null !== n) {
          e.callback = null;
          var r = t;
          if ("function" != typeof n) throw Error(a(191, n));
          n.call(r);
        }
        e = e.nextEffect;
      }
    }
    var To = _.ReactCurrentBatchConfig,
      Oo = new r.Component().refs;
    function ko(e, t, n, r) {
      n = null == (n = n(r, t = e.memoizedState)) ? t : i({}, t, n), e.memoizedState = n, null !== (r = e.updateQueue) && 0 === e.expirationTime && (r.baseState = n);
    }
    var Po = {
      isMounted: function isMounted(e) {
        return !!(e = e._reactInternalFiber) && et(e) === e;
      },
      enqueueSetState: function enqueueSetState(e, t, n) {
        e = e._reactInternalFiber;
        var r = mu(),
          i = To.suspense;
        (i = vo(r = gu(r, e, i), i)).payload = t, null != n && (i.callback = n), ho(e, i), vu(e, r);
      },
      enqueueReplaceState: function enqueueReplaceState(e, t, n) {
        e = e._reactInternalFiber;
        var r = mu(),
          i = To.suspense;
        (i = vo(r = gu(r, e, i), i)).tag = 1, i.payload = t, null != n && (i.callback = n), ho(e, i), vu(e, r);
      },
      enqueueForceUpdate: function enqueueForceUpdate(e, t) {
        e = e._reactInternalFiber;
        var n = mu(),
          r = To.suspense;
        (r = vo(n = gu(n, e, r), r)).tag = 2, null != t && (r.callback = t), ho(e, r), vu(e, n);
      }
    };
    function Do(e, t, n, r, i, o, a) {
      return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, o, a) : !t.prototype || !t.prototype.isPureReactComponent || !ni(n, r) || !ni(i, o);
    }
    function Io(e, t, n) {
      var r = !1,
        i = gi,
        o = t.contextType;
      return "object" == typeof o && null !== o ? o = fo(o) : (i = wi(t) ? hi : vi.current, o = (r = null != (r = t.contextTypes)) ? yi(e, i) : gi), t = new t(n, o), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Po, e.stateNode = t, t._reactInternalFiber = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = o), t;
    }
    function No(e, t, n, r) {
      e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Po.enqueueReplaceState(t, t.state, null);
    }
    function Ro(e, t, n, r) {
      var i = e.stateNode;
      i.props = n, i.state = e.memoizedState, i.refs = Oo;
      var o = t.contextType;
      "object" == typeof o && null !== o ? i.context = fo(o) : (o = wi(t) ? hi : vi.current, i.context = yi(e, o)), null !== (o = e.updateQueue) && (Eo(e, o, n, i, r), i.state = e.memoizedState), "function" == typeof (o = t.getDerivedStateFromProps) && (ko(e, t, o, n), i.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && Po.enqueueReplaceState(i, i.state, null), null !== (o = e.updateQueue) && (Eo(e, o, n, i, r), i.state = e.memoizedState)), "function" == typeof i.componentDidMount && (e.effectTag |= 4);
    }
    var _o = Array.isArray;
    function Ao(e, t, n) {
      if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
        if (n._owner) {
          if (n = n._owner) {
            if (1 !== n.tag) throw Error(a(309));
            var r = n.stateNode;
          }
          if (!r) throw Error(a(147, e));
          var i = "" + e;
          return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === i ? t.ref : ((t = function t(e) {
            var t = r.refs;
            t === Oo && (t = r.refs = {}), null === e ? delete t[i] : t[i] = e;
          })._stringRef = i, t);
        }
        if ("string" != typeof e) throw Error(a(284));
        if (!n._owner) throw Error(a(290, e));
      }
      return e;
    }
    function Lo(e, t) {
      if ("textarea" !== e.type) throw Error(a(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
    }
    function jo(e) {
      function t(t, n) {
        if (e) {
          var r = t.lastEffect;
          null !== r ? (r.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
        }
      }
      function n(n, r) {
        if (!e) return null;
        for (; null !== r;) t(n, r), r = r.sibling;
        return null;
      }
      function r(e, t) {
        for (e = new Map(); null !== t;) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
        return e;
      }
      function i(e, t, n) {
        return (e = Ku(e, t)).index = 0, e.sibling = null, e;
      }
      function o(t, n, r) {
        return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.effectTag = 2, n) : r : (t.effectTag = 2, n) : n;
      }
      function l(t) {
        return e && null === t.alternate && (t.effectTag = 2), t;
      }
      function u(e, t, n, r) {
        return null === t || 6 !== t.tag ? ((t = Xu(n, e.mode, r)).return = e, t) : ((t = i(t, n)).return = e, t);
      }
      function c(e, t, n, r) {
        return null !== t && t.elementType === n.type ? ((r = i(t, n.props)).ref = Ao(e, t, n), r.return = e, r) : ((r = Qu(n.type, n.key, n.props, null, e.mode, r)).ref = Ao(e, t, n), r.return = e, r);
      }
      function s(e, t, n, r) {
        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Ju(n, e.mode, r)).return = e, t) : ((t = i(t, n.children || [])).return = e, t);
      }
      function d(e, t, n, r, o) {
        return null === t || 7 !== t.tag ? ((t = Yu(n, e.mode, r, o)).return = e, t) : ((t = i(t, n)).return = e, t);
      }
      function f(e, t, n) {
        if ("string" == typeof t || "number" == typeof t) return (t = Xu("" + t, e.mode, n)).return = e, t;
        if ("object" == typeof t && null !== t) {
          switch (t.$$typeof) {
            case j:
              return (n = Qu(t.type, t.key, t.props, null, e.mode, n)).ref = Ao(e, null, t), n.return = e, n;
            case M:
              return (t = Ju(t, e.mode, n)).return = e, t;
          }
          if (_o(t) || Y(t)) return (t = Yu(t, e.mode, n, null)).return = e, t;
          Lo(e, t);
        }
        return null;
      }
      function p(e, t, n, r) {
        var i = null !== t ? t.key : null;
        if ("string" == typeof n || "number" == typeof n) return null !== i ? null : u(e, t, "" + n, r);
        if ("object" == typeof n && null !== n) {
          switch (n.$$typeof) {
            case j:
              return n.key === i ? n.type === B ? d(e, t, n.props.children, r, i) : c(e, t, n, r) : null;
            case M:
              return n.key === i ? s(e, t, n, r) : null;
          }
          if (_o(n) || Y(n)) return null !== i ? null : d(e, t, n, r, null);
          Lo(e, n);
        }
        return null;
      }
      function m(e, t, n, r, i) {
        if ("string" == typeof r || "number" == typeof r) return u(t, e = e.get(n) || null, "" + r, i);
        if ("object" == typeof r && null !== r) {
          switch (r.$$typeof) {
            case j:
              return e = e.get(null === r.key ? n : r.key) || null, r.type === B ? d(t, e, r.props.children, i, r.key) : c(t, e, r, i);
            case M:
              return s(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
          }
          if (_o(r) || Y(r)) return d(t, e = e.get(n) || null, r, i, null);
          Lo(t, r);
        }
        return null;
      }
      function g(i, a, l, u) {
        for (var c = null, s = null, d = a, g = a = 0, v = null; null !== d && g < l.length; g++) {
          d.index > g ? (v = d, d = null) : v = d.sibling;
          var b = p(i, d, l[g], u);
          if (null === b) {
            null === d && (d = v);
            break;
          }
          e && d && null === b.alternate && t(i, d), a = o(b, a, g), null === s ? c = b : s.sibling = b, s = b, d = v;
        }
        if (g === l.length) return n(i, d), c;
        if (null === d) {
          for (; g < l.length; g++) null !== (d = f(i, l[g], u)) && (a = o(d, a, g), null === s ? c = d : s.sibling = d, s = d);
          return c;
        }
        for (d = r(i, d); g < l.length; g++) null !== (v = m(d, i, g, l[g], u)) && (e && null !== v.alternate && d.delete(null === v.key ? g : v.key), a = o(v, a, g), null === s ? c = v : s.sibling = v, s = v);
        return e && d.forEach(function (e) {
          return t(i, e);
        }), c;
      }
      function v(i, l, u, c) {
        var s = Y(u);
        if ("function" != typeof s) throw Error(a(150));
        if (null == (u = s.call(u))) throw Error(a(151));
        for (var d = s = null, g = l, v = l = 0, b = null, h = u.next(); null !== g && !h.done; v++, h = u.next()) {
          g.index > v ? (b = g, g = null) : b = g.sibling;
          var y = p(i, g, h.value, c);
          if (null === y) {
            null === g && (g = b);
            break;
          }
          e && g && null === y.alternate && t(i, g), l = o(y, l, v), null === d ? s = y : d.sibling = y, d = y, g = b;
        }
        if (h.done) return n(i, g), s;
        if (null === g) {
          for (; !h.done; v++, h = u.next()) null !== (h = f(i, h.value, c)) && (l = o(h, l, v), null === d ? s = h : d.sibling = h, d = h);
          return s;
        }
        for (g = r(i, g); !h.done; v++, h = u.next()) null !== (h = m(g, i, v, h.value, c)) && (e && null !== h.alternate && g.delete(null === h.key ? v : h.key), l = o(h, l, v), null === d ? s = h : d.sibling = h, d = h);
        return e && g.forEach(function (e) {
          return t(i, e);
        }), s;
      }
      return function (e, r, o, u) {
        var c = "object" == typeof o && null !== o && o.type === B && null === o.key;
        c && (o = o.props.children);
        var s = "object" == typeof o && null !== o;
        if (s) switch (o.$$typeof) {
          case j:
            e: {
              for (s = o.key, c = r; null !== c;) {
                if (c.key === s) {
                  if (7 === c.tag ? o.type === B : c.elementType === o.type) {
                    n(e, c.sibling), (r = i(c, o.type === B ? o.props.children : o.props)).ref = Ao(e, c, o), r.return = e, e = r;
                    break e;
                  }
                  n(e, c);
                  break;
                }
                t(e, c), c = c.sibling;
              }
              o.type === B ? ((r = Yu(o.props.children, e.mode, u, o.key)).return = e, e = r) : ((u = Qu(o.type, o.key, o.props, null, e.mode, u)).ref = Ao(e, r, o), u.return = e, e = u);
            }
            return l(e);
          case M:
            e: {
              for (c = o.key; null !== r;) {
                if (r.key === c) {
                  if (4 === r.tag && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
                    n(e, r.sibling), (r = i(r, o.children || [])).return = e, e = r;
                    break e;
                  }
                  n(e, r);
                  break;
                }
                t(e, r), r = r.sibling;
              }
              (r = Ju(o, e.mode, u)).return = e, e = r;
            }
            return l(e);
        }
        if ("string" == typeof o || "number" == typeof o) return o = "" + o, null !== r && 6 === r.tag ? (n(e, r.sibling), (r = i(r, o)).return = e, e = r) : (n(e, r), (r = Xu(o, e.mode, u)).return = e, e = r), l(e);
        if (_o(o)) return g(e, r, o, u);
        if (Y(o)) return v(e, r, o, u);
        if (s && Lo(e, o), void 0 === o && !c) switch (e.tag) {
          case 1:
          case 0:
            throw e = e.type, Error(a(152, e.displayName || e.name || "Component"));
        }
        return n(e, r);
      };
    }
    var Mo = jo(!0),
      Bo = jo(!1),
      Fo = {},
      zo = {
        current: Fo
      },
      Uo = {
        current: Fo
      },
      Go = {
        current: Fo
      };
    function Wo(e) {
      if (e === Fo) throw Error(a(174));
      return e;
    }
    function Ho(e, t) {
      mi(Go, t), mi(Uo, e), mi(zo, Fo);
      var n = t.nodeType;
      switch (n) {
        case 9:
        case 11:
          t = (t = t.documentElement) ? t.namespaceURI : ze(null, "");
          break;
        default:
          t = ze(t = (n = 8 === n ? t.parentNode : t).namespaceURI || null, n = n.tagName);
      }
      pi(zo), mi(zo, t);
    }
    function Vo(e) {
      pi(zo), pi(Uo), pi(Go);
    }
    function qo(e) {
      Wo(Go.current);
      var t = Wo(zo.current),
        n = ze(t, e.type);
      t !== n && (mi(Uo, e), mi(zo, n));
    }
    function $o(e) {
      Uo.current === e && (pi(zo), pi(Uo));
    }
    var Ko = {
      current: 0
    };
    function Qo(e) {
      for (var t = e; null !== t;) {
        if (13 === t.tag) {
          var n = t.memoizedState;
          if (null !== n && (null === (n = n.dehydrated) || n.data === Jn || n.data === Zn)) return t;
        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
          if (0 != (64 & t.effectTag)) return t;
        } else if (null !== t.child) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;
        for (; null === t.sibling;) {
          if (null === t.return || t.return === e) return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    function Yo(e, t) {
      return {
        responder: e,
        props: t
      };
    }
    var Xo = _.ReactCurrentDispatcher,
      Jo = _.ReactCurrentBatchConfig,
      Zo = 0,
      ea = null,
      ta = null,
      na = null,
      ra = null,
      ia = null,
      oa = null,
      aa = 0,
      la = null,
      ua = 0,
      ca = !1,
      sa = null,
      da = 0;
    function fa() {
      throw Error(a(321));
    }
    function pa(e, t) {
      if (null === t) return !1;
      for (var n = 0; n < t.length && n < e.length; n++) if (!ei(e[n], t[n])) return !1;
      return !0;
    }
    function ma(e, t, n, r, i, o) {
      if (Zo = o, ea = t, na = null !== e ? e.memoizedState : null, Xo.current = null === na ? _a : Aa, t = n(r, i), ca) {
        do {
          ca = !1, da += 1, na = null !== e ? e.memoizedState : null, oa = ra, la = ia = ta = null, Xo.current = Aa, t = n(r, i);
        } while (ca);
        sa = null, da = 0;
      }
      if (Xo.current = Ra, (e = ea).memoizedState = ra, e.expirationTime = aa, e.updateQueue = la, e.effectTag |= ua, e = null !== ta && null !== ta.next, Zo = 0, oa = ia = ra = na = ta = ea = null, aa = 0, la = null, ua = 0, e) throw Error(a(300));
      return t;
    }
    function ga() {
      Xo.current = Ra, Zo = 0, oa = ia = ra = na = ta = ea = null, aa = 0, la = null, ua = 0, ca = !1, sa = null, da = 0;
    }
    function va() {
      var e = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
      };
      return null === ia ? ra = ia = e : ia = ia.next = e, ia;
    }
    function ba() {
      if (null !== oa) oa = (ia = oa).next, na = null !== (ta = na) ? ta.next : null;else {
        if (null === na) throw Error(a(310));
        var e = {
          memoizedState: (ta = na).memoizedState,
          baseState: ta.baseState,
          queue: ta.queue,
          baseUpdate: ta.baseUpdate,
          next: null
        };
        ia = null === ia ? ra = e : ia.next = e, na = ta.next;
      }
      return ia;
    }
    function ha(e, t) {
      return "function" == typeof t ? t(e) : t;
    }
    function ya(e) {
      var t = ba(),
        n = t.queue;
      if (null === n) throw Error(a(311));
      if (n.lastRenderedReducer = e, 0 < da) {
        var r = n.dispatch;
        if (null !== sa) {
          var i = sa.get(n);
          if (void 0 !== i) {
            sa.delete(n);
            var o = t.memoizedState;
            do {
              o = e(o, i.action), i = i.next;
            } while (null !== i);
            return ei(o, t.memoizedState) || (Va = !0), t.memoizedState = o, t.baseUpdate === n.last && (t.baseState = o), n.lastRenderedState = o, [o, r];
          }
        }
        return [t.memoizedState, r];
      }
      r = n.last;
      var l = t.baseUpdate;
      if (o = t.baseState, null !== l ? (null !== r && (r.next = null), r = l.next) : r = null !== r ? r.next : null, null !== r) {
        var u = i = null,
          c = r,
          s = !1;
        do {
          var d = c.expirationTime;
          d < Zo ? (s || (s = !0, u = l, i = o), d > aa && Pu(aa = d)) : (ku(d, c.suspenseConfig), o = c.eagerReducer === e ? c.eagerState : e(o, c.action)), l = c, c = c.next;
        } while (null !== c && c !== r);
        s || (u = l, i = o), ei(o, t.memoizedState) || (Va = !0), t.memoizedState = o, t.baseUpdate = u, t.baseState = i, n.lastRenderedState = o;
      }
      return [t.memoizedState, n.dispatch];
    }
    function wa(e) {
      var t = va();
      return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
        last: null,
        dispatch: null,
        lastRenderedReducer: ha,
        lastRenderedState: e
      }).dispatch = Na.bind(null, ea, e), [t.memoizedState, e];
    }
    function xa(e) {
      return ya(ha);
    }
    function Ea(e, t, n, r) {
      return e = {
        tag: e,
        create: t,
        destroy: n,
        deps: r,
        next: null
      }, null === la ? (la = {
        lastEffect: null
      }).lastEffect = e.next = e : null === (t = la.lastEffect) ? la.lastEffect = e.next = e : (n = t.next, t.next = e, e.next = n, la.lastEffect = e), e;
    }
    function Ca(e, t, n, r) {
      var i = va();
      ua |= e, i.memoizedState = Ea(t, n, void 0, void 0 === r ? null : r);
    }
    function Sa(e, t, n, r) {
      var i = ba();
      r = void 0 === r ? null : r;
      var o = void 0;
      if (null !== ta) {
        var a = ta.memoizedState;
        if (o = a.destroy, null !== r && pa(r, a.deps)) return void Ea(0, n, o, r);
      }
      ua |= e, i.memoizedState = Ea(t, n, o, r);
    }
    function Ta(e, t) {
      return Ca(516, 192, e, t);
    }
    function Oa(e, t) {
      return Sa(516, 192, e, t);
    }
    function ka(e, t) {
      return "function" == typeof t ? (e = e(), t(e), function () {
        t(null);
      }) : null != t ? (e = e(), t.current = e, function () {
        t.current = null;
      }) : void 0;
    }
    function Pa() {}
    function Da(e, t) {
      return va().memoizedState = [e, void 0 === t ? null : t], e;
    }
    function Ia(e, t) {
      var n = ba();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && pa(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
    }
    function Na(e, t, n) {
      if (!(25 > da)) throw Error(a(301));
      var r = e.alternate;
      if (e === ea || null !== r && r === ea) {
        if (ca = !0, e = {
          expirationTime: Zo,
          suspenseConfig: null,
          action: n,
          eagerReducer: null,
          eagerState: null,
          next: null
        }, null === sa && (sa = new Map()), void 0 === (n = sa.get(t))) sa.set(t, e);else {
          for (t = n; null !== t.next;) t = t.next;
          t.next = e;
        }
      } else {
        var i = mu(),
          o = To.suspense;
        o = {
          expirationTime: i = gu(i, e, o),
          suspenseConfig: o,
          action: n,
          eagerReducer: null,
          eagerState: null,
          next: null
        };
        var l = t.last;
        if (null === l) o.next = o;else {
          var u = l.next;
          null !== u && (o.next = u), l.next = o;
        }
        if (t.last = o, 0 === e.expirationTime && (null === r || 0 === r.expirationTime) && null !== (r = t.lastRenderedReducer)) try {
          var c = t.lastRenderedState,
            s = r(c, n);
          if (o.eagerReducer = r, o.eagerState = s, ei(s, c)) return;
        } catch (e) {}
        vu(e, i);
      }
    }
    var Ra = {
        readContext: fo,
        useCallback: fa,
        useContext: fa,
        useEffect: fa,
        useImperativeHandle: fa,
        useLayoutEffect: fa,
        useMemo: fa,
        useReducer: fa,
        useRef: fa,
        useState: fa,
        useDebugValue: fa,
        useResponder: fa,
        useDeferredValue: fa,
        useTransition: fa
      },
      _a = {
        readContext: fo,
        useCallback: Da,
        useContext: fo,
        useEffect: Ta,
        useImperativeHandle: function useImperativeHandle(e, t, n) {
          return n = null != n ? n.concat([e]) : null, Ca(4, 36, ka.bind(null, t, e), n);
        },
        useLayoutEffect: function useLayoutEffect(e, t) {
          return Ca(4, 36, e, t);
        },
        useMemo: function useMemo(e, t) {
          var n = va();
          return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
        },
        useReducer: function useReducer(e, t, n) {
          var r = va();
          return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = (e = r.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: e,
            lastRenderedState: t
          }).dispatch = Na.bind(null, ea, e), [r.memoizedState, e];
        },
        useRef: function useRef(e) {
          return e = {
            current: e
          }, va().memoizedState = e;
        },
        useState: wa,
        useDebugValue: Pa,
        useResponder: Yo,
        useDeferredValue: function useDeferredValue(e, t) {
          var n = wa(e),
            r = n[0],
            i = n[1];
          return Ta(function () {
            o.unstable_next(function () {
              var n = Jo.suspense;
              Jo.suspense = void 0 === t ? null : t;
              try {
                i(e);
              } finally {
                Jo.suspense = n;
              }
            });
          }, [e, t]), r;
        },
        useTransition: function useTransition(e) {
          var t = wa(!1),
            n = t[0],
            r = t[1];
          return [Da(function (t) {
            r(!0), o.unstable_next(function () {
              var n = Jo.suspense;
              Jo.suspense = void 0 === e ? null : e;
              try {
                r(!1), t();
              } finally {
                Jo.suspense = n;
              }
            });
          }, [e, n]), n];
        }
      },
      Aa = {
        readContext: fo,
        useCallback: Ia,
        useContext: fo,
        useEffect: Oa,
        useImperativeHandle: function useImperativeHandle(e, t, n) {
          return n = null != n ? n.concat([e]) : null, Sa(4, 36, ka.bind(null, t, e), n);
        },
        useLayoutEffect: function useLayoutEffect(e, t) {
          return Sa(4, 36, e, t);
        },
        useMemo: function useMemo(e, t) {
          var n = ba();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && pa(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
        },
        useReducer: ya,
        useRef: function useRef() {
          return ba().memoizedState;
        },
        useState: xa,
        useDebugValue: Pa,
        useResponder: Yo,
        useDeferredValue: function useDeferredValue(e, t) {
          var n = xa(),
            r = n[0],
            i = n[1];
          return Oa(function () {
            o.unstable_next(function () {
              var n = Jo.suspense;
              Jo.suspense = void 0 === t ? null : t;
              try {
                i(e);
              } finally {
                Jo.suspense = n;
              }
            });
          }, [e, t]), r;
        },
        useTransition: function useTransition(e) {
          var t = xa(),
            n = t[0],
            r = t[1];
          return [Ia(function (t) {
            r(!0), o.unstable_next(function () {
              var n = Jo.suspense;
              Jo.suspense = void 0 === e ? null : e;
              try {
                r(!1), t();
              } finally {
                Jo.suspense = n;
              }
            });
          }, [e, n]), n];
        }
      },
      La = null,
      ja = null,
      Ma = !1;
    function Ba(e, t) {
      var n = qu(5, null, null, 0);
      n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
    }
    function Fa(e, t) {
      switch (e.tag) {
        case 5:
          var n = e.type;
          return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);
        case 6:
          return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);
        case 13:
        default:
          return !1;
      }
    }
    function za(e) {
      if (Ma) {
        var t = ja;
        if (t) {
          var n = t;
          if (!Fa(e, t)) {
            if (!(t = ar(n.nextSibling)) || !Fa(e, t)) return e.effectTag = -1025 & e.effectTag | 2, Ma = !1, void (La = e);
            Ba(La, n);
          }
          La = e, ja = ar(t.firstChild);
        } else e.effectTag = -1025 & e.effectTag | 2, Ma = !1, La = e;
      }
    }
    function Ua(e) {
      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;) e = e.return;
      La = e;
    }
    function Ga(e) {
      if (e !== La) return !1;
      if (!Ma) return Ua(e), Ma = !0, !1;
      var t = e.type;
      if (5 !== e.tag || "head" !== t && "body" !== t && !rr(t, e.memoizedProps)) for (t = ja; t;) Ba(e, t), t = ar(t.nextSibling);
      if (Ua(e), 13 === e.tag) {
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(a(317));
        e: {
          for (e = e.nextSibling, t = 0; e;) {
            if (8 === e.nodeType) {
              var n = e.data;
              if (n === Xn) {
                if (0 === t) {
                  ja = ar(e.nextSibling);
                  break e;
                }
                t--;
              } else n !== Yn && n !== Zn && n !== Jn || t++;
            }
            e = e.nextSibling;
          }
          ja = null;
        }
      } else ja = La ? ar(e.stateNode.nextSibling) : null;
      return !0;
    }
    function Wa() {
      ja = La = null, Ma = !1;
    }
    var Ha = _.ReactCurrentOwner,
      Va = !1;
    function qa(e, t, n, r) {
      t.child = null === e ? Bo(t, null, n, r) : Mo(t, e.child, n, r);
    }
    function $a(e, t, n, r, i) {
      n = n.render;
      var o = t.ref;
      return so(t, i), r = ma(e, t, n, r, o, i), null === e || Va ? (t.effectTag |= 1, qa(e, t, r, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), sl(e, t, i));
    }
    function Ka(e, t, n, r, i, o) {
      if (null === e) {
        var a = n.type;
        return "function" != typeof a || $u(a) || void 0 !== a.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = Qu(n.type, null, r, null, t.mode, o)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = a, Qa(e, t, a, r, i, o));
      }
      return a = e.child, i < o && (i = a.memoizedProps, (n = null !== (n = n.compare) ? n : ni)(i, r) && e.ref === t.ref) ? sl(e, t, o) : (t.effectTag |= 1, (e = Ku(a, r)).ref = t.ref, e.return = t, t.child = e);
    }
    function Qa(e, t, n, r, i, o) {
      return null !== e && ni(e.memoizedProps, r) && e.ref === t.ref && (Va = !1, i < o) ? sl(e, t, o) : Xa(e, t, n, r, o);
    }
    function Ya(e, t) {
      var n = t.ref;
      (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
    }
    function Xa(e, t, n, r, i) {
      var o = wi(n) ? hi : vi.current;
      return o = yi(t, o), so(t, i), n = ma(e, t, n, r, o, i), null === e || Va ? (t.effectTag |= 1, qa(e, t, n, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), sl(e, t, i));
    }
    function Ja(e, t, n, r, i) {
      if (wi(n)) {
        var o = !0;
        Ti(t);
      } else o = !1;
      if (so(t, i), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), Io(t, n, r), Ro(t, n, r, i), r = !0;else if (null === e) {
        var a = t.stateNode,
          l = t.memoizedProps;
        a.props = l;
        var u = a.context,
          c = n.contextType;
        "object" == typeof c && null !== c ? c = fo(c) : c = yi(t, c = wi(n) ? hi : vi.current);
        var s = n.getDerivedStateFromProps,
          d = "function" == typeof s || "function" == typeof a.getSnapshotBeforeUpdate;
        d || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (l !== r || u !== c) && No(t, a, r, c), po = !1;
        var f = t.memoizedState;
        u = a.state = f;
        var p = t.updateQueue;
        null !== p && (Eo(t, p, r, a, i), u = t.memoizedState), l !== r || f !== u || bi.current || po ? ("function" == typeof s && (ko(t, n, s, r), u = t.memoizedState), (l = po || Do(t, n, l, r, f, u, c)) ? (d || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), t.memoizedProps = r, t.memoizedState = u), a.props = r, a.state = u, a.context = c, r = l) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), r = !1);
      } else a = t.stateNode, l = t.memoizedProps, a.props = t.type === t.elementType ? l : to(t.type, l), u = a.context, "object" == typeof (c = n.contextType) && null !== c ? c = fo(c) : c = yi(t, c = wi(n) ? hi : vi.current), (d = "function" == typeof (s = n.getDerivedStateFromProps) || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (l !== r || u !== c) && No(t, a, r, c), po = !1, u = t.memoizedState, f = a.state = u, null !== (p = t.updateQueue) && (Eo(t, p, r, a, i), f = t.memoizedState), l !== r || u !== f || bi.current || po ? ("function" == typeof s && (ko(t, n, s, r), f = t.memoizedState), (s = po || Do(t, n, l, r, u, f, c)) ? (d || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, f, c), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, f, c)), "function" == typeof a.componentDidUpdate && (t.effectTag |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof a.componentDidUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = r, t.memoizedState = f), a.props = r, a.state = f, a.context = c, r = s) : ("function" != typeof a.componentDidUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || l === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), r = !1);
      return Za(e, t, n, r, o, i);
    }
    function Za(e, t, n, r, i, o) {
      Ya(e, t);
      var a = 0 != (64 & t.effectTag);
      if (!r && !a) return i && Oi(t, n, !1), sl(e, t, o);
      r = t.stateNode, Ha.current = t;
      var l = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
      return t.effectTag |= 1, null !== e && a ? (t.child = Mo(t, e.child, null, o), t.child = Mo(t, null, l, o)) : qa(e, t, l, o), t.memoizedState = r.state, i && Oi(t, n, !0), t.child;
    }
    function el(e) {
      var t = e.stateNode;
      t.pendingContext ? Ci(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Ci(0, t.context, !1), Ho(e, t.containerInfo);
    }
    var tl,
      nl,
      rl,
      il,
      ol = {
        dehydrated: null,
        retryTime: 0
      };
    function al(e, t, n) {
      var r,
        i = t.mode,
        o = t.pendingProps,
        a = Ko.current,
        l = !1;
      if ((r = 0 != (64 & t.effectTag)) || (r = 0 != (2 & a) && (null === e || null !== e.memoizedState)), r ? (l = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === o.fallback || !0 === o.unstable_avoidThisFallback || (a |= 1), mi(Ko, 1 & a), null === e) {
        if (void 0 !== o.fallback && za(t), l) {
          if (l = o.fallback, (o = Yu(null, i, 0, null)).return = t, 0 == (2 & t.mode)) for (e = null !== t.memoizedState ? t.child.child : t.child, o.child = e; null !== e;) e.return = o, e = e.sibling;
          return (n = Yu(l, i, n, null)).return = t, o.sibling = n, t.memoizedState = ol, t.child = o, n;
        }
        return i = o.children, t.memoizedState = null, t.child = Bo(t, null, i, n);
      }
      if (null !== e.memoizedState) {
        if (i = (e = e.child).sibling, l) {
          if (o = o.fallback, (n = Ku(e, e.pendingProps)).return = t, 0 == (2 & t.mode) && (l = null !== t.memoizedState ? t.child.child : t.child) !== e.child) for (n.child = l; null !== l;) l.return = n, l = l.sibling;
          return (i = Ku(i, o, i.expirationTime)).return = t, n.sibling = i, n.childExpirationTime = 0, t.memoizedState = ol, t.child = n, i;
        }
        return n = Mo(t, e.child, o.children, n), t.memoizedState = null, t.child = n;
      }
      if (e = e.child, l) {
        if (l = o.fallback, (o = Yu(null, i, 0, null)).return = t, o.child = e, null !== e && (e.return = o), 0 == (2 & t.mode)) for (e = null !== t.memoizedState ? t.child.child : t.child, o.child = e; null !== e;) e.return = o, e = e.sibling;
        return (n = Yu(l, i, n, null)).return = t, o.sibling = n, n.effectTag |= 2, o.childExpirationTime = 0, t.memoizedState = ol, t.child = o, n;
      }
      return t.memoizedState = null, t.child = Mo(t, e, o.children, n);
    }
    function ll(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t), co(e.return, t);
    }
    function ul(e, t, n, r, i, o) {
      var a = e.memoizedState;
      null === a ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        last: r,
        tail: n,
        tailExpiration: 0,
        tailMode: i,
        lastEffect: o
      } : (a.isBackwards = t, a.rendering = null, a.last = r, a.tail = n, a.tailExpiration = 0, a.tailMode = i, a.lastEffect = o);
    }
    function cl(e, t, n) {
      var r = t.pendingProps,
        i = r.revealOrder,
        o = r.tail;
      if (qa(e, t, r.children, n), 0 != (2 & (r = Ko.current))) r = 1 & r | 2, t.effectTag |= 64;else {
        if (null !== e && 0 != (64 & e.effectTag)) e: for (e = t.child; null !== e;) {
          if (13 === e.tag) null !== e.memoizedState && ll(e, n);else if (19 === e.tag) ll(e, n);else if (null !== e.child) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === t) break e;
          for (; null === e.sibling;) {
            if (null === e.return || e.return === t) break e;
            e = e.return;
          }
          e.sibling.return = e.return, e = e.sibling;
        }
        r &= 1;
      }
      if (mi(Ko, r), 0 == (2 & t.mode)) t.memoizedState = null;else switch (i) {
        case "forwards":
          for (n = t.child, i = null; null !== n;) null !== (e = n.alternate) && null === Qo(e) && (i = n), n = n.sibling;
          null === (n = i) ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), ul(t, !1, i, n, o, t.lastEffect);
          break;
        case "backwards":
          for (n = null, i = t.child, t.child = null; null !== i;) {
            if (null !== (e = i.alternate) && null === Qo(e)) {
              t.child = i;
              break;
            }
            e = i.sibling, i.sibling = n, n = i, i = e;
          }
          ul(t, !0, n, null, o, t.lastEffect);
          break;
        case "together":
          ul(t, !1, null, null, void 0, t.lastEffect);
          break;
        default:
          t.memoizedState = null;
      }
      return t.child;
    }
    function sl(e, t, n) {
      null !== e && (t.dependencies = e.dependencies);
      var r = t.expirationTime;
      if (0 !== r && Pu(r), t.childExpirationTime < n) return null;
      if (null !== e && t.child !== e.child) throw Error(a(153));
      if (null !== t.child) {
        for (n = Ku(e = t.child, e.pendingProps, e.expirationTime), t.child = n, n.return = t; null !== e.sibling;) e = e.sibling, (n = n.sibling = Ku(e, e.pendingProps, e.expirationTime)).return = t;
        n.sibling = null;
      }
      return t.child;
    }
    function dl(e) {
      e.effectTag |= 4;
    }
    function fl(e, t) {
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var n = null; null !== t;) null !== t.alternate && (n = t), t = t.sibling;
          null === n ? e.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = e.tail;
          for (var r = null; null !== n;) null !== n.alternate && (r = n), n = n.sibling;
          null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
      }
    }
    function pl(e) {
      switch (e.tag) {
        case 1:
          wi(e.type) && xi();
          var t = e.effectTag;
          return 4096 & t ? (e.effectTag = -4097 & t | 64, e) : null;
        case 3:
          if (Vo(), Ei(), 0 != (64 & (t = e.effectTag))) throw Error(a(285));
          return e.effectTag = -4097 & t | 64, e;
        case 5:
          return $o(e), null;
        case 13:
          return pi(Ko), 4096 & (t = e.effectTag) ? (e.effectTag = -4097 & t | 64, e) : null;
        case 19:
          return pi(Ko), null;
        case 4:
          return Vo(), null;
        case 10:
          return uo(e), null;
        default:
          return null;
      }
    }
    function ml(e, t) {
      return {
        value: e,
        source: t,
        stack: J(t)
      };
    }
    tl = function tl(e, t) {
      for (var n = t.child; null !== n;) {
        if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);else if (4 !== n.tag && null !== n.child) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === t) break;
        for (; null === n.sibling;) {
          if (null === n.return || n.return === t) return;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
    }, nl = function nl() {}, rl = function rl(e, t, n, r, o) {
      var a = e.memoizedProps;
      if (a !== r) {
        var l,
          u,
          c = t.stateNode;
        switch (Wo(zo.current), e = null, n) {
          case "input":
            a = Oe(c, a), r = Oe(c, r), e = [];
            break;
          case "option":
            a = Re(c, a), r = Re(c, r), e = [];
            break;
          case "select":
            a = i({}, a, {
              value: void 0
            }), r = i({}, r, {
              value: void 0
            }), e = [];
            break;
          case "textarea":
            a = Ae(c, a), r = Ae(c, r), e = [];
            break;
          default:
            "function" != typeof a.onClick && "function" == typeof r.onClick && (c.onclick = Hn);
        }
        for (l in Un(n, r), n = null, a) if (!r.hasOwnProperty(l) && a.hasOwnProperty(l) && null != a[l]) if ("style" === l) for (u in c = a[l]) c.hasOwnProperty(u) && (n || (n = {}), n[u] = "");else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (p.hasOwnProperty(l) ? e || (e = []) : (e = e || []).push(l, null));
        for (l in r) {
          var s = r[l];
          if (c = null != a ? a[l] : void 0, r.hasOwnProperty(l) && s !== c && (null != s || null != c)) if ("style" === l) {
            if (c) {
              for (u in c) !c.hasOwnProperty(u) || s && s.hasOwnProperty(u) || (n || (n = {}), n[u] = "");
              for (u in s) s.hasOwnProperty(u) && c[u] !== s[u] && (n || (n = {}), n[u] = s[u]);
            } else n || (e || (e = []), e.push(l, n)), n = s;
          } else "dangerouslySetInnerHTML" === l ? (s = s ? s.__html : void 0, c = c ? c.__html : void 0, null != s && c !== s && (e = e || []).push(l, "" + s)) : "children" === l ? c === s || "string" != typeof s && "number" != typeof s || (e = e || []).push(l, "" + s) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (p.hasOwnProperty(l) ? (null != s && Wn(o, l), e || c === s || (e = [])) : (e = e || []).push(l, s));
        }
        n && (e = e || []).push("style", n), o = e, (t.updateQueue = o) && dl(t);
      }
    }, il = function il(e, t, n, r) {
      n !== r && dl(t);
    };
    var gl = "function" == typeof WeakSet ? WeakSet : Set;
    function vl(e, t) {
      var n = t.source,
        r = t.stack;
      null === r && null !== n && (r = J(n)), null !== n && X(n.type), t = t.value, null !== e && 1 === e.tag && X(e.type);
      try {
        console.error(t);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }
    function bl(e) {
      var t = e.ref;
      if (null !== t) if ("function" == typeof t) try {
        t(null);
      } catch (t) {
        zu(e, t);
      } else t.current = null;
    }
    function hl(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          yl(2, 0, t);
          break;
        case 1:
          if (256 & t.effectTag && null !== e) {
            var n = e.memoizedProps,
              r = e.memoizedState;
            t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : to(t.type, n), r), e.__reactInternalSnapshotBeforeUpdate = t;
          }
          break;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(a(163));
      }
    }
    function yl(e, t, n) {
      if (null !== (n = null !== (n = n.updateQueue) ? n.lastEffect : null)) {
        var r = n = n.next;
        do {
          if (0 != (r.tag & e)) {
            var i = r.destroy;
            r.destroy = void 0, void 0 !== i && i();
          }
          0 != (r.tag & t) && (i = r.create, r.destroy = i()), r = r.next;
        } while (r !== n);
      }
    }
    function wl(e, t, n) {
      switch ("function" == typeof Hu && Hu(t), t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
            var r = e.next;
            Ki(97 < n ? 97 : n, function () {
              var e = r;
              do {
                var n = e.destroy;
                if (void 0 !== n) {
                  var i = t;
                  try {
                    n();
                  } catch (e) {
                    zu(i, e);
                  }
                }
                e = e.next;
              } while (e !== r);
            });
          }
          break;
        case 1:
          bl(t), "function" == typeof (n = t.stateNode).componentWillUnmount && function (e, t) {
            try {
              t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
            } catch (t) {
              zu(e, t);
            }
          }(t, n);
          break;
        case 5:
          bl(t);
          break;
        case 4:
          Sl(e, t, n);
      }
    }
    function xl(e) {
      var t = e.alternate;
      e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, null !== t && xl(t);
    }
    function El(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
    }
    function Cl(e) {
      e: {
        for (var t = e.return; null !== t;) {
          if (El(t)) {
            var n = t;
            break e;
          }
          t = t.return;
        }
        throw Error(a(160));
      }
      switch (t = n.stateNode, n.tag) {
        case 5:
          var r = !1;
          break;
        case 3:
        case 4:
          t = t.containerInfo, r = !0;
          break;
        default:
          throw Error(a(161));
      }
      16 & n.effectTag && (We(t, ""), n.effectTag &= -17);
      e: t: for (n = e;;) {
        for (; null === n.sibling;) {
          if (null === n.return || El(n.return)) {
            n = null;
            break e;
          }
          n = n.return;
        }
        for (n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;) {
          if (2 & n.effectTag) continue t;
          if (null === n.child || 4 === n.tag) continue t;
          n.child.return = n, n = n.child;
        }
        if (!(2 & n.effectTag)) {
          n = n.stateNode;
          break e;
        }
      }
      for (var i = e;;) {
        var o = 5 === i.tag || 6 === i.tag;
        if (o) {
          var l = o ? i.stateNode : i.stateNode.instance;
          if (n) {
            if (r) {
              var u = l;
              l = n, 8 === (o = t).nodeType ? o.parentNode.insertBefore(u, l) : o.insertBefore(u, l);
            } else t.insertBefore(l, n);
          } else r ? (8 === (u = t).nodeType ? (o = u.parentNode).insertBefore(l, u) : (o = u).appendChild(l), null != (u = u._reactRootContainer) || null !== o.onclick || (o.onclick = Hn)) : t.appendChild(l);
        } else if (4 !== i.tag && null !== i.child) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === e) break;
        for (; null === i.sibling;) {
          if (null === i.return || i.return === e) return;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    function Sl(e, t, n) {
      for (var r, i, o = t, l = !1;;) {
        if (!l) {
          l = o.return;
          e: for (;;) {
            if (null === l) throw Error(a(160));
            switch (r = l.stateNode, l.tag) {
              case 5:
                i = !1;
                break e;
              case 3:
              case 4:
                r = r.containerInfo, i = !0;
                break e;
            }
            l = l.return;
          }
          l = !0;
        }
        if (5 === o.tag || 6 === o.tag) {
          e: for (var u = e, c = o, s = n, d = c;;) if (wl(u, d, s), null !== d.child && 4 !== d.tag) d.child.return = d, d = d.child;else {
            if (d === c) break;
            for (; null === d.sibling;) {
              if (null === d.return || d.return === c) break e;
              d = d.return;
            }
            d.sibling.return = d.return, d = d.sibling;
          }
          i ? (u = r, c = o.stateNode, 8 === u.nodeType ? u.parentNode.removeChild(c) : u.removeChild(c)) : r.removeChild(o.stateNode);
        } else if (4 === o.tag) {
          if (null !== o.child) {
            r = o.stateNode.containerInfo, i = !0, o.child.return = o, o = o.child;
            continue;
          }
        } else if (wl(e, o, n), null !== o.child) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === t) break;
        for (; null === o.sibling;) {
          if (null === o.return || o.return === t) return;
          4 === (o = o.return).tag && (l = !1);
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    function Tl(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          yl(4, 8, t);
          break;
        case 1:
          break;
        case 5:
          var n = t.stateNode;
          if (null != n) {
            var r = t.memoizedProps,
              i = null !== e ? e.memoizedProps : r;
            e = t.type;
            var o = t.updateQueue;
            if (t.updateQueue = null, null !== o) {
              for (n[sr] = r, "input" === e && "radio" === r.type && null != r.name && Pe(n, r), Gn(e, i), t = Gn(e, r), i = 0; i < o.length; i += 2) {
                var l = o[i],
                  u = o[i + 1];
                "style" === l ? Fn(n, u) : "dangerouslySetInnerHTML" === l ? Ge(n, u) : "children" === l ? We(n, u) : Ee(n, l, u, t);
              }
              switch (e) {
                case "input":
                  De(n, r);
                  break;
                case "textarea":
                  je(n, r);
                  break;
                case "select":
                  t = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!r.multiple, null != (e = r.value) ? _e(n, !!r.multiple, e, !1) : t !== !!r.multiple && (null != r.defaultValue ? _e(n, !!r.multiple, r.defaultValue, !0) : _e(n, !!r.multiple, r.multiple ? [] : "", !1));
              }
            }
          }
          break;
        case 6:
          if (null === t.stateNode) throw Error(a(162));
          t.stateNode.nodeValue = t.memoizedProps;
          break;
        case 3:
          (t = t.stateNode).hydrate && (t.hydrate = !1, Tt(t.containerInfo));
          break;
        case 12:
          break;
        case 13:
          if (n = t, null === t.memoizedState ? r = !1 : (r = !0, n = t.child, tu = Vi()), null !== n) e: for (e = n;;) {
            if (5 === e.tag) o = e.stateNode, r ? "function" == typeof (o = o.style).setProperty ? o.setProperty("display", "none", "important") : o.display = "none" : (o = e.stateNode, i = null != (i = e.memoizedProps.style) && i.hasOwnProperty("display") ? i.display : null, o.style.display = Bn("display", i));else if (6 === e.tag) e.stateNode.nodeValue = r ? "" : e.memoizedProps;else {
              if (13 === e.tag && null !== e.memoizedState && null === e.memoizedState.dehydrated) {
                (o = e.child.sibling).return = e, e = o;
                continue;
              }
              if (null !== e.child) {
                e.child.return = e, e = e.child;
                continue;
              }
            }
            if (e === n) break e;
            for (; null === e.sibling;) {
              if (null === e.return || e.return === n) break e;
              e = e.return;
            }
            e.sibling.return = e.return, e = e.sibling;
          }
          Ol(t);
          break;
        case 19:
          Ol(t);
          break;
        case 17:
        case 20:
        case 21:
          break;
        default:
          throw Error(a(163));
      }
    }
    function Ol(e) {
      var t = e.updateQueue;
      if (null !== t) {
        e.updateQueue = null;
        var n = e.stateNode;
        null === n && (n = e.stateNode = new gl()), t.forEach(function (t) {
          var r = Gu.bind(null, e, t);
          n.has(t) || (n.add(t), t.then(r, r));
        });
      }
    }
    var kl = "function" == typeof WeakMap ? WeakMap : Map;
    function Pl(e, t, n) {
      (n = vo(n, null)).tag = 3, n.payload = {
        element: null
      };
      var r = t.value;
      return n.callback = function () {
        iu || (iu = !0, ou = r), vl(e, t);
      }, n;
    }
    function Dl(e, t, n) {
      (n = vo(n, null)).tag = 3;
      var r = e.type.getDerivedStateFromError;
      if ("function" == typeof r) {
        var i = t.value;
        n.payload = function () {
          return vl(e, t), r(i);
        };
      }
      var o = e.stateNode;
      return null !== o && "function" == typeof o.componentDidCatch && (n.callback = function () {
        "function" != typeof r && (null === au ? au = new Set([this]) : au.add(this), vl(e, t));
        var n = t.stack;
        this.componentDidCatch(t.value, {
          componentStack: null !== n ? n : ""
        });
      }), n;
    }
    var Il,
      Nl = Math.ceil,
      Rl = _.ReactCurrentDispatcher,
      _l = _.ReactCurrentOwner,
      Al = 0,
      Ll = 8,
      jl = 16,
      Ml = 32,
      Bl = 0,
      Fl = 1,
      zl = 2,
      Ul = 3,
      Gl = 4,
      Wl = 5,
      Hl = Al,
      Vl = null,
      ql = null,
      $l = 0,
      Kl = Bl,
      Ql = null,
      Yl = 1073741823,
      Xl = 1073741823,
      Jl = null,
      Zl = 0,
      eu = !1,
      tu = 0,
      nu = 500,
      ru = null,
      iu = !1,
      ou = null,
      au = null,
      lu = !1,
      uu = null,
      cu = 90,
      su = null,
      du = 0,
      fu = null,
      pu = 0;
    function mu() {
      return (Hl & (jl | Ml)) !== Al ? 1073741821 - (Vi() / 10 | 0) : 0 !== pu ? pu : pu = 1073741821 - (Vi() / 10 | 0);
    }
    function gu(e, t, n) {
      if (0 == (2 & (t = t.mode))) return 1073741823;
      var r = qi();
      if (0 == (4 & t)) return 99 === r ? 1073741823 : 1073741822;
      if ((Hl & jl) !== Al) return $l;
      if (null !== n) e = eo(e, 0 | n.timeoutMs || 5e3, 250);else switch (r) {
        case 99:
          e = 1073741823;
          break;
        case 98:
          e = eo(e, 150, 100);
          break;
        case 97:
        case 96:
          e = eo(e, 5e3, 250);
          break;
        case 95:
          e = 2;
          break;
        default:
          throw Error(a(326));
      }
      return null !== Vl && e === $l && --e, e;
    }
    function vu(e, t) {
      if (50 < du) throw du = 0, fu = null, Error(a(185));
      if (null !== (e = bu(e, t))) {
        var n = qi();
        1073741823 === t ? (Hl & Ll) !== Al && (Hl & (jl | Ml)) === Al ? xu(e) : (yu(e), Hl === Al && Xi()) : yu(e), (4 & Hl) === Al || 98 !== n && 99 !== n || (null === su ? su = new Map([[e, t]]) : (void 0 === (n = su.get(e)) || n > t) && su.set(e, t));
      }
    }
    function bu(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t);
      var r = e.return,
        i = null;
      if (null === r && 3 === e.tag) i = e.stateNode;else for (; null !== r;) {
        if (n = r.alternate, r.childExpirationTime < t && (r.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === r.return && 3 === r.tag) {
          i = r.stateNode;
          break;
        }
        r = r.return;
      }
      return null !== i && (Vl === i && (Pu(t), Kl === Gl && tc(i, $l)), nc(i, t)), i;
    }
    function hu(e) {
      var t = e.lastExpiredTime;
      return 0 !== t ? t : ec(e, t = e.firstPendingTime) ? (t = e.lastPingedTime) > (e = e.nextKnownPendingLevel) ? t : e : t;
    }
    function yu(e) {
      if (0 !== e.lastExpiredTime) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = Yi(xu.bind(null, e));else {
        var t = hu(e),
          n = e.callbackNode;
        if (0 === t) null !== n && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);else {
          var r = mu();
          if (1073741823 === t ? r = 99 : 1 === t || 2 === t ? r = 95 : r = 0 >= (r = 10 * (1073741821 - t) - 10 * (1073741821 - r)) ? 99 : 250 >= r ? 98 : 5250 >= r ? 97 : 95, null !== n) {
            var i = e.callbackPriority;
            if (e.callbackExpirationTime === t && i >= r) return;
            n !== Fi && Di(n);
          }
          e.callbackExpirationTime = t, e.callbackPriority = r, t = 1073741823 === t ? Yi(xu.bind(null, e)) : Qi(r, wu.bind(null, e), {
            timeout: 10 * (1073741821 - t) - Vi()
          }), e.callbackNode = t;
        }
      }
    }
    function wu(e, t) {
      if (pu = 0, t) return rc(e, t = mu()), yu(e), null;
      var n = hu(e);
      if (0 !== n) {
        if (t = e.callbackNode, (Hl & (jl | Ml)) !== Al) throw Error(a(327));
        if (Mu(), e === Vl && n === $l || Su(e, n), null !== ql) {
          var r = Hl;
          Hl |= jl;
          for (var i = Ou();;) try {
            Iu();
            break;
          } catch (t) {
            Tu(e, t);
          }
          if (ao(), Hl = r, Rl.current = i, Kl === Fl) throw t = Ql, Su(e, n), tc(e, n), yu(e), t;
          if (null === ql) switch (i = e.finishedWork = e.current.alternate, e.finishedExpirationTime = n, r = Kl, Vl = null, r) {
            case Bl:
            case Fl:
              throw Error(a(345));
            case zl:
              rc(e, 2 < n ? 2 : n);
              break;
            case Ul:
              if (tc(e, n), n === (r = e.lastSuspendedTime) && (e.nextKnownPendingLevel = _u(i)), 1073741823 === Yl && 10 < (i = tu + nu - Vi())) {
                if (eu) {
                  var o = e.lastPingedTime;
                  if (0 === o || o >= n) {
                    e.lastPingedTime = n, Su(e, n);
                    break;
                  }
                }
                if (0 !== (o = hu(e)) && o !== n) break;
                if (0 !== r && r !== n) {
                  e.lastPingedTime = r;
                  break;
                }
                e.timeoutHandle = ir(Au.bind(null, e), i);
                break;
              }
              Au(e);
              break;
            case Gl:
              if (tc(e, n), n === (r = e.lastSuspendedTime) && (e.nextKnownPendingLevel = _u(i)), eu && (0 === (i = e.lastPingedTime) || i >= n)) {
                e.lastPingedTime = n, Su(e, n);
                break;
              }
              if (0 !== (i = hu(e)) && i !== n) break;
              if (0 !== r && r !== n) {
                e.lastPingedTime = r;
                break;
              }
              if (1073741823 !== Xl ? r = 10 * (1073741821 - Xl) - Vi() : 1073741823 === Yl ? r = 0 : (r = 10 * (1073741821 - Yl) - 5e3, 0 > (r = (i = Vi()) - r) && (r = 0), (n = 10 * (1073741821 - n) - i) < (r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * Nl(r / 1960)) - r) && (r = n)), 10 < r) {
                e.timeoutHandle = ir(Au.bind(null, e), r);
                break;
              }
              Au(e);
              break;
            case Wl:
              if (1073741823 !== Yl && null !== Jl) {
                o = Yl;
                var l = Jl;
                if (0 >= (r = 0 | l.busyMinDurationMs) ? r = 0 : (i = 0 | l.busyDelayMs, r = (o = Vi() - (10 * (1073741821 - o) - (0 | l.timeoutMs || 5e3))) <= i ? 0 : i + r - o), 10 < r) {
                  tc(e, n), e.timeoutHandle = ir(Au.bind(null, e), r);
                  break;
                }
              }
              Au(e);
              break;
            default:
              throw Error(a(329));
          }
          if (yu(e), e.callbackNode === t) return wu.bind(null, e);
        }
      }
      return null;
    }
    function xu(e) {
      var t = e.lastExpiredTime;
      if (t = 0 !== t ? t : 1073741823, e.finishedExpirationTime === t) Au(e);else {
        if ((Hl & (jl | Ml)) !== Al) throw Error(a(327));
        if (Mu(), e === Vl && t === $l || Su(e, t), null !== ql) {
          var n = Hl;
          Hl |= jl;
          for (var r = Ou();;) try {
            Du();
            break;
          } catch (t) {
            Tu(e, t);
          }
          if (ao(), Hl = n, Rl.current = r, Kl === Fl) throw n = Ql, Su(e, t), tc(e, t), yu(e), n;
          if (null !== ql) throw Error(a(261));
          e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, Vl = null, Au(e), yu(e);
        }
      }
      return null;
    }
    function Eu(e, t) {
      var n = Hl;
      Hl |= 1;
      try {
        return e(t);
      } finally {
        (Hl = n) === Al && Xi();
      }
    }
    function Cu(e, t) {
      var n = Hl;
      Hl &= -2, Hl |= Ll;
      try {
        return e(t);
      } finally {
        (Hl = n) === Al && Xi();
      }
    }
    function Su(e, t) {
      e.finishedWork = null, e.finishedExpirationTime = 0;
      var n = e.timeoutHandle;
      if (-1 !== n && (e.timeoutHandle = -1, or(n)), null !== ql) for (n = ql.return; null !== n;) {
        var r = n;
        switch (r.tag) {
          case 1:
            var i = r.type.childContextTypes;
            null != i && xi();
            break;
          case 3:
            Vo(), Ei();
            break;
          case 5:
            $o(r);
            break;
          case 4:
            Vo();
            break;
          case 13:
          case 19:
            pi(Ko);
            break;
          case 10:
            uo(r);
        }
        n = n.return;
      }
      Vl = e, ql = Ku(e.current, null), $l = t, Kl = Bl, Ql = null, Xl = Yl = 1073741823, Jl = null, Zl = 0, eu = !1;
    }
    function Tu(e, t) {
      for (;;) {
        try {
          if (ao(), ga(), null === ql || null === ql.return) return Kl = Fl, Ql = t, null;
          e: {
            var n = e,
              r = ql.return,
              i = ql,
              o = t;
            if (t = $l, i.effectTag |= 2048, i.firstEffect = i.lastEffect = null, null !== o && "object" == typeof o && "function" == typeof o.then) {
              var a = o,
                l = 0 != (1 & Ko.current),
                u = r;
              do {
                var c;
                if (c = 13 === u.tag) {
                  var s = u.memoizedState;
                  if (null !== s) c = null !== s.dehydrated;else {
                    var d = u.memoizedProps;
                    c = void 0 !== d.fallback && (!0 !== d.unstable_avoidThisFallback || !l);
                  }
                }
                if (c) {
                  var f = u.updateQueue;
                  if (null === f) {
                    var p = new Set();
                    p.add(a), u.updateQueue = p;
                  } else f.add(a);
                  if (0 == (2 & u.mode)) {
                    if (u.effectTag |= 64, i.effectTag &= -2981, 1 === i.tag) if (null === i.alternate) i.tag = 17;else {
                      var m = vo(1073741823, null);
                      m.tag = 2, ho(i, m);
                    }
                    i.expirationTime = 1073741823;
                    break e;
                  }
                  o = void 0, i = t;
                  var g = n.pingCache;
                  if (null === g ? (g = n.pingCache = new kl(), o = new Set(), g.set(a, o)) : void 0 === (o = g.get(a)) && (o = new Set(), g.set(a, o)), !o.has(i)) {
                    o.add(i);
                    var v = Uu.bind(null, n, a, i);
                    a.then(v, v);
                  }
                  u.effectTag |= 4096, u.expirationTime = t;
                  break e;
                }
                u = u.return;
              } while (null !== u);
              o = Error((X(i.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + J(i));
            }
            Kl !== Wl && (Kl = zl), o = ml(o, i), u = r;
            do {
              switch (u.tag) {
                case 3:
                  a = o, u.effectTag |= 4096, u.expirationTime = t, yo(u, Pl(u, a, t));
                  break e;
                case 1:
                  a = o;
                  var b = u.type,
                    h = u.stateNode;
                  if (0 == (64 & u.effectTag) && ("function" == typeof b.getDerivedStateFromError || null !== h && "function" == typeof h.componentDidCatch && (null === au || !au.has(h)))) {
                    u.effectTag |= 4096, u.expirationTime = t, yo(u, Dl(u, a, t));
                    break e;
                  }
              }
              u = u.return;
            } while (null !== u);
          }
          ql = Ru(ql);
        } catch (e) {
          t = e;
          continue;
        }
        break;
      }
    }
    function Ou() {
      var e = Rl.current;
      return Rl.current = Ra, null === e ? Ra : e;
    }
    function ku(e, t) {
      e < Yl && 2 < e && (Yl = e), null !== t && e < Xl && 2 < e && (Xl = e, Jl = t);
    }
    function Pu(e) {
      e > Zl && (Zl = e);
    }
    function Du() {
      for (; null !== ql;) ql = Nu(ql);
    }
    function Iu() {
      for (; null !== ql && !Ii();) ql = Nu(ql);
    }
    function Nu(e) {
      var t = Il(e.alternate, e, $l);
      return e.memoizedProps = e.pendingProps, null === t && (t = Ru(e)), _l.current = null, t;
    }
    function Ru(e) {
      ql = e;
      do {
        var t = ql.alternate;
        if (e = ql.return, 0 == (2048 & ql.effectTag)) {
          e: {
            var n = t,
              r = $l,
              o = (t = ql).pendingProps;
            switch (t.tag) {
              case 2:
              case 16:
                break;
              case 15:
              case 0:
                break;
              case 1:
                wi(t.type) && xi();
                break;
              case 3:
                Vo(), Ei(), (o = t.stateNode).pendingContext && (o.context = o.pendingContext, o.pendingContext = null), (null === n || null === n.child) && Ga(t) && dl(t), nl(t);
                break;
              case 5:
                $o(t), r = Wo(Go.current);
                var l = t.type;
                if (null !== n && null != t.stateNode) rl(n, t, l, o, r), n.ref !== t.ref && (t.effectTag |= 128);else if (o) {
                  var u = Wo(zo.current);
                  if (Ga(t)) {
                    var c = (o = t).stateNode;
                    n = o.type;
                    var s = o.memoizedProps,
                      d = r;
                    switch (c[cr] = o, c[sr] = s, l = void 0, r = c, n) {
                      case "iframe":
                      case "object":
                      case "embed":
                        Tn("load", r);
                        break;
                      case "video":
                      case "audio":
                        for (c = 0; c < Ze.length; c++) Tn(Ze[c], r);
                        break;
                      case "source":
                        Tn("error", r);
                        break;
                      case "img":
                      case "image":
                      case "link":
                        Tn("error", r), Tn("load", r);
                        break;
                      case "form":
                        Tn("reset", r), Tn("submit", r);
                        break;
                      case "details":
                        Tn("toggle", r);
                        break;
                      case "input":
                        ke(r, s), Tn("invalid", r), Wn(d, "onChange");
                        break;
                      case "select":
                        r._wrapperState = {
                          wasMultiple: !!s.multiple
                        }, Tn("invalid", r), Wn(d, "onChange");
                        break;
                      case "textarea":
                        Le(r, s), Tn("invalid", r), Wn(d, "onChange");
                    }
                    for (l in Un(n, s), c = null, s) s.hasOwnProperty(l) && (u = s[l], "children" === l ? "string" == typeof u ? r.textContent !== u && (c = ["children", u]) : "number" == typeof u && r.textContent !== "" + u && (c = ["children", "" + u]) : p.hasOwnProperty(l) && null != u && Wn(d, l));
                    switch (n) {
                      case "input":
                        Se(r), Ie(r, s, !0);
                        break;
                      case "textarea":
                        Se(r), Me(r);
                        break;
                      case "select":
                      case "option":
                        break;
                      default:
                        "function" == typeof s.onClick && (r.onclick = Hn);
                    }
                    l = c, o.updateQueue = l, (o = null !== l) && dl(t);
                  } else {
                    n = t, d = l, s = o, c = 9 === r.nodeType ? r : r.ownerDocument, u === Be.html && (u = Fe(d)), u === Be.html ? "script" === d ? ((s = c.createElement("div")).innerHTML = "<script><\/script>", c = s.removeChild(s.firstChild)) : "string" == typeof s.is ? c = c.createElement(d, {
                      is: s.is
                    }) : (c = c.createElement(d), "select" === d && (d = c, s.multiple ? d.multiple = !0 : s.size && (d.size = s.size))) : c = c.createElementNS(u, d), (s = c)[cr] = n, s[sr] = o, tl(s, t, !1, !1), t.stateNode = s;
                    var f = r,
                      m = Gn(d = l, n = o);
                    switch (d) {
                      case "iframe":
                      case "object":
                      case "embed":
                        Tn("load", s), r = n;
                        break;
                      case "video":
                      case "audio":
                        for (r = 0; r < Ze.length; r++) Tn(Ze[r], s);
                        r = n;
                        break;
                      case "source":
                        Tn("error", s), r = n;
                        break;
                      case "img":
                      case "image":
                      case "link":
                        Tn("error", s), Tn("load", s), r = n;
                        break;
                      case "form":
                        Tn("reset", s), Tn("submit", s), r = n;
                        break;
                      case "details":
                        Tn("toggle", s), r = n;
                        break;
                      case "input":
                        ke(s, n), r = Oe(s, n), Tn("invalid", s), Wn(f, "onChange");
                        break;
                      case "option":
                        r = Re(s, n);
                        break;
                      case "select":
                        s._wrapperState = {
                          wasMultiple: !!n.multiple
                        }, r = i({}, n, {
                          value: void 0
                        }), Tn("invalid", s), Wn(f, "onChange");
                        break;
                      case "textarea":
                        Le(s, n), r = Ae(s, n), Tn("invalid", s), Wn(f, "onChange");
                        break;
                      default:
                        r = n;
                    }
                    Un(d, r), c = void 0, u = d;
                    var g = s,
                      v = r;
                    for (c in v) if (v.hasOwnProperty(c)) {
                      var b = v[c];
                      "style" === c ? Fn(g, b) : "dangerouslySetInnerHTML" === c ? null != (b = b ? b.__html : void 0) && Ge(g, b) : "children" === c ? "string" == typeof b ? ("textarea" !== u || "" !== b) && We(g, b) : "number" == typeof b && We(g, "" + b) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (p.hasOwnProperty(c) ? null != b && Wn(f, c) : null != b && Ee(g, c, b, m));
                    }
                    switch (d) {
                      case "input":
                        Se(s), Ie(s, n, !1);
                        break;
                      case "textarea":
                        Se(s), Me(s);
                        break;
                      case "option":
                        null != n.value && s.setAttribute("value", "" + xe(n.value));
                        break;
                      case "select":
                        (r = s).multiple = !!n.multiple, null != (s = n.value) ? _e(r, !!n.multiple, s, !1) : null != n.defaultValue && _e(r, !!n.multiple, n.defaultValue, !0);
                        break;
                      default:
                        "function" == typeof r.onClick && (s.onclick = Hn);
                    }
                    (o = nr(l, o)) && dl(t);
                  }
                  null !== t.ref && (t.effectTag |= 128);
                } else if (null === t.stateNode) throw Error(a(166));
                break;
              case 6:
                if (n && null != t.stateNode) il(n, t, n.memoizedProps, o);else {
                  if ("string" != typeof o && null === t.stateNode) throw Error(a(166));
                  r = Wo(Go.current), Wo(zo.current), Ga(t) ? (l = (o = t).stateNode, r = o.memoizedProps, l[cr] = o, (o = l.nodeValue !== r) && dl(t)) : (l = t, (o = (9 === r.nodeType ? r : r.ownerDocument).createTextNode(o))[cr] = l, t.stateNode = o);
                }
                break;
              case 11:
                break;
              case 13:
                if (pi(Ko), o = t.memoizedState, 0 != (64 & t.effectTag)) {
                  t.expirationTime = r;
                  break e;
                }
                o = null !== o, l = !1, null === n ? void 0 !== t.memoizedProps.fallback && Ga(t) : (l = null !== (r = n.memoizedState), o || null === r || null !== (r = n.child.sibling) && (null !== (s = t.firstEffect) ? (t.firstEffect = r, r.nextEffect = s) : (t.firstEffect = t.lastEffect = r, r.nextEffect = null), r.effectTag = 8)), o && !l && 0 != (2 & t.mode) && (null === n && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & Ko.current) ? Kl === Bl && (Kl = Ul) : (Kl !== Bl && Kl !== Ul || (Kl = Gl), 0 !== Zl && null !== Vl && (tc(Vl, $l), nc(Vl, Zl)))), (o || l) && (t.effectTag |= 4);
                break;
              case 7:
              case 8:
              case 12:
                break;
              case 4:
                Vo(), nl(t);
                break;
              case 10:
                uo(t);
                break;
              case 9:
              case 14:
                break;
              case 17:
                wi(t.type) && xi();
                break;
              case 19:
                if (pi(Ko), null === (o = t.memoizedState)) break;
                if (l = 0 != (64 & t.effectTag), null === (s = o.rendering)) {
                  if (l) fl(o, !1);else if (Kl !== Bl || null !== n && 0 != (64 & n.effectTag)) for (n = t.child; null !== n;) {
                    if (null !== (s = Qo(n))) {
                      for (t.effectTag |= 64, fl(o, !1), null !== (l = s.updateQueue) && (t.updateQueue = l, t.effectTag |= 4), null === o.lastEffect && (t.firstEffect = null), t.lastEffect = o.lastEffect, o = r, l = t.child; null !== l;) n = o, (r = l).effectTag &= 2, r.nextEffect = null, r.firstEffect = null, r.lastEffect = null, null === (s = r.alternate) ? (r.childExpirationTime = 0, r.expirationTime = n, r.child = null, r.memoizedProps = null, r.memoizedState = null, r.updateQueue = null, r.dependencies = null) : (r.childExpirationTime = s.childExpirationTime, r.expirationTime = s.expirationTime, r.child = s.child, r.memoizedProps = s.memoizedProps, r.memoizedState = s.memoizedState, r.updateQueue = s.updateQueue, n = s.dependencies, r.dependencies = null === n ? null : {
                        expirationTime: n.expirationTime,
                        firstContext: n.firstContext,
                        responders: n.responders
                      }), l = l.sibling;
                      mi(Ko, 1 & Ko.current | 2), t = t.child;
                      break e;
                    }
                    n = n.sibling;
                  }
                } else {
                  if (!l) if (null !== (n = Qo(s))) {
                    if (t.effectTag |= 64, l = !0, null !== (r = n.updateQueue) && (t.updateQueue = r, t.effectTag |= 4), fl(o, !0), null === o.tail && "hidden" === o.tailMode && !s.alternate) {
                      null !== (t = t.lastEffect = o.lastEffect) && (t.nextEffect = null);
                      break;
                    }
                  } else Vi() > o.tailExpiration && 1 < r && (t.effectTag |= 64, l = !0, fl(o, !1), t.expirationTime = t.childExpirationTime = r - 1);
                  o.isBackwards ? (s.sibling = t.child, t.child = s) : (null !== (r = o.last) ? r.sibling = s : t.child = s, o.last = s);
                }
                if (null !== o.tail) {
                  0 === o.tailExpiration && (o.tailExpiration = Vi() + 500), r = o.tail, o.rendering = r, o.tail = r.sibling, o.lastEffect = t.lastEffect, r.sibling = null, o = Ko.current, mi(Ko, o = l ? 1 & o | 2 : 1 & o), t = r;
                  break e;
                }
                break;
              case 20:
              case 21:
                break;
              default:
                throw Error(a(156, t.tag));
            }
            t = null;
          }
          if (o = ql, 1 === $l || 1 !== o.childExpirationTime) {
            for (l = 0, r = o.child; null !== r;) (n = r.expirationTime) > l && (l = n), (s = r.childExpirationTime) > l && (l = s), r = r.sibling;
            o.childExpirationTime = l;
          }
          if (null !== t) return t;
          null !== e && 0 == (2048 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = ql.firstEffect), null !== ql.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = ql.firstEffect), e.lastEffect = ql.lastEffect), 1 < ql.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = ql : e.firstEffect = ql, e.lastEffect = ql));
        } else {
          if (null !== (t = pl(ql))) return t.effectTag &= 2047, t;
          null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
        }
        if (null !== (t = ql.sibling)) return t;
        ql = e;
      } while (null !== ql);
      return Kl === Bl && (Kl = Wl), null;
    }
    function _u(e) {
      var t = e.expirationTime;
      return t > (e = e.childExpirationTime) ? t : e;
    }
    function Au(e) {
      var t = qi();
      return Ki(99, Lu.bind(null, e, t)), null;
    }
    function Lu(e, t) {
      do {
        Mu();
      } while (null !== uu);
      if ((Hl & (jl | Ml)) !== Al) throw Error(a(327));
      var n = e.finishedWork,
        r = e.finishedExpirationTime;
      if (null === n) return null;
      if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw Error(a(177));
      e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
      var i = _u(n);
      if (e.firstPendingTime = i, r <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : r <= e.firstSuspendedTime && (e.firstSuspendedTime = r - 1), r <= e.lastPingedTime && (e.lastPingedTime = 0), r <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === Vl && (ql = Vl = null, $l = 0), 1 < n.effectTag ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n : i = n.firstEffect, null !== i) {
        var o = Hl;
        Hl |= Ml, _l.current = null, er = Sn;
        var l = Kn();
        if (Qn(l)) {
          if ("selectionStart" in l) var u = {
            start: l.selectionStart,
            end: l.selectionEnd
          };else e: {
            var c = (u = (u = l.ownerDocument) && u.defaultView || window).getSelection && u.getSelection();
            if (c && 0 !== c.rangeCount) {
              u = c.anchorNode;
              var s = c.anchorOffset,
                d = c.focusNode;
              c = c.focusOffset;
              try {
                u.nodeType, d.nodeType;
              } catch (e) {
                u = null;
                break e;
              }
              var f = 0,
                p = -1,
                m = -1,
                g = 0,
                v = 0,
                b = l,
                h = null;
              t: for (;;) {
                for (var y; b !== u || 0 !== s && 3 !== b.nodeType || (p = f + s), b !== d || 0 !== c && 3 !== b.nodeType || (m = f + c), 3 === b.nodeType && (f += b.nodeValue.length), null !== (y = b.firstChild);) h = b, b = y;
                for (;;) {
                  if (b === l) break t;
                  if (h === u && ++g === s && (p = f), h === d && ++v === c && (m = f), null !== (y = b.nextSibling)) break;
                  h = (b = h).parentNode;
                }
                b = y;
              }
              u = -1 === p || -1 === m ? null : {
                start: p,
                end: m
              };
            } else u = null;
          }
          u = u || {
            start: 0,
            end: 0
          };
        } else u = null;
        tr = {
          focusedElem: l,
          selectionRange: u
        }, Sn = !1, ru = i;
        do {
          try {
            ju();
          } catch (e) {
            if (null === ru) throw Error(a(330));
            zu(ru, e), ru = ru.nextEffect;
          }
        } while (null !== ru);
        ru = i;
        do {
          try {
            for (l = e, u = t; null !== ru;) {
              var w = ru.effectTag;
              if (16 & w && We(ru.stateNode, ""), 128 & w) {
                var x = ru.alternate;
                if (null !== x) {
                  var E = x.ref;
                  null !== E && ("function" == typeof E ? E(null) : E.current = null);
                }
              }
              switch (1038 & w) {
                case 2:
                  Cl(ru), ru.effectTag &= -3;
                  break;
                case 6:
                  Cl(ru), ru.effectTag &= -3, Tl(ru.alternate, ru);
                  break;
                case 1024:
                  ru.effectTag &= -1025;
                  break;
                case 1028:
                  ru.effectTag &= -1025, Tl(ru.alternate, ru);
                  break;
                case 4:
                  Tl(ru.alternate, ru);
                  break;
                case 8:
                  Sl(l, s = ru, u), xl(s);
              }
              ru = ru.nextEffect;
            }
          } catch (e) {
            if (null === ru) throw Error(a(330));
            zu(ru, e), ru = ru.nextEffect;
          }
        } while (null !== ru);
        if (E = tr, x = Kn(), w = E.focusedElem, u = E.selectionRange, x !== w && w && w.ownerDocument && function e(t, n) {
          return !(!t || !n) && (t === n || (!t || 3 !== t.nodeType) && (n && 3 === n.nodeType ? e(t, n.parentNode) : "contains" in t ? t.contains(n) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n))));
        }(w.ownerDocument.documentElement, w)) {
          null !== u && Qn(w) && (x = u.start, void 0 === (E = u.end) && (E = x), "selectionStart" in w ? (w.selectionStart = x, w.selectionEnd = Math.min(E, w.value.length)) : (E = (x = w.ownerDocument || document) && x.defaultView || window).getSelection && (E = E.getSelection(), s = w.textContent.length, l = Math.min(u.start, s), u = void 0 === u.end ? l : Math.min(u.end, s), !E.extend && l > u && (s = u, u = l, l = s), s = $n(w, l), d = $n(w, u), s && d && (1 !== E.rangeCount || E.anchorNode !== s.node || E.anchorOffset !== s.offset || E.focusNode !== d.node || E.focusOffset !== d.offset) && ((x = x.createRange()).setStart(s.node, s.offset), E.removeAllRanges(), l > u ? (E.addRange(x), E.extend(d.node, d.offset)) : (x.setEnd(d.node, d.offset), E.addRange(x))))), x = [];
          for (E = w; E = E.parentNode;) 1 === E.nodeType && x.push({
            element: E,
            left: E.scrollLeft,
            top: E.scrollTop
          });
          for ("function" == typeof w.focus && w.focus(), w = 0; w < x.length; w++) (E = x[w]).element.scrollLeft = E.left, E.element.scrollTop = E.top;
        }
        tr = null, Sn = !!er, er = null, e.current = n, ru = i;
        do {
          try {
            for (w = r; null !== ru;) {
              var C = ru.effectTag;
              if (36 & C) {
                var S = ru.alternate;
                switch (E = w, (x = ru).tag) {
                  case 0:
                  case 11:
                  case 15:
                    yl(16, 32, x);
                    break;
                  case 1:
                    var T = x.stateNode;
                    if (4 & x.effectTag) if (null === S) T.componentDidMount();else {
                      var O = x.elementType === x.type ? S.memoizedProps : to(x.type, S.memoizedProps);
                      T.componentDidUpdate(O, S.memoizedState, T.__reactInternalSnapshotBeforeUpdate);
                    }
                    var k = x.updateQueue;
                    null !== k && Co(0, k, T);
                    break;
                  case 3:
                    var P = x.updateQueue;
                    if (null !== P) {
                      if (l = null, null !== x.child) switch (x.child.tag) {
                        case 5:
                          l = x.child.stateNode;
                          break;
                        case 1:
                          l = x.child.stateNode;
                      }
                      Co(0, P, l);
                    }
                    break;
                  case 5:
                    var D = x.stateNode;
                    null === S && 4 & x.effectTag && nr(x.type, x.memoizedProps) && D.focus();
                    break;
                  case 6:
                  case 4:
                  case 12:
                    break;
                  case 13:
                    if (null === x.memoizedState) {
                      var I = x.alternate;
                      if (null !== I) {
                        var N = I.memoizedState;
                        if (null !== N) {
                          var R = N.dehydrated;
                          null !== R && Tt(R);
                        }
                      }
                    }
                    break;
                  case 19:
                  case 17:
                  case 20:
                  case 21:
                    break;
                  default:
                    throw Error(a(163));
                }
              }
              if (128 & C) {
                x = void 0;
                var _ = ru.ref;
                if (null !== _) {
                  var A = ru.stateNode;
                  switch (ru.tag) {
                    case 5:
                      x = A;
                      break;
                    default:
                      x = A;
                  }
                  "function" == typeof _ ? _(x) : _.current = x;
                }
              }
              ru = ru.nextEffect;
            }
          } catch (e) {
            if (null === ru) throw Error(a(330));
            zu(ru, e), ru = ru.nextEffect;
          }
        } while (null !== ru);
        ru = null, zi(), Hl = o;
      } else e.current = n;
      if (lu) lu = !1, uu = e, cu = t;else for (ru = i; null !== ru;) t = ru.nextEffect, ru.nextEffect = null, ru = t;
      if (0 === (t = e.firstPendingTime) && (au = null), 1073741823 === t ? e === fu ? du++ : (du = 0, fu = e) : du = 0, "function" == typeof Wu && Wu(n.stateNode, r), yu(e), iu) throw iu = !1, e = ou, ou = null, e;
      return (Hl & Ll) !== Al ? null : (Xi(), null);
    }
    function ju() {
      for (; null !== ru;) {
        var e = ru.effectTag;
        0 != (256 & e) && hl(ru.alternate, ru), 0 == (512 & e) || lu || (lu = !0, Qi(97, function () {
          return Mu(), null;
        })), ru = ru.nextEffect;
      }
    }
    function Mu() {
      if (90 !== cu) {
        var e = 97 < cu ? 97 : cu;
        return cu = 90, Ki(e, Bu);
      }
    }
    function Bu() {
      if (null === uu) return !1;
      var e = uu;
      if (uu = null, (Hl & (jl | Ml)) !== Al) throw Error(a(331));
      var t = Hl;
      for (Hl |= Ml, e = e.current.firstEffect; null !== e;) {
        try {
          var n = e;
          if (0 != (512 & n.effectTag)) switch (n.tag) {
            case 0:
            case 11:
            case 15:
              yl(128, 0, n), yl(0, 64, n);
          }
        } catch (t) {
          if (null === e) throw Error(a(330));
          zu(e, t);
        }
        n = e.nextEffect, e.nextEffect = null, e = n;
      }
      return Hl = t, Xi(), !0;
    }
    function Fu(e, t, n) {
      ho(e, t = Pl(e, t = ml(n, t), 1073741823)), null !== (e = bu(e, 1073741823)) && yu(e);
    }
    function zu(e, t) {
      if (3 === e.tag) Fu(e, e, t);else for (var n = e.return; null !== n;) {
        if (3 === n.tag) {
          Fu(n, e, t);
          break;
        }
        if (1 === n.tag) {
          var r = n.stateNode;
          if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === au || !au.has(r))) {
            ho(n, e = Dl(n, e = ml(t, e), 1073741823)), null !== (n = bu(n, 1073741823)) && yu(n);
            break;
          }
        }
        n = n.return;
      }
    }
    function Uu(e, t, n) {
      var r = e.pingCache;
      null !== r && r.delete(t), Vl === e && $l === n ? Kl === Gl || Kl === Ul && 1073741823 === Yl && Vi() - tu < nu ? Su(e, $l) : eu = !0 : ec(e, n) && (0 !== (t = e.lastPingedTime) && t < n || (e.lastPingedTime = n, e.finishedExpirationTime === n && (e.finishedExpirationTime = 0, e.finishedWork = null), yu(e)));
    }
    function Gu(e, t) {
      var n = e.stateNode;
      null !== n && n.delete(t), 0 === (t = 0) && (t = gu(t = mu(), e, null)), null !== (e = bu(e, t)) && yu(e);
    }
    Il = function Il(e, t, n) {
      var r = t.expirationTime;
      if (null !== e) {
        var i = t.pendingProps;
        if (e.memoizedProps !== i || bi.current) Va = !0;else {
          if (r < n) {
            switch (Va = !1, t.tag) {
              case 3:
                el(t), Wa();
                break;
              case 5:
                if (qo(t), 4 & t.mode && 1 !== n && i.hidden) return t.expirationTime = t.childExpirationTime = 1, null;
                break;
              case 1:
                wi(t.type) && Ti(t);
                break;
              case 4:
                Ho(t, t.stateNode.containerInfo);
                break;
              case 10:
                lo(t, t.memoizedProps.value);
                break;
              case 13:
                if (null !== t.memoizedState) return 0 !== (r = t.child.childExpirationTime) && r >= n ? al(e, t, n) : (mi(Ko, 1 & Ko.current), null !== (t = sl(e, t, n)) ? t.sibling : null);
                mi(Ko, 1 & Ko.current);
                break;
              case 19:
                if (r = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
                  if (r) return cl(e, t, n);
                  t.effectTag |= 64;
                }
                if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null), mi(Ko, Ko.current), !r) return null;
            }
            return sl(e, t, n);
          }
          Va = !1;
        }
      } else Va = !1;
      switch (t.expirationTime = 0, t.tag) {
        case 2:
          if (r = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, i = yi(t, vi.current), so(t, n), i = ma(null, t, r, e, i, n), t.effectTag |= 1, "object" == typeof i && null !== i && "function" == typeof i.render && void 0 === i.$$typeof) {
            if (t.tag = 1, ga(), wi(r)) {
              var o = !0;
              Ti(t);
            } else o = !1;
            t.memoizedState = null !== i.state && void 0 !== i.state ? i.state : null;
            var l = r.getDerivedStateFromProps;
            "function" == typeof l && ko(t, r, l, e), i.updater = Po, t.stateNode = i, i._reactInternalFiber = t, Ro(t, r, e, n), t = Za(null, t, r, !0, o, n);
          } else t.tag = 0, qa(null, t, i, n), t = t.child;
          return t;
        case 16:
          if (i = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function (e) {
            if (-1 === e._status) {
              e._status = 0;
              var t = e._ctor;
              t = t(), e._result = t, t.then(function (t) {
                0 === e._status && (t = t.default, e._status = 1, e._result = t);
              }, function (t) {
                0 === e._status && (e._status = 2, e._result = t);
              });
            }
          }(i), 1 !== i._status) throw i._result;
          switch (i = i._result, t.type = i, o = t.tag = function (e) {
            if ("function" == typeof e) return $u(e) ? 1 : 0;
            if (null != e) {
              if ((e = e.$$typeof) === H) return 11;
              if (e === $) return 14;
            }
            return 2;
          }(i), e = to(i, e), o) {
            case 0:
              t = Xa(null, t, i, e, n);
              break;
            case 1:
              t = Ja(null, t, i, e, n);
              break;
            case 11:
              t = $a(null, t, i, e, n);
              break;
            case 14:
              t = Ka(null, t, i, to(i.type, e), r, n);
              break;
            default:
              throw Error(a(306, i, ""));
          }
          return t;
        case 0:
          return r = t.type, i = t.pendingProps, Xa(e, t, r, i = t.elementType === r ? i : to(r, i), n);
        case 1:
          return r = t.type, i = t.pendingProps, Ja(e, t, r, i = t.elementType === r ? i : to(r, i), n);
        case 3:
          if (el(t), null === (r = t.updateQueue)) throw Error(a(282));
          if (i = null !== (i = t.memoizedState) ? i.element : null, Eo(t, r, t.pendingProps, null, n), (r = t.memoizedState.element) === i) Wa(), t = sl(e, t, n);else {
            if ((i = t.stateNode.hydrate) && (ja = ar(t.stateNode.containerInfo.firstChild), La = t, i = Ma = !0), i) for (n = Bo(t, null, r, n), t.child = n; n;) n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;else qa(e, t, r, n), Wa();
            t = t.child;
          }
          return t;
        case 5:
          return qo(t), null === e && za(t), r = t.type, i = t.pendingProps, o = null !== e ? e.memoizedProps : null, l = i.children, rr(r, i) ? l = null : null !== o && rr(r, o) && (t.effectTag |= 16), Ya(e, t), 4 & t.mode && 1 !== n && i.hidden ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (qa(e, t, l, n), t = t.child), t;
        case 6:
          return null === e && za(t), null;
        case 13:
          return al(e, t, n);
        case 4:
          return Ho(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = Mo(t, null, r, n) : qa(e, t, r, n), t.child;
        case 11:
          return r = t.type, i = t.pendingProps, $a(e, t, r, i = t.elementType === r ? i : to(r, i), n);
        case 7:
          return qa(e, t, t.pendingProps, n), t.child;
        case 8:
        case 12:
          return qa(e, t, t.pendingProps.children, n), t.child;
        case 10:
          e: {
            if (r = t.type._context, i = t.pendingProps, l = t.memoizedProps, lo(t, o = i.value), null !== l) {
              var u = l.value;
              if (0 === (o = ei(u, o) ? 0 : 0 | ("function" == typeof r._calculateChangedBits ? r._calculateChangedBits(u, o) : 1073741823))) {
                if (l.children === i.children && !bi.current) {
                  t = sl(e, t, n);
                  break e;
                }
              } else for (null !== (u = t.child) && (u.return = t); null !== u;) {
                var c = u.dependencies;
                if (null !== c) {
                  l = u.child;
                  for (var s = c.firstContext; null !== s;) {
                    if (s.context === r && 0 != (s.observedBits & o)) {
                      1 === u.tag && ((s = vo(n, null)).tag = 2, ho(u, s)), u.expirationTime < n && (u.expirationTime = n), null !== (s = u.alternate) && s.expirationTime < n && (s.expirationTime = n), co(u.return, n), c.expirationTime < n && (c.expirationTime = n);
                      break;
                    }
                    s = s.next;
                  }
                } else l = 10 === u.tag && u.type === t.type ? null : u.child;
                if (null !== l) l.return = u;else for (l = u; null !== l;) {
                  if (l === t) {
                    l = null;
                    break;
                  }
                  if (null !== (u = l.sibling)) {
                    u.return = l.return, l = u;
                    break;
                  }
                  l = l.return;
                }
                u = l;
              }
            }
            qa(e, t, i.children, n), t = t.child;
          }
          return t;
        case 9:
          return i = t.type, r = (o = t.pendingProps).children, so(t, n), r = r(i = fo(i, o.unstable_observedBits)), t.effectTag |= 1, qa(e, t, r, n), t.child;
        case 14:
          return o = to(i = t.type, t.pendingProps), Ka(e, t, i, o = to(i.type, o), r, n);
        case 15:
          return Qa(e, t, t.type, t.pendingProps, r, n);
        case 17:
          return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : to(r, i), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, wi(r) ? (e = !0, Ti(t)) : e = !1, so(t, n), Io(t, r, i), Ro(t, r, i, n), Za(null, t, r, !0, e, n);
        case 19:
          return cl(e, t, n);
      }
      throw Error(a(156, t.tag));
    };
    var Wu = null,
      Hu = null;
    function Vu(e, t, n, r) {
      this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
    }
    function qu(e, t, n, r) {
      return new Vu(e, t, n, r);
    }
    function $u(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }
    function Ku(e, t) {
      var n = e.alternate;
      return null === n ? ((n = qu(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
        expirationTime: t.expirationTime,
        firstContext: t.firstContext,
        responders: t.responders
      }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
    }
    function Qu(e, t, n, r, i, o) {
      var l = 2;
      if (r = e, "function" == typeof e) $u(e) && (l = 1);else if ("string" == typeof e) l = 5;else e: switch (e) {
        case B:
          return Yu(n.children, i, o, t);
        case W:
          l = 8, i |= 7;
          break;
        case F:
          l = 8, i |= 1;
          break;
        case z:
          return (e = qu(12, n, t, 8 | i)).elementType = z, e.type = z, e.expirationTime = o, e;
        case V:
          return (e = qu(13, n, t, i)).type = V, e.elementType = V, e.expirationTime = o, e;
        case q:
          return (e = qu(19, n, t, i)).elementType = q, e.expirationTime = o, e;
        default:
          if ("object" == typeof e && null !== e) switch (e.$$typeof) {
            case U:
              l = 10;
              break e;
            case G:
              l = 9;
              break e;
            case H:
              l = 11;
              break e;
            case $:
              l = 14;
              break e;
            case K:
              l = 16, r = null;
              break e;
          }
          throw Error(a(130, null == e ? e : typeof e, ""));
      }
      return (t = qu(l, n, t, i)).elementType = e, t.type = r, t.expirationTime = o, t;
    }
    function Yu(e, t, n, r) {
      return (e = qu(7, e, r, t)).expirationTime = n, e;
    }
    function Xu(e, t, n) {
      return (e = qu(6, e, null, t)).expirationTime = n, e;
    }
    function Ju(e, t, n) {
      return (t = qu(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }
    function Zu(e, t, n) {
      this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }
    function ec(e, t) {
      var n = e.firstSuspendedTime;
      return e = e.lastSuspendedTime, 0 !== n && n >= t && e <= t;
    }
    function tc(e, t) {
      var n = e.firstSuspendedTime,
        r = e.lastSuspendedTime;
      n < t && (e.firstSuspendedTime = t), (r > t || 0 === n) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
    }
    function nc(e, t) {
      t > e.firstPendingTime && (e.firstPendingTime = t);
      var n = e.firstSuspendedTime;
      0 !== n && (t >= n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
    }
    function rc(e, t) {
      var n = e.lastExpiredTime;
      (0 === n || n > t) && (e.lastExpiredTime = t);
    }
    function ic(e, t, n, r) {
      var i = t.current,
        o = mu(),
        l = To.suspense;
      o = gu(o, i, l);
      e: if (n) {
        t: {
          if (et(n = n._reactInternalFiber) !== n || 1 !== n.tag) throw Error(a(170));
          var u = n;
          do {
            switch (u.tag) {
              case 3:
                u = u.stateNode.context;
                break t;
              case 1:
                if (wi(u.type)) {
                  u = u.stateNode.__reactInternalMemoizedMergedChildContext;
                  break t;
                }
            }
            u = u.return;
          } while (null !== u);
          throw Error(a(171));
        }
        if (1 === n.tag) {
          var c = n.type;
          if (wi(c)) {
            n = Si(n, c, u);
            break e;
          }
        }
        n = u;
      } else n = gi;
      return null === t.context ? t.context = n : t.pendingContext = n, (t = vo(o, l)).payload = {
        element: e
      }, null !== (r = void 0 === r ? null : r) && (t.callback = r), ho(i, t), vu(i, o), o;
    }
    function oc(e) {
      if (!(e = e.current).child) return null;
      switch (e.child.tag) {
        case 5:
        default:
          return e.child.stateNode;
      }
    }
    function ac(e, t) {
      null !== (e = e.memoizedState) && null !== e.dehydrated && e.retryTime < t && (e.retryTime = t);
    }
    function lc(e, t) {
      ac(e, t), (e = e.alternate) && ac(e, t);
    }
    function uc(e, t, n) {
      var r = new Zu(e, t, n = null != n && !0 === n.hydrate),
        i = qu(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0);
      r.current = i, i.stateNode = r, e[dr] = r.current, n && 0 !== t && function (e) {
        var t = An(e);
        gt.forEach(function (n) {
          Ln(n, e, t);
        }), vt.forEach(function (n) {
          Ln(n, e, t);
        });
      }(9 === e.nodeType ? e : e.ownerDocument), this._internalRoot = r;
    }
    function cc(e) {
      return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
    }
    function sc(e, t, n, r, i) {
      var o = n._reactRootContainer;
      if (o) {
        var a = o._internalRoot;
        if ("function" == typeof i) {
          var l = i;
          i = function i() {
            var e = oc(a);
            l.call(e);
          };
        }
        ic(t, a, e, i);
      } else {
        if (o = n._reactRootContainer = function (e, t) {
          if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for (var n; n = e.lastChild;) e.removeChild(n);
          return new uc(e, 0, t ? {
            hydrate: !0
          } : void 0);
        }(n, r), a = o._internalRoot, "function" == typeof i) {
          var u = i;
          i = function i() {
            var e = oc(a);
            u.call(e);
          };
        }
        Cu(function () {
          ic(t, a, e, i);
        });
      }
      return oc(a);
    }
    function dc(e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
      if (!cc(t)) throw Error(a(200));
      return function (e, t, n) {
        var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
          $$typeof: M,
          key: null == r ? null : "" + r,
          children: e,
          containerInfo: t,
          implementation: n
        };
      }(e, t, null, n);
    }
    uc.prototype.render = function (e, t) {
      ic(e, this._internalRoot, null, void 0 === t ? null : t);
    }, uc.prototype.unmount = function (e) {
      var t = this._internalRoot,
        n = void 0 === e ? null : e,
        r = t.containerInfo;
      ic(null, t, null, function () {
        r[dr] = null, null !== n && n();
      });
    }, it = function it(e) {
      if (13 === e.tag) {
        var t = eo(mu(), 150, 100);
        vu(e, t), lc(e, t);
      }
    }, ot = function ot(e) {
      if (13 === e.tag) {
        mu();
        var t = Zi++;
        vu(e, t), lc(e, t);
      }
    }, at = function at(e) {
      if (13 === e.tag) {
        var t = mu();
        vu(e, t = gu(t, e, null)), lc(e, t);
      }
    }, ee = function ee(e, t, n) {
      switch (t) {
        case "input":
          if (De(e, n), t = n.name, "radio" === n.type && null != t) {
            for (n = e; n.parentNode;) n = n.parentNode;
            for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
              var r = n[t];
              if (r !== e && r.form === e.form) {
                var i = gr(r);
                if (!i) throw Error(a(90));
                Te(r), De(r, i);
              }
            }
          }
          break;
        case "textarea":
          je(e, n);
          break;
        case "select":
          null != (t = n.value) && _e(e, !!n.multiple, t, !1);
      }
    }, ae = Eu, le = function le(e, t, n, r) {
      var i = Hl;
      Hl |= 4;
      try {
        return Ki(98, e.bind(null, t, n, r));
      } finally {
        (Hl = i) === Al && Xi();
      }
    }, ue = function ue() {
      (Hl & (1 | jl | Ml)) === Al && (function () {
        if (null !== su) {
          var e = su;
          su = null, e.forEach(function (e, t) {
            rc(t, e), yu(t);
          }), Xi();
        }
      }(), Mu());
    }, ce = function ce(e, t) {
      var n = Hl;
      Hl |= 2;
      try {
        return e(t);
      } finally {
        (Hl = n) === Al && Xi();
      }
    };
    var fc,
      pc,
      mc = {
        createPortal: dc,
        findDOMNode: function findDOMNode(e) {
          if (null == e) return null;
          if (1 === e.nodeType) return e;
          var t = e._reactInternalFiber;
          if (void 0 === t) {
            if ("function" == typeof e.render) throw Error(a(188));
            throw Error(a(268, Object.keys(e)));
          }
          return e = null === (e = rt(t)) ? null : e.stateNode;
        },
        hydrate: function hydrate(e, t, n) {
          if (!cc(t)) throw Error(a(200));
          return sc(null, e, t, !0, n);
        },
        render: function render(e, t, n) {
          if (!cc(t)) throw Error(a(200));
          return sc(null, e, t, !1, n);
        },
        unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(e, t, n, r) {
          if (!cc(n)) throw Error(a(200));
          if (null == e || void 0 === e._reactInternalFiber) throw Error(a(38));
          return sc(e, t, n, !1, r);
        },
        unmountComponentAtNode: function unmountComponentAtNode(e) {
          if (!cc(e)) throw Error(a(40));
          return !!e._reactRootContainer && (Cu(function () {
            sc(null, null, e, !1, function () {
              e._reactRootContainer = null, e[dr] = null;
            });
          }), !0);
        },
        unstable_createPortal: function unstable_createPortal() {
          return dc.apply(void 0, arguments);
        },
        unstable_batchedUpdates: Eu,
        flushSync: function flushSync(e, t) {
          if ((Hl & (jl | Ml)) !== Al) throw Error(a(187));
          var n = Hl;
          Hl |= 1;
          try {
            return Ki(99, e.bind(null, t));
          } finally {
            Hl = n, Xi();
          }
        },
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
          Events: [pr, mr, gr, N.injectEventPluginsByName, f, Rt, function (e) {
            k(e, Nt);
          }, ie, oe, In, I, Mu, {
            current: !1
          }]
        }
      };
    pc = (fc = {
      findFiberByHostInstance: fr,
      bundleType: 0,
      version: "16.12.0",
      rendererPackageName: "react-dom"
    }).findFiberByHostInstance, function (e) {
      if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled || !t.supportsFiber) return !0;
      try {
        var n = t.inject(e);
        Wu = function Wu(e) {
          try {
            t.onCommitFiberRoot(n, e, void 0, 64 == (64 & e.current.effectTag));
          } catch (e) {}
        }, Hu = function Hu(e) {
          try {
            t.onCommitFiberUnmount(n, e);
          } catch (e) {}
        };
      } catch (e) {}
    }(i({}, fc, {
      overrideHookState: null,
      overrideProps: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: _.ReactCurrentDispatcher,
      findHostInstanceByFiber: function findHostInstanceByFiber(e) {
        return null === (e = rt(e)) ? null : e.stateNode;
      },
      findFiberByHostInstance: function findFiberByHostInstance(e) {
        return pc ? pc(e) : null;
      },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null
    }));
    var gc = {
        default: mc
      },
      vc = gc && mc || gc;
    e.exports = vc.default || vc;
  }, function (e, t, n) {
    "use strict";

    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var r = Object.getOwnPropertySymbols,
      i = Object.prototype.hasOwnProperty,
      o = Object.prototype.propertyIsEnumerable;
    function a(e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
        for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, l, u = a(e), c = 1; c < arguments.length; c++) {
        for (var s in n = Object(arguments[c])) i.call(n, s) && (u[s] = n[s]);
        if (r) {
          l = r(n);
          for (var d = 0; d < l.length; d++) o.call(n, l[d]) && (u[l[d]] = n[l[d]]);
        }
      }
      return u;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = n(65);
  }, function (e, t, n) {
    "use strict";

    /** @license React v0.18.0
     * scheduler.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var _r2, i, o, a, l;
    if (Object.defineProperty(t, "__esModule", {
      value: !0
    }), "undefined" == typeof window || "function" != typeof MessageChannel) {
      var u = null,
        c = null,
        s = function s() {
          if (null !== u) try {
            var e = t.unstable_now();
            u(!0, e), u = null;
          } catch (e) {
            throw setTimeout(s, 0), e;
          }
        },
        d = Date.now();
      t.unstable_now = function () {
        return Date.now() - d;
      }, _r2 = function r(e) {
        null !== u ? setTimeout(_r2, 0, e) : (u = e, setTimeout(s, 0));
      }, i = function i(e, t) {
        c = setTimeout(e, t);
      }, o = function o() {
        clearTimeout(c);
      }, a = function a() {
        return !1;
      }, l = t.unstable_forceFrameRate = function () {};
    } else {
      var f = window.performance,
        p = window.Date,
        m = window.setTimeout,
        g = window.clearTimeout;
      if ("undefined" != typeof console) {
        var v = window.cancelAnimationFrame;
        "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof v && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
      }
      if ("object" == typeof f && "function" == typeof f.now) t.unstable_now = function () {
        return f.now();
      };else {
        var b = p.now();
        t.unstable_now = function () {
          return p.now() - b;
        };
      }
      var h = !1,
        y = null,
        w = -1,
        x = 5,
        E = 0;
      a = function a() {
        return t.unstable_now() >= E;
      }, l = function l() {}, t.unstable_forceFrameRate = function (e) {
        0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : x = 0 < e ? Math.floor(1e3 / e) : 5;
      };
      var C = new MessageChannel(),
        S = C.port2;
      C.port1.onmessage = function () {
        if (null !== y) {
          var e = t.unstable_now();
          E = e + x;
          try {
            y(!0, e) ? S.postMessage(null) : (h = !1, y = null);
          } catch (e) {
            throw S.postMessage(null), e;
          }
        } else h = !1;
      }, _r2 = function _r2(e) {
        y = e, h || (h = !0, S.postMessage(null));
      }, i = function i(e, n) {
        w = m(function () {
          e(t.unstable_now());
        }, n);
      }, o = function o() {
        g(w), w = -1;
      };
    }
    function T(e, t) {
      var n = e.length;
      e.push(t);
      e: for (;;) {
        var r = Math.floor((n - 1) / 2),
          i = e[r];
        if (!(void 0 !== i && 0 < P(i, t))) break e;
        e[r] = t, e[n] = i, n = r;
      }
    }
    function O(e) {
      return void 0 === (e = e[0]) ? null : e;
    }
    function k(e) {
      var t = e[0];
      if (void 0 !== t) {
        var n = e.pop();
        if (n !== t) {
          e[0] = n;
          e: for (var r = 0, i = e.length; r < i;) {
            var o = 2 * (r + 1) - 1,
              a = e[o],
              l = o + 1,
              u = e[l];
            if (void 0 !== a && 0 > P(a, n)) void 0 !== u && 0 > P(u, a) ? (e[r] = u, e[l] = n, r = l) : (e[r] = a, e[o] = n, r = o);else {
              if (!(void 0 !== u && 0 > P(u, n))) break e;
              e[r] = u, e[l] = n, r = l;
            }
          }
        }
        return t;
      }
      return null;
    }
    function P(e, t) {
      var n = e.sortIndex - t.sortIndex;
      return 0 !== n ? n : e.id - t.id;
    }
    var D = [],
      I = [],
      N = 1,
      R = null,
      _ = 3,
      A = !1,
      L = !1,
      j = !1;
    function M(e) {
      for (var t = O(I); null !== t;) {
        if (null === t.callback) k(I);else {
          if (!(t.startTime <= e)) break;
          k(I), t.sortIndex = t.expirationTime, T(D, t);
        }
        t = O(I);
      }
    }
    function B(e) {
      if (j = !1, M(e), !L) if (null !== O(D)) L = !0, _r2(F);else {
        var t = O(I);
        null !== t && i(B, t.startTime - e);
      }
    }
    function F(e, n) {
      L = !1, j && (j = !1, o()), A = !0;
      var r = _;
      try {
        for (M(n), R = O(D); null !== R && (!(R.expirationTime > n) || e && !a());) {
          var l = R.callback;
          if (null !== l) {
            R.callback = null, _ = R.priorityLevel;
            var u = l(R.expirationTime <= n);
            n = t.unstable_now(), "function" == typeof u ? R.callback = u : R === O(D) && k(D), M(n);
          } else k(D);
          R = O(D);
        }
        if (null !== R) var c = !0;else {
          var s = O(I);
          null !== s && i(B, s.startTime - n), c = !1;
        }
        return c;
      } finally {
        R = null, _ = r, A = !1;
      }
    }
    function z(e) {
      switch (e) {
        case 1:
          return -1;
        case 2:
          return 250;
        case 5:
          return 1073741823;
        case 4:
          return 1e4;
        default:
          return 5e3;
      }
    }
    var U = l;
    t.unstable_ImmediatePriority = 1, t.unstable_UserBlockingPriority = 2, t.unstable_NormalPriority = 3, t.unstable_IdlePriority = 5, t.unstable_LowPriority = 4, t.unstable_runWithPriority = function (e, t) {
      switch (e) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          e = 3;
      }
      var n = _;
      _ = e;
      try {
        return t();
      } finally {
        _ = n;
      }
    }, t.unstable_next = function (e) {
      switch (_) {
        case 1:
        case 2:
        case 3:
          var t = 3;
          break;
        default:
          t = _;
      }
      var n = _;
      _ = t;
      try {
        return e();
      } finally {
        _ = n;
      }
    }, t.unstable_scheduleCallback = function (e, n, a) {
      var l = t.unstable_now();
      if ("object" == typeof a && null !== a) {
        var u = a.delay;
        u = "number" == typeof u && 0 < u ? l + u : l, a = "number" == typeof a.timeout ? a.timeout : z(e);
      } else a = z(e), u = l;
      return e = {
        id: N++,
        callback: n,
        priorityLevel: e,
        startTime: u,
        expirationTime: a = u + a,
        sortIndex: -1
      }, u > l ? (e.sortIndex = u, T(I, e), null === O(D) && e === O(I) && (j ? o() : j = !0, i(B, u - l))) : (e.sortIndex = a, T(D, e), L || A || (L = !0, _r2(F))), e;
    }, t.unstable_cancelCallback = function (e) {
      e.callback = null;
    }, t.unstable_wrapCallback = function (e) {
      var t = _;
      return function () {
        var n = _;
        _ = t;
        try {
          return e.apply(this, arguments);
        } finally {
          _ = n;
        }
      };
    }, t.unstable_getCurrentPriorityLevel = function () {
      return _;
    }, t.unstable_shouldYield = function () {
      var e = t.unstable_now();
      M(e);
      var n = O(D);
      return n !== R && null !== R && null !== n && null !== n.callback && n.startTime <= e && n.expirationTime < R.expirationTime || a();
    }, t.unstable_requestPaint = U, t.unstable_continueExecution = function () {
      L || A || (L = !0, _r2(F));
    }, t.unstable_pauseExecution = function () {}, t.unstable_getFirstCallbackNode = function () {
      return O(D);
    }, t.unstable_Profiling = null;
  }, function (e, t, n) {
    n(67), e.exports = n(2).Object.values;
  }, function (e, t, n) {
    var r = n(5),
      i = n(68)(!1);
    r(r.S, "Object", {
      values: function values(e) {
        return i(e);
      }
    });
  }, function (e, t, n) {
    var r = n(6),
      i = n(12),
      o = n(15),
      a = n(28).f;
    e.exports = function (e) {
      return function (t) {
        for (var n, l = o(t), u = i(l), c = u.length, s = 0, d = []; c > s;) n = u[s++], r && !a.call(l, n) || d.push(e ? [n, l[n]] : l[n]);
        return d;
      };
    };
  }, function (e, t, n) {
    n(70), e.exports = n(2).Object.keys;
  }, function (e, t, n) {
    var r = n(29),
      i = n(12);
    n(71)("keys", function () {
      return function (e) {
        return i(r(e));
      };
    });
  }, function (e, t, n) {
    var r = n(5),
      i = n(2),
      o = n(11);
    e.exports = function (e, t) {
      var n = (i.Object || {})[e] || Object[e],
        a = {};
      a[e] = t(n), r(r.S + r.F * o(function () {
        n(1);
      }), "Object", a);
    };
  }, function (e, t, n) {
    n(73), e.exports = n(2).Date.now;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Date", {
      now: function now() {
        return new Date().getTime();
      }
    });
  }, function (e, t, n) {
    n(75), e.exports = n(2).Number.isInteger;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Number", {
      isInteger: n(76)
    });
  }, function (e, t, n) {
    var r = n(10),
      i = Math.floor;
    e.exports = function (e) {
      return !r(e) && isFinite(e) && i(e) === e;
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
      i = n.n(r),
      o = n(1),
      a = n.n(o);
    function l(e, t) {
      var n = Object(r.useState)(function () {
          return {
            inputs: t,
            result: e()
          };
        })[0],
        i = Object(r.useRef)(n),
        o = Boolean(t && i.current.inputs && function (e, t) {
          if (e.length !== t.length) return !1;
          for (var n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
          return !0;
        }(t, i.current.inputs)) ? i.current : {
          inputs: t,
          result: e()
        };
      return Object(r.useEffect)(function () {
        i.current = o;
      }, [o]), o.result;
    }
    var u = l,
      c = function c(e, t) {
        return l(function () {
          return e;
        }, t);
      },
      s = n(30),
      d = n.n(s);
    function f(e, t) {
      e.prototype = d()(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
    }
    var p = n(7),
      m = n.n(p);
    function g() {
      return (g = m.a || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }).apply(this, arguments);
    }
    var v = n(18),
      b = function b() {
        return Math.random().toString(36).substring(7).split("").join(".");
      },
      h = {
        INIT: "@@redux/INIT" + b(),
        REPLACE: "@@redux/REPLACE" + b(),
        PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
          return "@@redux/PROBE_UNKNOWN_ACTION" + b();
        }
      };
    function y(e) {
      if ("object" != typeof e || null === e) return !1;
      for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
      return Object.getPrototypeOf(e) === t;
    }
    function w(e, t, n) {
      var r;
      if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
      if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
        if ("function" != typeof n) throw new Error("Expected the enhancer to be a function.");
        return n(w)(e, t);
      }
      if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
      var i = e,
        o = t,
        a = [],
        l = a,
        u = !1;
      function c() {
        l === a && (l = a.slice());
      }
      function s() {
        if (u) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return o;
      }
      function d(e) {
        if ("function" != typeof e) throw new Error("Expected the listener to be a function.");
        if (u) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
        var t = !0;
        return c(), l.push(e), function () {
          if (t) {
            if (u) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
            t = !1, c();
            var n = l.indexOf(e);
            l.splice(n, 1);
          }
        };
      }
      function f(e) {
        if (!y(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (u) throw new Error("Reducers may not dispatch actions.");
        try {
          u = !0, o = i(o, e);
        } finally {
          u = !1;
        }
        for (var t = a = l, n = 0; n < t.length; n++) {
          (0, t[n])();
        }
        return e;
      }
      return f({
        type: h.INIT
      }), (r = {
        dispatch: f,
        subscribe: d,
        getState: s,
        replaceReducer: function replaceReducer(e) {
          if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
          i = e, f({
            type: h.REPLACE
          });
        }
      })[v.a] = function () {
        var e,
          t = d;
        return (e = {
          subscribe: function subscribe(e) {
            if ("object" != typeof e || null === e) throw new TypeError("Expected the observer to be an object.");
            function n() {
              e.next && e.next(s());
            }
            return n(), {
              unsubscribe: t(n)
            };
          }
        })[v.a] = function () {
          return this;
        }, e;
      }, r;
    }
    function x(e, t) {
      return function () {
        return t(e.apply(this, arguments));
      };
    }
    function E(e, t) {
      if ("function" == typeof e) return x(e, t);
      if ("object" != typeof e || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : typeof e) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
      var n = {};
      for (var r in e) {
        var i = e[r];
        "function" == typeof i && (n[r] = x(i, t));
      }
      return n;
    }
    function C(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function S(e, t) {
      var n = Object.keys(e);
      return Object.getOwnPropertySymbols && n.push.apply(n, Object.getOwnPropertySymbols(e)), t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n;
    }
    function T(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? S(n, !0).forEach(function (t) {
          C(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S(n).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function O() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
      return 0 === t.length ? function (e) {
        return e;
      } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
        return function () {
          return e(t.apply(void 0, arguments));
        };
      });
    }
    var k = n(4),
      P = n.n(k),
      D = i.a.createContext(null);
    var I = function I(e) {
        e();
      },
      N = function N() {
        return I;
      },
      R = null,
      _ = {
        notify: function notify() {}
      };
    var A = function () {
      function e(e, t) {
        this.store = e, this.parentSub = t, this.unsubscribe = null, this.listeners = _, this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
      }
      var t = e.prototype;
      return t.addNestedSub = function (e) {
        return this.trySubscribe(), this.listeners.subscribe(e);
      }, t.notifyNestedSubs = function () {
        this.listeners.notify();
      }, t.handleChangeWrapper = function () {
        this.onStateChange && this.onStateChange();
      }, t.isSubscribed = function () {
        return Boolean(this.unsubscribe);
      }, t.trySubscribe = function () {
        var e, t, n;
        this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper), this.listeners = (e = N(), t = [], n = [], {
          clear: function clear() {
            n = R, t = R;
          },
          notify: function notify() {
            var r = t = n;
            e(function () {
              for (var e = 0; e < r.length; e++) r[e]();
            });
          },
          get: function get() {
            return n;
          },
          subscribe: function subscribe(e) {
            var r = !0;
            return n === t && (n = t.slice()), n.push(e), function () {
              r && t !== R && (r = !1, n === t && (n = t.slice()), n.splice(n.indexOf(e), 1));
            };
          }
        }));
      }, t.tryUnsubscribe = function () {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = _);
      }, e;
    }();
    function L(e) {
      var t = e.store,
        n = e.context,
        o = e.children,
        a = Object(r.useMemo)(function () {
          var e = new A(t);
          return e.onStateChange = e.notifyNestedSubs, {
            store: t,
            subscription: e
          };
        }, [t]),
        l = Object(r.useMemo)(function () {
          return t.getState();
        }, [t]);
      Object(r.useEffect)(function () {
        var e = a.subscription;
        return e.trySubscribe(), l !== t.getState() && e.notifyNestedSubs(), function () {
          e.tryUnsubscribe(), e.onStateChange = null;
        };
      }, [a, l]);
      var u = n || D;
      return i.a.createElement(u.Provider, {
        value: a
      }, o);
    }
    L.propTypes = {
      store: P.a.shape({
        subscribe: P.a.func.isRequired,
        dispatch: P.a.func.isRequired,
        getState: P.a.func.isRequired
      }),
      context: P.a.object,
      children: P.a.any
    };
    var j = L;
    function M() {
      return (M = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }).apply(this, arguments);
    }
    function B(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    var F = n(17),
      z = n.n(F),
      U = n(3),
      G = n.n(U),
      W = n(16),
      H = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? r.useLayoutEffect : r.useEffect,
      V = [],
      q = [null, null];
    function $(e, t) {
      var n = e[1];
      return [t.payload, n + 1];
    }
    var K = function K() {
      return [null, 0];
    };
    function Q(e, t) {
      void 0 === t && (t = {});
      var n = t,
        o = n.getDisplayName,
        a = void 0 === o ? function (e) {
          return "ConnectAdvanced(" + e + ")";
        } : o,
        l = n.methodName,
        u = void 0 === l ? "connectAdvanced" : l,
        c = n.renderCountProp,
        s = void 0 === c ? void 0 : c,
        d = n.shouldHandleStateChanges,
        f = void 0 === d || d,
        p = n.storeKey,
        m = void 0 === p ? "store" : p,
        g = n.withRef,
        v = void 0 !== g && g,
        b = n.forwardRef,
        h = void 0 !== b && b,
        y = n.context,
        w = void 0 === y ? D : y,
        x = B(n, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
      G()(void 0 === s, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension"), G()(!v, "withRef is removed. To access the wrapped instance, use a ref on the connected component");
      G()("store" === m, "storeKey has been removed and does not do anything. To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect");
      var E = w;
      return function (t) {
        var n = t.displayName || t.name || "Component",
          o = a(n),
          l = M({}, x, {
            getDisplayName: a,
            methodName: u,
            renderCountProp: s,
            shouldHandleStateChanges: f,
            storeKey: m,
            displayName: o,
            wrappedComponentName: n,
            WrappedComponent: t
          }),
          c = x.pure;
        var d = c ? r.useMemo : function (e) {
          return e();
        };
        function p(n) {
          var a = Object(r.useMemo)(function () {
              var e = n.forwardedRef,
                t = B(n, ["forwardedRef"]);
              return [n.context, e, t];
            }, [n]),
            u = a[0],
            c = a[1],
            s = a[2],
            p = Object(r.useMemo)(function () {
              return u && u.Consumer && Object(W.isContextConsumer)(i.a.createElement(u.Consumer, null)) ? u : E;
            }, [u, E]),
            m = Object(r.useContext)(p),
            g = Boolean(n.store) && Boolean(n.store.getState) && Boolean(n.store.dispatch),
            v = Boolean(m) && Boolean(m.store);
          G()(g || v, 'Could not find "store" in the context of "' + o + '". Either wrap the root component in a <Provider>, or pass a custom React context provider to <Provider> and the corresponding React context consumer to ' + o + " in connect options.");
          var b = g ? n.store : m.store,
            h = Object(r.useMemo)(function () {
              return function (t) {
                return e(t.dispatch, l);
              }(b);
            }, [b]),
            y = Object(r.useMemo)(function () {
              if (!f) return q;
              var e = new A(b, g ? null : m.subscription),
                t = e.notifyNestedSubs.bind(e);
              return [e, t];
            }, [b, g, m]),
            w = y[0],
            x = y[1],
            C = Object(r.useMemo)(function () {
              return g ? m : M({}, m, {
                subscription: w
              });
            }, [g, m, w]),
            S = Object(r.useReducer)($, V, K),
            T = S[0][0],
            O = S[1];
          if (T && T.error) throw T.error;
          var k = Object(r.useRef)(),
            P = Object(r.useRef)(s),
            D = Object(r.useRef)(),
            I = Object(r.useRef)(!1),
            N = d(function () {
              return D.current && s === P.current ? D.current : h(b.getState(), s);
            }, [b, T, s]);
          H(function () {
            P.current = s, k.current = N, I.current = !1, D.current && (D.current = null, x());
          }), H(function () {
            if (f) {
              var e = !1,
                t = null,
                n = function n() {
                  if (!e) {
                    var n,
                      r,
                      i = b.getState();
                    try {
                      n = h(i, P.current);
                    } catch (e) {
                      r = e, t = e;
                    }
                    r || (t = null), n === k.current ? I.current || x() : (k.current = n, D.current = n, I.current = !0, O({
                      type: "STORE_UPDATED",
                      payload: {
                        error: r
                      }
                    }));
                  }
                };
              w.onStateChange = n, w.trySubscribe(), n();
              return function () {
                if (e = !0, w.tryUnsubscribe(), w.onStateChange = null, t) throw t;
              };
            }
          }, [b, w, h]);
          var R = Object(r.useMemo)(function () {
            return i.a.createElement(t, M({}, N, {
              ref: c
            }));
          }, [c, t, N]);
          return Object(r.useMemo)(function () {
            return f ? i.a.createElement(p.Provider, {
              value: C
            }, R) : R;
          }, [p, R, C]);
        }
        var g = c ? i.a.memo(p) : p;
        if (g.WrappedComponent = t, g.displayName = o, h) {
          var v = i.a.forwardRef(function (e, t) {
            return i.a.createElement(g, M({}, e, {
              forwardedRef: t
            }));
          });
          return v.displayName = o, v.WrappedComponent = t, z()(v, t);
        }
        return z()(g, t);
      };
    }
    var Y = Object.prototype.hasOwnProperty;
    function X(e, t) {
      return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
    }
    function J(e, t) {
      if (X(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var n = Object.keys(e),
        r = Object.keys(t);
      if (n.length !== r.length) return !1;
      for (var i = 0; i < n.length; i++) if (!Y.call(t, n[i]) || !X(e[n[i]], t[n[i]])) return !1;
      return !0;
    }
    function Z(e) {
      return function (t, n) {
        var r = e(t, n);
        function i() {
          return r;
        }
        return i.dependsOnOwnProps = !1, i;
      };
    }
    function ee(e) {
      return null !== e.dependsOnOwnProps && void 0 !== e.dependsOnOwnProps ? Boolean(e.dependsOnOwnProps) : 1 !== e.length;
    }
    function te(e, t) {
      return function (t, n) {
        n.displayName;
        var r = function r(e, t) {
          return r.dependsOnOwnProps ? r.mapToProps(e, t) : r.mapToProps(e);
        };
        return r.dependsOnOwnProps = !0, r.mapToProps = function (t, n) {
          r.mapToProps = e, r.dependsOnOwnProps = ee(e);
          var i = r(t, n);
          return "function" == typeof i && (r.mapToProps = i, r.dependsOnOwnProps = ee(i), i = r(t, n)), i;
        }, r;
      };
    }
    var ne = [function (e) {
      return "function" == typeof e ? te(e) : void 0;
    }, function (e) {
      return e ? void 0 : Z(function (e) {
        return {
          dispatch: e
        };
      });
    }, function (e) {
      return e && "object" == typeof e ? Z(function (t) {
        return E(e, t);
      }) : void 0;
    }];
    var re = [function (e) {
      return "function" == typeof e ? te(e) : void 0;
    }, function (e) {
      return e ? void 0 : Z(function () {
        return {};
      });
    }];
    function ie(e, t, n) {
      return M({}, n, {}, e, {}, t);
    }
    var oe = [function (e) {
      return "function" == typeof e ? function (e) {
        return function (t, n) {
          n.displayName;
          var r,
            i = n.pure,
            o = n.areMergedPropsEqual,
            a = !1;
          return function (t, n, l) {
            var u = e(t, n, l);
            return a ? i && o(u, r) || (r = u) : (a = !0, r = u), r;
          };
        };
      }(e) : void 0;
    }, function (e) {
      return e ? void 0 : function () {
        return ie;
      };
    }];
    function ae(e, t, n, r) {
      return function (i, o) {
        return n(e(i, o), t(r, o), o);
      };
    }
    function le(e, t, n, r, i) {
      var o,
        a,
        l,
        u,
        c,
        s = i.areStatesEqual,
        d = i.areOwnPropsEqual,
        f = i.areStatePropsEqual,
        p = !1;
      function m(i, p) {
        var m,
          g,
          v = !d(p, a),
          b = !s(i, o);
        return o = i, a = p, v && b ? (l = e(o, a), t.dependsOnOwnProps && (u = t(r, a)), c = n(l, u, a)) : v ? (e.dependsOnOwnProps && (l = e(o, a)), t.dependsOnOwnProps && (u = t(r, a)), c = n(l, u, a)) : b ? (m = e(o, a), g = !f(m, l), l = m, g && (c = n(l, u, a)), c) : c;
      }
      return function (i, s) {
        return p ? m(i, s) : (l = e(o = i, a = s), u = t(r, a), c = n(l, u, a), p = !0, c);
      };
    }
    function ue(e, t) {
      var n = t.initMapStateToProps,
        r = t.initMapDispatchToProps,
        i = t.initMergeProps,
        o = B(t, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]),
        a = n(e, o),
        l = r(e, o),
        u = i(e, o);
      return (o.pure ? le : ae)(a, l, u, e, o);
    }
    function ce(e, t, n) {
      for (var r = t.length - 1; r >= 0; r--) {
        var i = t[r](e);
        if (i) return i;
      }
      return function (t, r) {
        throw new Error("Invalid value of type " + typeof e + " for " + n + " argument when connecting component " + r.wrappedComponentName + ".");
      };
    }
    function se(e, t) {
      return e === t;
    }
    var de,
      fe,
      pe,
      me,
      ge,
      ve,
      be,
      he,
      ye,
      we,
      xe,
      Ee,
      Ce = (pe = (fe = void 0 === de ? {} : de).connectHOC, me = void 0 === pe ? Q : pe, ge = fe.mapStateToPropsFactories, ve = void 0 === ge ? re : ge, be = fe.mapDispatchToPropsFactories, he = void 0 === be ? ne : be, ye = fe.mergePropsFactories, we = void 0 === ye ? oe : ye, xe = fe.selectorFactory, Ee = void 0 === xe ? ue : xe, function (e, t, n, r) {
        void 0 === r && (r = {});
        var i = r,
          o = i.pure,
          a = void 0 === o || o,
          l = i.areStatesEqual,
          u = void 0 === l ? se : l,
          c = i.areOwnPropsEqual,
          s = void 0 === c ? J : c,
          d = i.areStatePropsEqual,
          f = void 0 === d ? J : d,
          p = i.areMergedPropsEqual,
          m = void 0 === p ? J : p,
          g = B(i, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]),
          v = ce(e, ve, "mapStateToProps"),
          b = ce(t, he, "mapDispatchToProps"),
          h = ce(n, we, "mergeProps");
        return me(Ee, M({
          methodName: "connect",
          getDisplayName: function getDisplayName(e) {
            return "Connect(" + e + ")";
          },
          shouldHandleStateChanges: Boolean(e),
          initMapStateToProps: v,
          initMapDispatchToProps: b,
          initMergeProps: h,
          pure: a,
          areStatesEqual: u,
          areOwnPropsEqual: s,
          areStatePropsEqual: f,
          areMergedPropsEqual: m
        }, g));
      });
    function Se() {
      var e = Object(r.useContext)(D);
      return G()(e, "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"), e;
    }
    function Te(e) {
      void 0 === e && (e = D);
      var t = e === D ? Se : function () {
        return Object(r.useContext)(e);
      };
      return function () {
        return t().store;
      };
    }
    var Oe = Te();
    !function (e) {
      void 0 === e && (e = D);
      var t = e === D ? Oe : Te(e);
    }();
    var ke = function ke(e, t) {
      return e === t;
    };
    !function (e) {
      void 0 === e && (e = D);
      var t = e === D ? Se : function () {
        return Object(r.useContext)(e);
      };
    }();
    var Pe,
      De = n(13),
      Ie = n.n(De);
    Pe = De.unstable_batchedUpdates, I = Pe;
    var Ne = !0,
      Re = "Invariant failed";
    var _e = function _e(e, t) {
        if (!e) throw Ne ? new Error(Re) : new Error(Re + ": " + (t || ""));
      },
      Ae = function Ae(e) {
        var t = e.top,
          n = e.right,
          r = e.bottom,
          i = e.left;
        return {
          top: t,
          right: n,
          bottom: r,
          left: i,
          width: n - i,
          height: r - t,
          x: i,
          y: t,
          center: {
            x: (n + i) / 2,
            y: (r + t) / 2
          }
        };
      },
      Le = function Le(e, t) {
        return {
          top: e.top - t.top,
          left: e.left - t.left,
          bottom: e.bottom + t.bottom,
          right: e.right + t.right
        };
      },
      je = function je(e, t) {
        return {
          top: e.top + t.top,
          left: e.left + t.left,
          bottom: e.bottom - t.bottom,
          right: e.right - t.right
        };
      },
      Me = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      Be = function Be(e) {
        var t = e.borderBox,
          n = e.margin,
          r = void 0 === n ? Me : n,
          i = e.border,
          o = void 0 === i ? Me : i,
          a = e.padding,
          l = void 0 === a ? Me : a,
          u = Ae(Le(t, r)),
          c = Ae(je(t, o)),
          s = Ae(je(c, l));
        return {
          marginBox: u,
          borderBox: Ae(t),
          paddingBox: c,
          contentBox: s,
          margin: r,
          border: o,
          padding: l
        };
      },
      Fe = function Fe(e) {
        var t = e.slice(0, -2);
        if ("px" !== e.slice(-2)) return 0;
        var n = Number(t);
        return isNaN(n) && _e(!1), n;
      },
      ze = function ze(e, t) {
        var n,
          r,
          i = e.borderBox,
          o = e.border,
          a = e.margin,
          l = e.padding,
          u = (r = t, {
            top: (n = i).top + r.y,
            left: n.left + r.x,
            bottom: n.bottom + r.y,
            right: n.right + r.x
          });
        return Be({
          borderBox: u,
          border: o,
          margin: a,
          padding: l
        });
      },
      Ue = function Ue(e, t) {
        return void 0 === t && (t = {
          x: window.pageXOffset,
          y: window.pageYOffset
        }), ze(e, t);
      },
      Ge = function Ge(e, t) {
        var n = {
            top: Fe(t.marginTop),
            right: Fe(t.marginRight),
            bottom: Fe(t.marginBottom),
            left: Fe(t.marginLeft)
          },
          r = {
            top: Fe(t.paddingTop),
            right: Fe(t.paddingRight),
            bottom: Fe(t.paddingBottom),
            left: Fe(t.paddingLeft)
          },
          i = {
            top: Fe(t.borderTopWidth),
            right: Fe(t.borderRightWidth),
            bottom: Fe(t.borderBottomWidth),
            left: Fe(t.borderLeftWidth)
          };
        return Be({
          borderBox: e,
          margin: n,
          padding: r,
          border: i
        });
      },
      We = function We(e) {
        var t = e.getBoundingClientRect(),
          n = window.getComputedStyle(e);
        return Ge(t, n);
      };
    function He(e, t) {
      if (e.length !== t.length) return !1;
      for (var n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
      return !0;
    }
    var Ve = function Ve(e, t) {
        var n;
        void 0 === t && (t = He);
        var r,
          i = [],
          o = !1;
        return function () {
          for (var a = [], l = 0; l < arguments.length; l++) a[l] = arguments[l];
          return o && n === this && t(a, i) ? r : (r = e.apply(this, a), o = !0, n = this, i = a, r);
        };
      },
      qe = n(32),
      $e = n.n(qe),
      Ke = n(8),
      Qe = n.n(Ke),
      Ye = function Ye(e) {
        var t = [],
          n = null,
          r = function r() {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            t = i, n || (n = requestAnimationFrame(function () {
              n = null, e.apply(void 0, t);
            }));
          };
        return r.cancel = function () {
          n && (cancelAnimationFrame(n), n = null);
        }, r;
      },
      Xe = n(19),
      Je = n.n(Xe),
      Ze = (n(33), !0),
      et = /[ \t]{2,}/g,
      tt = /^[ \t]*/gm,
      nt = function nt(e) {
        return e.replace(et, " ").replace(tt, "").trim();
      },
      rt = function rt(e) {
        return nt("\n  %creact-beautiful-dnd\n\n  %c" + nt(e) + "\n\n  %c👷‍ This is a development only message. It will be removed in production builds.\n");
      },
      it = function it(e) {
        return [rt(e), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
      },
      ot = "__react-beautiful-dnd-disable-dev-warnings";
    function at(e, t) {
      var n;
      Ze || "undefined" != typeof window && window[ot] || (n = console)[e].apply(n, it(t));
    }
    at.bind(null, "warn"), at.bind(null, "error");
    function lt() {}
    function ut(e, t, n) {
      var r = t.map(function (t) {
        var r,
          i,
          o = (r = n, i = t.options, g({}, r, i));
        return e.addEventListener(t.eventName, t.fn, o), function () {
          e.removeEventListener(t.eventName, t.fn, o);
        };
      });
      return function () {
        r.forEach(function (e) {
          e();
        });
      };
    }
    var ct = !0,
      st = "Invariant failed";
    function dt(e) {
      this.message = e;
    }
    function ft(e, t) {
      if (!e) throw new dt(ct ? st : st + ": " + (t || ""));
    }
    dt.prototype.toString = function () {
      return this.message;
    };
    var pt = function (e) {
        function t() {
          for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
          return (t = e.call.apply(e, [this].concat(r)) || this).callbacks = null, t.unbind = lt, t.onWindowError = function (e) {
            var n = t.getCallbacks();
            n.isDragging() && n.tryAbort(), e.error instanceof dt && e.preventDefault();
          }, t.getCallbacks = function () {
            if (!t.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return t.callbacks;
          }, t.setCallbacks = function (e) {
            t.callbacks = e;
          }, t;
        }
        f(t, e);
        var n = t.prototype;
        return n.componentDidMount = function () {
          this.unbind = ut(window, [{
            eventName: "error",
            fn: this.onWindowError
          }]);
        }, n.componentWillUnmount = function () {
          this.unbind();
        }, n.componentDidCatch = function (e) {
          if (!(e instanceof dt)) throw e;
          this.setState({});
        }, n.render = function () {
          return this.props.children(this.setCallbacks);
        }, t;
      }(i.a.Component),
      mt = function mt(e) {
        return e + 1;
      },
      gt = function gt(e, t) {
        var n = e.droppableId === t.droppableId,
          r = mt(e.index),
          i = mt(t.index);
        return n ? "\n      You have moved the item from position " + r + "\n      to position " + i + "\n    " : "\n    You have moved the item from position " + r + "\n    in list " + e.droppableId + "\n    to list " + t.droppableId + "\n    in position " + i + "\n  ";
      },
      vt = function vt(e, t, n) {
        return t.droppableId === n.droppableId ? "\n      The item " + e + "\n      has been combined with " + n.draggableId : "\n      The item " + e + "\n      in list " + t.droppableId + "\n      has been combined with " + n.draggableId + "\n      in list " + n.droppableId + "\n    ";
      },
      bt = function bt(e) {
        return "\n  The item has returned to its starting position\n  of " + mt(e.index) + "\n";
      },
      ht = {
        liftInstruction: "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.",
        onDragStart: function onDragStart(e) {
          return "\n  You have lifted an item in position " + mt(e.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
        },
        onDragUpdate: function onDragUpdate(e) {
          var t = e.destination;
          if (t) return gt(e.source, t);
          var n = e.combine;
          return n ? vt(e.draggableId, e.source, n) : "You are over an area that cannot be dropped on";
        },
        onDragEnd: function onDragEnd(e) {
          if ("CANCEL" === e.reason) return "\n      Movement cancelled.\n      " + bt(e.source) + "\n    ";
          var t = e.destination,
            n = e.combine;
          return t ? "\n      You have dropped the item.\n      " + gt(e.source, t) + "\n    " : n ? "\n      You have dropped the item.\n      " + vt(e.draggableId, e.source, n) + "\n    " : "\n    The item has been dropped while not over a drop area.\n    " + bt(e.source) + "\n  ";
        }
      },
      yt = {
        x: 0,
        y: 0
      },
      wt = function wt(e, t) {
        return {
          x: e.x + t.x,
          y: e.y + t.y
        };
      },
      xt = function xt(e, t) {
        return {
          x: e.x - t.x,
          y: e.y - t.y
        };
      },
      Et = function Et(e, t) {
        return e.x === t.x && e.y === t.y;
      },
      Ct = function Ct(e) {
        return {
          x: 0 !== e.x ? -e.x : 0,
          y: 0 !== e.y ? -e.y : 0
        };
      },
      St = function St(e, t, n) {
        var r;
        return void 0 === n && (n = 0), (r = {})[e] = t, r["x" === e ? "y" : "x"] = n, r;
      },
      Tt = function Tt(e, t) {
        return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
      },
      Ot = function Ot(e, t) {
        return Math.min.apply(Math, t.map(function (t) {
          return Tt(e, t);
        }));
      },
      kt = function kt(e) {
        return function (t) {
          return {
            x: e(t.x),
            y: e(t.y)
          };
        };
      },
      Pt = function Pt(e, t) {
        return {
          top: e.top + t.y,
          left: e.left + t.x,
          bottom: e.bottom + t.y,
          right: e.right + t.x
        };
      },
      Dt = function Dt(e) {
        return [{
          x: e.left,
          y: e.top
        }, {
          x: e.right,
          y: e.top
        }, {
          x: e.left,
          y: e.bottom
        }, {
          x: e.right,
          y: e.bottom
        }];
      },
      It = function It(e, t) {
        return t && t.shouldClipSubject ? function (e, t) {
          var n = Ae({
            top: Math.max(t.top, e.top),
            right: Math.min(t.right, e.right),
            bottom: Math.min(t.bottom, e.bottom),
            left: Math.max(t.left, e.left)
          });
          return n.width <= 0 || n.height <= 0 ? null : n;
        }(t.pageMarginBox, e) : Ae(e);
      },
      Nt = function Nt(e) {
        var t = e.page,
          n = e.withPlaceholder,
          r = e.axis,
          i = e.frame,
          o = function (e, t, n) {
            var r;
            return n && n.increasedBy ? g({}, e, ((r = {})[t.end] = e[t.end] + n.increasedBy[t.line], r)) : e;
          }(function (e, t) {
            return t ? Pt(e, t.scroll.diff.displacement) : e;
          }(t.marginBox, i), r, n);
        return {
          page: t,
          withPlaceholder: n,
          active: It(o, i)
        };
      },
      Rt = function Rt(e, t) {
        e.frame || ft(!1);
        var n = e.frame,
          r = xt(t, n.scroll.initial),
          i = Ct(r),
          o = g({}, n, {
            scroll: {
              initial: n.scroll.initial,
              current: t,
              diff: {
                value: r,
                displacement: i
              },
              max: n.scroll.max
            }
          });
        return g({}, e, {
          frame: o,
          subject: Nt({
            page: e.subject.page,
            withPlaceholder: e.subject.withPlaceholder,
            axis: e.axis,
            frame: o
          })
        });
      };
    function _t(e) {
      return $e()(e);
    }
    function At(e, t) {
      if (e.findIndex) return e.findIndex(t);
      for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
      return -1;
    }
    function Lt(e, t) {
      if (e.find) return e.find(t);
      var n = At(e, t);
      return -1 !== n ? e[n] : void 0;
    }
    function jt(e) {
      return Array.prototype.slice.call(e);
    }
    var Mt = Ve(function (e) {
        return e.reduce(function (e, t) {
          return e[t.descriptor.id] = t, e;
        }, {});
      }),
      Bt = Ve(function (e) {
        return e.reduce(function (e, t) {
          return e[t.descriptor.id] = t, e;
        }, {});
      }),
      Ft = Ve(function (e) {
        return _t(e);
      }),
      zt = Ve(function (e) {
        return _t(e);
      }),
      Ut = Ve(function (e, t) {
        return zt(t).filter(function (t) {
          return e === t.descriptor.droppableId;
        }).sort(function (e, t) {
          return e.descriptor.index - t.descriptor.index;
        });
      });
    function Gt(e) {
      return e.at && "REORDER" === e.at.type ? e.at.destination : null;
    }
    function Wt(e) {
      return e.at && "COMBINE" === e.at.type ? e.at.combine : null;
    }
    var Ht = Ve(function (e, t) {
        return t.filter(function (t) {
          return t.descriptor.id !== e.descriptor.id;
        });
      }),
      Vt = function Vt(e, t) {
        return e.descriptor.droppableId === t.descriptor.id;
      },
      qt = {
        point: yt,
        value: 0
      },
      $t = {
        invisible: {},
        visible: {},
        all: []
      },
      Kt = {
        displaced: $t,
        displacedBy: qt,
        at: null
      },
      Qt = function Qt(e, t) {
        return function (n) {
          return e <= n && n <= t;
        };
      },
      Yt = function Yt(e) {
        var t = Qt(e.top, e.bottom),
          n = Qt(e.left, e.right);
        return function (r) {
          if (t(r.top) && t(r.bottom) && n(r.left) && n(r.right)) return !0;
          var i = t(r.top) || t(r.bottom),
            o = n(r.left) || n(r.right);
          if (i && o) return !0;
          var a = r.top < e.top && r.bottom > e.bottom,
            l = r.left < e.left && r.right > e.right;
          return !(!a || !l) || a && o || l && i;
        };
      },
      Xt = function Xt(e) {
        var t = Qt(e.top, e.bottom),
          n = Qt(e.left, e.right);
        return function (e) {
          return t(e.top) && t(e.bottom) && n(e.left) && n(e.right);
        };
      },
      Jt = {
        direction: "vertical",
        line: "y",
        crossAxisLine: "x",
        start: "top",
        end: "bottom",
        size: "height",
        crossAxisStart: "left",
        crossAxisEnd: "right",
        crossAxisSize: "width"
      },
      Zt = {
        direction: "horizontal",
        line: "x",
        crossAxisLine: "y",
        start: "left",
        end: "right",
        size: "width",
        crossAxisStart: "top",
        crossAxisEnd: "bottom",
        crossAxisSize: "height"
      },
      en = function en(e) {
        var t = e.target,
          n = e.destination,
          r = e.viewport,
          i = e.withDroppableDisplacement,
          o = e.isVisibleThroughFrameFn,
          a = i ? function (e, t) {
            var n = t.frame ? t.frame.scroll.diff.displacement : yt;
            return Pt(e, n);
          }(t, n) : t;
        return function (e, t, n) {
          return !!t.subject.active && n(t.subject.active)(e);
        }(a, n, o) && function (e, t, n) {
          return n(t)(e);
        }(a, r, o);
      },
      tn = function tn(e) {
        return en(g({}, e, {
          isVisibleThroughFrameFn: Yt
        }));
      },
      nn = function nn(e) {
        return en(g({}, e, {
          isVisibleThroughFrameFn: Xt
        }));
      },
      rn = function rn(e, t, n) {
        if ("boolean" == typeof n) return n;
        if (!t) return !0;
        var r = t.invisible,
          i = t.visible;
        if (r[e]) return !1;
        var o = i[e];
        return !o || o.shouldAnimate;
      };
    function on(e) {
      var t = e.afterDragging,
        n = e.destination,
        r = e.displacedBy,
        i = e.viewport,
        o = e.forceShouldAnimate,
        a = e.last;
      return t.reduce(function (e, t) {
        var l = function (e, t) {
            var n = e.page.marginBox,
              r = {
                top: t.point.y,
                right: 0,
                bottom: 0,
                left: t.point.x
              };
            return Ae(Le(n, r));
          }(t, r),
          u = t.descriptor.id;
        if (e.all.push(u), !tn({
          target: l,
          destination: n,
          viewport: i,
          withDroppableDisplacement: !0
        })) return e.invisible[t.descriptor.id] = !0, e;
        var c = {
          draggableId: u,
          shouldAnimate: rn(u, a, o)
        };
        return e.visible[u] = c, e;
      }, {
        all: [],
        visible: {},
        invisible: {}
      });
    }
    function an(e) {
      var t = e.insideDestination,
        n = e.inHomeList,
        r = e.displacedBy,
        i = e.destination,
        o = function (e, t) {
          if (!e.length) return 0;
          var n = e[e.length - 1].descriptor.index;
          return t.inHomeList ? n : n + 1;
        }(t, {
          inHomeList: n
        });
      return {
        displaced: $t,
        displacedBy: r,
        at: {
          type: "REORDER",
          destination: {
            droppableId: i.descriptor.id,
            index: o
          }
        }
      };
    }
    function ln(e) {
      var t = e.draggable,
        n = e.insideDestination,
        r = e.destination,
        i = e.viewport,
        o = e.displacedBy,
        a = e.last,
        l = e.index,
        u = e.forceShouldAnimate,
        c = Vt(t, r);
      if (null == l) return an({
        insideDestination: n,
        inHomeList: c,
        displacedBy: o,
        destination: r
      });
      var s = Lt(n, function (e) {
        return e.descriptor.index === l;
      });
      if (!s) return an({
        insideDestination: n,
        inHomeList: c,
        displacedBy: o,
        destination: r
      });
      var d = Ht(t, n),
        f = n.indexOf(s);
      return {
        displaced: on({
          afterDragging: d.slice(f),
          destination: r,
          displacedBy: o,
          last: a,
          viewport: i.frame,
          forceShouldAnimate: u
        }),
        displacedBy: o,
        at: {
          type: "REORDER",
          destination: {
            droppableId: r.descriptor.id,
            index: l
          }
        }
      };
    }
    function un(e, t) {
      return Boolean(t.effected[e]);
    }
    var cn = function cn(e) {
        var t = e.isMovingForward,
          n = e.isInHomeList,
          r = e.draggable,
          i = e.draggables,
          o = e.destination,
          a = e.insideDestination,
          l = e.previousImpact,
          u = e.viewport,
          c = e.afterCritical,
          s = l.at;
        if (s || ft(!1), "REORDER" === s.type) {
          var d = function (e) {
            var t = e.isMovingForward,
              n = e.isInHomeList,
              r = e.insideDestination,
              i = e.location;
            if (!r.length) return null;
            var o = i.index,
              a = t ? o + 1 : o - 1,
              l = r[0].descriptor.index,
              u = r[r.length - 1].descriptor.index;
            return a < l ? null : a > (n ? u : u + 1) ? null : a;
          }({
            isMovingForward: t,
            isInHomeList: n,
            location: s.destination,
            insideDestination: a
          });
          return null == d ? null : ln({
            draggable: r,
            insideDestination: a,
            destination: o,
            viewport: u,
            last: l.displaced,
            displacedBy: l.displacedBy,
            index: d
          });
        }
        var f = function (e) {
          var t = e.isMovingForward,
            n = e.destination,
            r = e.draggables,
            i = e.combine,
            o = e.afterCritical;
          if (!n.isCombineEnabled) return null;
          var a = i.draggableId,
            l = r[a].descriptor.index;
          return un(a, o) ? t ? l : l - 1 : t ? l + 1 : l;
        }({
          isMovingForward: t,
          destination: o,
          displaced: l.displaced,
          draggables: i,
          combine: s.combine,
          afterCritical: c
        });
        return null == f ? null : ln({
          draggable: r,
          insideDestination: a,
          destination: o,
          viewport: u,
          last: l.displaced,
          displacedBy: l.displacedBy,
          index: f
        });
      },
      sn = function sn(e) {
        var t = e.afterCritical,
          n = e.impact,
          r = e.draggables,
          i = Wt(n);
        i || ft(!1);
        var o = i.draggableId,
          a = r[o].page.borderBox.center,
          l = function (e) {
            var t = e.displaced,
              n = e.afterCritical,
              r = e.combineWith,
              i = e.displacedBy,
              o = Boolean(t.visible[r] || t.invisible[r]);
            return un(r, n) ? o ? yt : Ct(i.point) : o ? i.point : yt;
          }({
            displaced: n.displaced,
            afterCritical: t,
            combineWith: o,
            displacedBy: n.displacedBy
          });
        return wt(a, l);
      },
      dn = function dn(e, t) {
        return t.margin[e.start] + t.borderBox[e.size] / 2;
      },
      fn = function fn(e, t, n) {
        return t[e.crossAxisStart] + n.margin[e.crossAxisStart] + n.borderBox[e.crossAxisSize] / 2;
      },
      pn = function pn(e) {
        var t = e.axis,
          n = e.moveRelativeTo,
          r = e.isMoving;
        return St(t.line, n.marginBox[t.end] + dn(t, r), fn(t, n.marginBox, r));
      },
      mn = function mn(e) {
        var t = e.axis,
          n = e.moveRelativeTo,
          r = e.isMoving;
        return St(t.line, n.marginBox[t.start] - function (e, t) {
          return t.margin[e.end] + t.borderBox[e.size] / 2;
        }(t, r), fn(t, n.marginBox, r));
      },
      gn = function gn(e) {
        var t = e.impact,
          n = e.draggable,
          r = e.draggables,
          i = e.droppable,
          o = e.afterCritical,
          a = Ut(i.descriptor.id, r),
          l = n.page,
          u = i.axis;
        if (!a.length) return function (e) {
          var t = e.axis,
            n = e.moveInto,
            r = e.isMoving;
          return St(t.line, n.contentBox[t.start] + dn(t, r), fn(t, n.contentBox, r));
        }({
          axis: u,
          moveInto: i.page,
          isMoving: l
        });
        var c = t.displaced,
          s = t.displacedBy,
          d = c.all[0];
        if (d) {
          var f = r[d];
          if (un(d, o)) return mn({
            axis: u,
            moveRelativeTo: f.page,
            isMoving: l
          });
          var p = ze(f.page, s.point);
          return mn({
            axis: u,
            moveRelativeTo: p,
            isMoving: l
          });
        }
        var m = a[a.length - 1];
        if (m.descriptor.id === n.descriptor.id) return l.borderBox.center;
        if (un(m.descriptor.id, o)) {
          var g = ze(m.page, Ct(o.displacedBy.point));
          return pn({
            axis: u,
            moveRelativeTo: g,
            isMoving: l
          });
        }
        return pn({
          axis: u,
          moveRelativeTo: m.page,
          isMoving: l
        });
      },
      vn = function vn(e, t) {
        var n = e.frame;
        return n ? wt(t, n.scroll.diff.displacement) : t;
      },
      bn = function bn(e) {
        var t = function (e) {
            var t = e.impact,
              n = e.draggable,
              r = e.droppable,
              i = e.draggables,
              o = e.afterCritical,
              a = n.page.borderBox.center,
              l = t.at;
            return r && l ? "REORDER" === l.type ? gn({
              impact: t,
              draggable: n,
              draggables: i,
              droppable: r,
              afterCritical: o
            }) : sn({
              impact: t,
              draggables: i,
              afterCritical: o
            }) : a;
          }(e),
          n = e.droppable;
        return n ? vn(n, t) : t;
      },
      hn = function hn(e, t) {
        var n = xt(t, e.scroll.initial),
          r = Ct(n);
        return {
          frame: Ae({
            top: t.y,
            bottom: t.y + e.frame.height,
            left: t.x,
            right: t.x + e.frame.width
          }),
          scroll: {
            initial: e.scroll.initial,
            max: e.scroll.max,
            current: t,
            diff: {
              value: n,
              displacement: r
            }
          }
        };
      };
    function yn(e, t) {
      return e.map(function (e) {
        return t[e];
      });
    }
    var wn = function wn(e) {
        var t = e.pageBorderBoxCenter,
          n = e.draggable,
          r = function (e, t) {
            return wt(e.scroll.diff.displacement, t);
          }(e.viewport, t),
          i = xt(r, n.page.borderBox.center);
        return wt(n.client.borderBox.center, i);
      },
      xn = function xn(e) {
        var t = e.draggable,
          n = e.destination,
          r = e.newPageBorderBoxCenter,
          i = e.viewport,
          o = e.withDroppableDisplacement,
          a = e.onlyOnMainAxis,
          l = void 0 !== a && a,
          u = xt(r, t.page.borderBox.center),
          c = {
            target: Pt(t.page.borderBox, u),
            destination: n,
            withDroppableDisplacement: o,
            viewport: i
          };
        return l ? function (e) {
          return en(g({}, e, {
            isVisibleThroughFrameFn: (t = e.destination.axis, function (e) {
              var n = Qt(e.top, e.bottom),
                r = Qt(e.left, e.right);
              return function (e) {
                return t === Jt ? n(e.top) && n(e.bottom) : r(e.left) && r(e.right);
              };
            })
          }));
          var t;
        }(c) : nn(c);
      },
      En = function En(e) {
        var t = e.isMovingForward,
          n = e.draggable,
          r = e.destination,
          i = e.draggables,
          o = e.previousImpact,
          a = e.viewport,
          l = e.previousPageBorderBoxCenter,
          u = e.previousClientSelection,
          c = e.afterCritical;
        if (!r.isEnabled) return null;
        var s = Ut(r.descriptor.id, i),
          d = Vt(n, r),
          f = function (e) {
            var t = e.isMovingForward,
              n = e.draggable,
              r = e.destination,
              i = e.insideDestination,
              o = e.previousImpact;
            if (!r.isCombineEnabled) return null;
            if (!Gt(o)) return null;
            function a(e) {
              var t = {
                type: "COMBINE",
                combine: {
                  draggableId: e,
                  droppableId: r.descriptor.id
                }
              };
              return g({}, o, {
                at: t
              });
            }
            var l = o.displaced.all,
              u = l.length ? l[0] : null;
            if (t) return u ? a(u) : null;
            var c = Ht(n, i);
            if (!u) return c.length ? a(c[c.length - 1].descriptor.id) : null;
            var s = At(c, function (e) {
              return e.descriptor.id === u;
            });
            -1 === s && ft(!1);
            var d = s - 1;
            return d < 0 ? null : a(c[d].descriptor.id);
          }({
            isMovingForward: t,
            draggable: n,
            destination: r,
            insideDestination: s,
            previousImpact: o
          }) || cn({
            isMovingForward: t,
            isInHomeList: d,
            draggable: n,
            draggables: i,
            destination: r,
            insideDestination: s,
            previousImpact: o,
            viewport: a,
            afterCritical: c
          });
        if (!f) return null;
        var p = bn({
          impact: f,
          draggable: n,
          droppable: r,
          draggables: i,
          afterCritical: c
        });
        if (xn({
          draggable: n,
          destination: r,
          newPageBorderBoxCenter: p,
          viewport: a.frame,
          withDroppableDisplacement: !1,
          onlyOnMainAxis: !0
        })) return {
          clientSelection: wn({
            pageBorderBoxCenter: p,
            draggable: n,
            viewport: a
          }),
          impact: f,
          scrollJumpRequest: null
        };
        var m = xt(p, l);
        return {
          clientSelection: u,
          impact: function (e) {
            var t = e.impact,
              n = e.viewport,
              r = e.destination,
              i = e.draggables,
              o = e.maxScrollChange,
              a = hn(n, wt(n.scroll.current, o)),
              l = r.frame ? Rt(r, wt(r.frame.scroll.current, o)) : r,
              u = t.displaced,
              c = on({
                afterDragging: yn(u.all, i),
                destination: r,
                displacedBy: t.displacedBy,
                viewport: a.frame,
                last: u,
                forceShouldAnimate: !1
              }),
              s = on({
                afterDragging: yn(u.all, i),
                destination: l,
                displacedBy: t.displacedBy,
                viewport: n.frame,
                last: u,
                forceShouldAnimate: !1
              }),
              d = {},
              f = {},
              p = [u, c, s];
            return u.all.forEach(function (e) {
              var t = function (e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n].visible[e];
                  if (r) return r;
                }
                return null;
              }(e, p);
              t ? f[e] = t : d[e] = !0;
            }), g({}, t, {
              displaced: {
                all: u.all,
                invisible: d,
                visible: f
              }
            });
          }({
            impact: f,
            viewport: a,
            destination: r,
            draggables: i,
            maxScrollChange: m
          }),
          scrollJumpRequest: m
        };
      },
      Cn = function Cn(e) {
        var t = e.subject.active;
        return t || ft(!1), t;
      },
      Sn = function Sn(e, t) {
        var n = e.page.borderBox.center;
        return un(e.descriptor.id, t) ? xt(n, t.displacedBy.point) : n;
      },
      Tn = function Tn(e, t) {
        var n = e.page.borderBox;
        return un(e.descriptor.id, t) ? Pt(n, Ct(t.displacedBy.point)) : n;
      },
      On = Ve(function (e, t) {
        var n = t[e.line];
        return {
          value: n,
          point: St(e.line, n)
        };
      }),
      kn = function kn(e, t) {
        return g({}, e, {
          scroll: g({}, e.scroll, {
            max: t
          })
        });
      },
      Pn = function Pn(e, t, n) {
        var r = e.frame;
        Vt(t, e) && ft(!1), e.subject.withPlaceholder && ft(!1);
        var i = On(e.axis, t.displaceBy).point,
          o = function (e, t, n) {
            var r = e.axis;
            if ("virtual" === e.descriptor.mode) return St(r.line, t[r.line]);
            var i = e.subject.page.contentBox[r.size],
              o = Ut(e.descriptor.id, n).reduce(function (e, t) {
                return e + t.client.marginBox[r.size];
              }, 0) + t[r.line] - i;
            return o <= 0 ? null : St(r.line, o);
          }(e, i, n),
          a = {
            placeholderSize: i,
            increasedBy: o,
            oldFrameMaxScroll: e.frame ? e.frame.scroll.max : null
          };
        if (!r) return g({}, e, {
          subject: Nt({
            page: e.subject.page,
            withPlaceholder: a,
            axis: e.axis,
            frame: e.frame
          })
        });
        var l = o ? wt(r.scroll.max, o) : r.scroll.max,
          u = kn(r, l);
        return g({}, e, {
          subject: Nt({
            page: e.subject.page,
            withPlaceholder: a,
            axis: e.axis,
            frame: u
          }),
          frame: u
        });
      },
      Dn = function Dn(e) {
        var t = e.isMovingForward,
          n = e.previousPageBorderBoxCenter,
          r = e.draggable,
          i = e.isOver,
          o = e.draggables,
          a = e.droppables,
          l = e.viewport,
          u = e.afterCritical,
          c = function (e) {
            var t = e.isMovingForward,
              n = e.pageBorderBoxCenter,
              r = e.source,
              i = e.droppables,
              o = e.viewport,
              a = r.subject.active;
            if (!a) return null;
            var l = r.axis,
              u = Qt(a[l.start], a[l.end]),
              c = Ft(i).filter(function (e) {
                return e !== r;
              }).filter(function (e) {
                return e.isEnabled;
              }).filter(function (e) {
                return Boolean(e.subject.active);
              }).filter(function (e) {
                return Yt(o.frame)(Cn(e));
              }).filter(function (e) {
                var n = Cn(e);
                return t ? a[l.crossAxisEnd] < n[l.crossAxisEnd] : n[l.crossAxisStart] < a[l.crossAxisStart];
              }).filter(function (e) {
                var t = Cn(e),
                  n = Qt(t[l.start], t[l.end]);
                return u(t[l.start]) || u(t[l.end]) || n(a[l.start]) || n(a[l.end]);
              }).sort(function (e, n) {
                var r = Cn(e)[l.crossAxisStart],
                  i = Cn(n)[l.crossAxisStart];
                return t ? r - i : i - r;
              }).filter(function (e, t, n) {
                return Cn(e)[l.crossAxisStart] === Cn(n[0])[l.crossAxisStart];
              });
            if (!c.length) return null;
            if (1 === c.length) return c[0];
            var s = c.filter(function (e) {
              return Qt(Cn(e)[l.start], Cn(e)[l.end])(n[l.line]);
            });
            return 1 === s.length ? s[0] : s.length > 1 ? s.sort(function (e, t) {
              return Cn(e)[l.start] - Cn(t)[l.start];
            })[0] : c.sort(function (e, t) {
              var r = Ot(n, Dt(Cn(e))),
                i = Ot(n, Dt(Cn(t)));
              return r !== i ? r - i : Cn(e)[l.start] - Cn(t)[l.start];
            })[0];
          }({
            isMovingForward: t,
            pageBorderBoxCenter: n,
            source: i,
            droppables: a,
            viewport: l
          });
        if (!c) return null;
        var s = Ut(c.descriptor.id, o),
          d = function (e) {
            var t = e.previousPageBorderBoxCenter,
              n = e.moveRelativeTo,
              r = e.insideDestination,
              i = e.draggable,
              o = e.draggables,
              a = e.destination,
              l = e.viewport,
              u = e.afterCritical;
            if (!n) {
              if (r.length) return null;
              var c = {
                  displaced: $t,
                  displacedBy: qt,
                  at: {
                    type: "REORDER",
                    destination: {
                      droppableId: a.descriptor.id,
                      index: 0
                    }
                  }
                },
                s = bn({
                  impact: c,
                  draggable: i,
                  droppable: a,
                  draggables: o,
                  afterCritical: u
                }),
                d = Vt(i, a) ? a : Pn(a, i, o);
              return xn({
                draggable: i,
                destination: d,
                newPageBorderBoxCenter: s,
                viewport: l.frame,
                withDroppableDisplacement: !1,
                onlyOnMainAxis: !0
              }) ? c : null;
            }
            var f,
              p = Boolean(t[a.axis.line] <= n.page.borderBox.center[a.axis.line]),
              m = (f = n.descriptor.index, n.descriptor.id === i.descriptor.id ? f : p ? f : f + 1),
              g = On(a.axis, i.displaceBy);
            return ln({
              draggable: i,
              insideDestination: r,
              destination: a,
              viewport: l,
              displacedBy: g,
              last: $t,
              index: m
            });
          }({
            previousPageBorderBoxCenter: n,
            destination: c,
            draggable: r,
            draggables: o,
            moveRelativeTo: function (e) {
              var t = e.pageBorderBoxCenter,
                n = e.viewport,
                r = e.destination,
                i = e.insideDestination,
                o = e.afterCritical;
              return i.filter(function (e) {
                return nn({
                  target: Tn(e, o),
                  destination: r,
                  viewport: n.frame,
                  withDroppableDisplacement: !0
                });
              }).sort(function (e, n) {
                var i = Tt(t, vn(r, Sn(e, o))),
                  a = Tt(t, vn(r, Sn(n, o)));
                return i < a ? -1 : a < i ? 1 : e.descriptor.index - n.descriptor.index;
              })[0] || null;
            }({
              pageBorderBoxCenter: n,
              viewport: l,
              destination: c,
              insideDestination: s,
              afterCritical: u
            }),
            insideDestination: s,
            viewport: l,
            afterCritical: u
          });
        if (!d) return null;
        var f = bn({
          impact: d,
          draggable: r,
          droppable: c,
          draggables: o,
          afterCritical: u
        });
        return {
          clientSelection: wn({
            pageBorderBoxCenter: f,
            draggable: r,
            viewport: l
          }),
          impact: d,
          scrollJumpRequest: null
        };
      },
      In = function In(e) {
        var t = e.at;
        return t ? "REORDER" === t.type ? t.destination.droppableId : t.combine.droppableId : null;
      },
      Nn = function Nn(e) {
        var t = e.state,
          n = e.type,
          r = function (e, t) {
            var n = In(e);
            return n ? t[n] : null;
          }(t.impact, t.dimensions.droppables),
          i = Boolean(r),
          o = t.dimensions.droppables[t.critical.droppable.id],
          a = r || o,
          l = a.axis.direction,
          u = "vertical" === l && ("MOVE_UP" === n || "MOVE_DOWN" === n) || "horizontal" === l && ("MOVE_LEFT" === n || "MOVE_RIGHT" === n);
        if (u && !i) return null;
        var c = "MOVE_DOWN" === n || "MOVE_RIGHT" === n,
          s = t.dimensions.draggables[t.critical.draggable.id],
          d = t.current.page.borderBoxCenter,
          f = t.dimensions,
          p = f.draggables,
          m = f.droppables;
        return u ? En({
          isMovingForward: c,
          previousPageBorderBoxCenter: d,
          draggable: s,
          destination: a,
          draggables: p,
          viewport: t.viewport,
          previousClientSelection: t.current.client.selection,
          previousImpact: t.impact,
          afterCritical: t.afterCritical
        }) : Dn({
          isMovingForward: c,
          previousPageBorderBoxCenter: d,
          draggable: s,
          isOver: a,
          draggables: p,
          droppables: m,
          viewport: t.viewport,
          afterCritical: t.afterCritical
        });
      };
    function Rn(e) {
      return "DRAGGING" === e.phase || "COLLECTING" === e.phase;
    }
    function _n(e) {
      var t = Qt(e.top, e.bottom),
        n = Qt(e.left, e.right);
      return function (e) {
        return t(e.y) && n(e.x);
      };
    }
    function An(e) {
      var t = e.pageBorderBox,
        n = e.draggable,
        r = e.droppables,
        i = Ft(r).filter(function (e) {
          if (!e.isEnabled) return !1;
          var n,
            r,
            i = e.subject.active;
          if (!i) return !1;
          if (r = i, !((n = t).left < r.right && n.right > r.left && n.top < r.bottom && n.bottom > r.top)) return !1;
          if (_n(i)(t.center)) return !0;
          var o = e.axis,
            a = i.center[o.crossAxisLine],
            l = t[o.crossAxisStart],
            u = t[o.crossAxisEnd],
            c = Qt(i[o.crossAxisStart], i[o.crossAxisEnd]),
            s = c(l),
            d = c(u);
          return !s && !d || (s ? l < a : u > a);
        });
      return i.length ? 1 === i.length ? i[0].descriptor.id : function (e) {
        var t = e.pageBorderBox,
          n = e.draggable,
          r = e.candidates,
          i = n.page.borderBox.center,
          o = r.map(function (e) {
            var n = e.axis,
              r = St(e.axis.line, t.center[n.line], e.page.borderBox.center[n.crossAxisLine]);
            return {
              id: e.descriptor.id,
              distance: Tt(i, r)
            };
          }).sort(function (e, t) {
            return t.distance - e.distance;
          });
        return o[0] ? o[0].id : null;
      }({
        pageBorderBox: t,
        draggable: n,
        candidates: i
      }) : null;
    }
    var Ln = function Ln(e, t) {
      return Ae(Pt(e, t));
    };
    function jn(e) {
      var t = e.displaced,
        n = e.id;
      return Boolean(t.visible[n] || t.invisible[n]);
    }
    var Mn = function Mn(e) {
        var t = e.pageOffset,
          n = e.draggable,
          r = e.draggables,
          i = e.droppables,
          o = e.previousImpact,
          a = e.viewport,
          l = e.afterCritical,
          u = Ln(n.page.borderBox, t),
          c = An({
            pageBorderBox: u,
            draggable: n,
            droppables: i
          });
        if (!c) return Kt;
        var s,
          d,
          f = i[c],
          p = Ut(f.descriptor.id, r),
          m = (s = u, (d = f.frame) ? Ln(s, d.scroll.diff.value) : s);
        return function (e) {
          var t = e.draggable,
            n = e.pageBorderBoxWithDroppableScroll,
            r = e.previousImpact,
            i = e.destination,
            o = e.insideDestination,
            a = e.afterCritical;
          if (!i.isCombineEnabled) return null;
          var l = i.axis,
            u = On(i.axis, t.displaceBy),
            c = u.value,
            s = n[l.start],
            d = n[l.end],
            f = Lt(Ht(t, o), function (e) {
              var t = e.descriptor.id,
                n = e.page.borderBox,
                i = n[l.size] / 4,
                o = un(t, a),
                u = jn({
                  displaced: r.displaced,
                  id: t
                });
              return o ? u ? d > n[l.start] + i && d < n[l.end] - i : s > n[l.start] - c + i && s < n[l.end] - c - i : u ? d > n[l.start] + c + i && d < n[l.end] + c - i : s > n[l.start] + i && s < n[l.end] - i;
            });
          return f ? {
            displacedBy: u,
            displaced: r.displaced,
            at: {
              type: "COMBINE",
              combine: {
                draggableId: f.descriptor.id,
                droppableId: i.descriptor.id
              }
            }
          } : null;
        }({
          pageBorderBoxWithDroppableScroll: m,
          draggable: n,
          previousImpact: o,
          destination: f,
          insideDestination: p,
          afterCritical: l
        }) || function (e) {
          var t = e.pageBorderBoxWithDroppableScroll,
            n = e.draggable,
            r = e.destination,
            i = e.insideDestination,
            o = e.last,
            a = e.viewport,
            l = e.afterCritical,
            u = r.axis,
            c = On(r.axis, n.displaceBy),
            s = c.value,
            d = t[u.start],
            f = t[u.end],
            p = function (e) {
              var t = e.draggable,
                n = e.closest,
                r = e.inHomeList;
              return n ? r && n.descriptor.index > t.descriptor.index ? n.descriptor.index - 1 : n.descriptor.index : null;
            }({
              draggable: n,
              closest: Lt(Ht(n, i), function (e) {
                var t = e.descriptor.id,
                  n = e.page.borderBox.center[u.line],
                  r = un(t, l),
                  i = jn({
                    displaced: o,
                    id: t
                  });
                return r ? i ? f <= n : d < n - s : i ? f <= n + s : d < n;
              }),
              inHomeList: Vt(n, r)
            });
          return ln({
            draggable: n,
            insideDestination: i,
            destination: r,
            viewport: a,
            last: o,
            displacedBy: c,
            index: p
          });
        }({
          pageBorderBoxWithDroppableScroll: m,
          draggable: n,
          destination: f,
          insideDestination: p,
          last: o.displaced,
          viewport: a,
          afterCritical: l
        });
      },
      Bn = function Bn(e, t) {
        var n;
        return g({}, e, ((n = {})[t.descriptor.id] = t, n));
      },
      Fn = function Fn(e) {
        var t = e.previousImpact,
          n = e.impact,
          r = e.droppables,
          i = In(t),
          o = In(n);
        if (!i) return r;
        if (i === o) return r;
        var a = r[i];
        if (!a.subject.withPlaceholder) return r;
        var l = function (e) {
          var t = e.subject.withPlaceholder;
          t || ft(!1);
          var n = e.frame;
          if (!n) return g({}, e, {
            subject: Nt({
              page: e.subject.page,
              axis: e.axis,
              frame: null,
              withPlaceholder: null
            })
          });
          var r = t.oldFrameMaxScroll;
          r || ft(!1);
          var i = kn(n, r);
          return g({}, e, {
            subject: Nt({
              page: e.subject.page,
              axis: e.axis,
              frame: i,
              withPlaceholder: null
            }),
            frame: i
          });
        }(a);
        return Bn(r, l);
      },
      zn = function zn(e) {
        var t = e.state,
          n = e.clientSelection,
          r = e.dimensions,
          i = e.viewport,
          o = e.impact,
          a = e.scrollJumpRequest,
          l = i || t.viewport,
          u = r || t.dimensions,
          c = n || t.current.client.selection,
          s = xt(c, t.initial.client.selection),
          d = {
            offset: s,
            selection: c,
            borderBoxCenter: wt(t.initial.client.borderBoxCenter, s)
          },
          f = {
            selection: wt(d.selection, l.scroll.current),
            borderBoxCenter: wt(d.borderBoxCenter, l.scroll.current),
            offset: wt(d.offset, l.scroll.diff.value)
          },
          p = {
            client: d,
            page: f
          };
        if ("COLLECTING" === t.phase) return g({
          phase: "COLLECTING"
        }, t, {
          dimensions: u,
          viewport: l,
          current: p
        });
        var m = u.draggables[t.critical.draggable.id],
          v = o || Mn({
            pageOffset: f.offset,
            draggable: m,
            draggables: u.draggables,
            droppables: u.droppables,
            previousImpact: t.impact,
            viewport: l,
            afterCritical: t.afterCritical
          }),
          b = function (e) {
            var t = e.draggable,
              n = e.draggables,
              r = e.droppables,
              i = e.previousImpact,
              o = e.impact,
              a = Fn({
                previousImpact: i,
                impact: o,
                droppables: r
              }),
              l = In(o);
            if (!l) return a;
            var u = r[l];
            if (Vt(t, u)) return a;
            if (u.subject.withPlaceholder) return a;
            var c = Pn(u, t, n);
            return Bn(a, c);
          }({
            draggable: m,
            impact: v,
            previousImpact: t.impact,
            draggables: u.draggables,
            droppables: u.droppables
          });
        return g({}, t, {
          current: p,
          dimensions: {
            draggables: u.draggables,
            droppables: b
          },
          impact: v,
          viewport: l,
          scrollJumpRequest: a || null,
          forceShouldAnimate: !a && null
        });
      };
    var Un = function Un(e) {
        var t = e.impact,
          n = e.viewport,
          r = e.draggables,
          i = e.destination,
          o = e.forceShouldAnimate,
          a = t.displaced;
        return g({}, t, {
          displaced: on({
            afterDragging: function (e, t) {
              return e.map(function (e) {
                return t[e];
              });
            }(a.all, r),
            destination: i,
            displacedBy: t.displacedBy,
            viewport: n.frame,
            forceShouldAnimate: o,
            last: a
          })
        });
      },
      Gn = function Gn(e) {
        var t = e.impact,
          n = e.draggable,
          r = e.droppable,
          i = e.draggables,
          o = e.viewport,
          a = e.afterCritical,
          l = bn({
            impact: t,
            draggable: n,
            draggables: i,
            droppable: r,
            afterCritical: a
          });
        return wn({
          pageBorderBoxCenter: l,
          draggable: n,
          viewport: o
        });
      },
      Wn = function Wn(e) {
        var t = e.state,
          n = e.dimensions,
          r = e.viewport;
        "SNAP" !== t.movementMode && ft(!1);
        var i = t.impact,
          o = r || t.viewport,
          a = n || t.dimensions,
          l = a.draggables,
          u = a.droppables,
          c = l[t.critical.draggable.id],
          s = In(i);
        s || ft(!1);
        var d = u[s],
          f = Un({
            impact: i,
            viewport: o,
            destination: d,
            draggables: l
          }),
          p = Gn({
            impact: f,
            draggable: c,
            droppable: d,
            draggables: l,
            viewport: o,
            afterCritical: t.afterCritical
          });
        return zn({
          impact: f,
          clientSelection: p,
          state: t,
          dimensions: a,
          viewport: o
        });
      },
      Hn = function Hn(e) {
        var t = e.draggable,
          n = e.home,
          r = e.draggables,
          i = e.viewport,
          o = On(n.axis, t.displaceBy),
          a = Ut(n.descriptor.id, r),
          l = a.indexOf(t);
        -1 === l && ft(!1);
        var u,
          c = a.slice(l + 1),
          s = c.reduce(function (e, t) {
            return e[t.descriptor.id] = !0, e;
          }, {}),
          d = {
            inVirtualList: "virtual" === n.descriptor.mode,
            displacedBy: o,
            effected: s
          };
        return {
          impact: {
            displaced: on({
              afterDragging: c,
              destination: n,
              displacedBy: o,
              last: null,
              viewport: i.frame,
              forceShouldAnimate: !1
            }),
            displacedBy: o,
            at: {
              type: "REORDER",
              destination: (u = t.descriptor, {
                index: u.index,
                droppableId: u.droppableId
              })
            }
          },
          afterCritical: d
        };
      },
      Vn = function Vn(e) {},
      qn = function qn(e) {},
      $n = function $n(e) {
        var t = e.additions,
          n = e.updatedDroppables,
          r = e.viewport,
          i = r.scroll.diff.value;
        return t.map(function (e) {
          var t = e.descriptor.droppableId,
            o = function (e) {
              var t = e.frame;
              return t || ft(!1), t;
            }(n[t]).scroll.diff.value;
          return function (e) {
            var t = e.draggable,
              n = e.offset,
              r = e.initialWindowScroll,
              i = ze(t.client, n),
              o = Ue(i, r);
            return g({}, t, {
              placeholder: g({}, t.placeholder, {
                client: i
              }),
              client: i,
              page: o
            });
          }({
            draggable: e,
            offset: wt(i, o),
            initialWindowScroll: r.scroll.initial
          });
        });
      },
      Kn = function Kn(e) {
        return "SNAP" === e.movementMode;
      },
      Qn = function Qn(e, t, n) {
        var r = function (e, t) {
          return {
            draggables: e.draggables,
            droppables: Bn(e.droppables, t)
          };
        }(e.dimensions, t);
        return !Kn(e) || n ? zn({
          state: e,
          dimensions: r
        }) : Wn({
          state: e,
          dimensions: r
        });
      };
    function Yn(e) {
      return e.isDragging && "SNAP" === e.movementMode ? g({
        phase: "DRAGGING"
      }, e, {
        scrollJumpRequest: null
      }) : e;
    }
    var Xn = {
        phase: "IDLE",
        completed: null,
        shouldFlush: !1
      },
      Jn = function Jn(e, t) {
        if (void 0 === e && (e = Xn), "FLUSH" === t.type) return g({}, Xn, {
          shouldFlush: !0
        });
        if ("INITIAL_PUBLISH" === t.type) {
          "IDLE" !== e.phase && ft(!1);
          var n = t.payload,
            r = n.critical,
            i = n.clientSelection,
            o = n.viewport,
            a = n.dimensions,
            l = n.movementMode,
            u = a.draggables[r.draggable.id],
            c = a.droppables[r.droppable.id],
            s = {
              selection: i,
              borderBoxCenter: u.client.borderBox.center,
              offset: yt
            },
            d = {
              client: s,
              page: {
                selection: wt(s.selection, o.scroll.initial),
                borderBoxCenter: wt(s.selection, o.scroll.initial),
                offset: wt(s.selection, o.scroll.diff.value)
              }
            },
            f = Ft(a.droppables).every(function (e) {
              return !e.isFixedOnPage;
            }),
            p = Hn({
              draggable: u,
              home: c,
              draggables: a.draggables,
              viewport: o
            }),
            m = p.impact;
          return {
            phase: "DRAGGING",
            isDragging: !0,
            critical: r,
            movementMode: l,
            dimensions: a,
            initial: d,
            current: d,
            isWindowScrollAllowed: f,
            impact: m,
            afterCritical: p.afterCritical,
            onLiftImpact: m,
            viewport: o,
            scrollJumpRequest: null,
            forceShouldAnimate: null
          };
        }
        var v;
        if ("COLLECTION_STARTING" === t.type) return "COLLECTING" === e.phase || "DROP_PENDING" === e.phase ? e : ("DRAGGING" !== e.phase && ft(!1), g({
          phase: "COLLECTING"
        }, e, ((v = {}).phase = "COLLECTING", v)));
        if ("PUBLISH_WHILE_DRAGGING" === t.type) return "COLLECTING" !== e.phase && "DROP_PENDING" !== e.phase && ft(!1), function (e) {
          var t,
            n,
            r = e.state,
            i = e.published;
          Vn("Processing dynamic changes");
          var o = i.modified.map(function (e) {
              var t = r.dimensions.droppables[e.droppableId];
              return Rt(t, e.scroll);
            }),
            a = g({}, r.dimensions.droppables, Mt(o)),
            l = Bt($n({
              additions: i.additions,
              updatedDroppables: a,
              viewport: r.viewport
            })),
            u = g({}, r.dimensions.draggables, l);
          i.removals.forEach(function (e) {
            delete u[e];
          });
          var c = {
              droppables: a,
              draggables: u
            },
            s = In(r.impact),
            d = s ? c.droppables[s] : null,
            f = c.draggables[r.critical.draggable.id],
            p = c.droppables[r.critical.droppable.id],
            m = Hn({
              draggable: f,
              home: p,
              draggables: u,
              viewport: r.viewport
            }),
            v = m.impact,
            b = m.afterCritical,
            h = d && d.isCombineEnabled ? r.impact : v,
            y = Mn({
              pageOffset: r.current.page.offset,
              draggable: c.draggables[r.critical.draggable.id],
              draggables: c.draggables,
              droppables: c.droppables,
              previousImpact: h,
              viewport: r.viewport,
              afterCritical: b
            });
          qn("Processing dynamic changes");
          var w = g({
            phase: "DRAGGING"
          }, r, ((t = {}).phase = "DRAGGING", t.impact = y, t.onLiftImpact = v, t.dimensions = c, t.afterCritical = b, t.forceShouldAnimate = !1, t));
          return "COLLECTING" === r.phase ? w : g({
            phase: "DROP_PENDING"
          }, w, ((n = {}).phase = "DROP_PENDING", n.reason = r.reason, n.isWaiting = !1, n));
        }({
          state: e,
          published: t.payload
        });
        if ("MOVE" === t.type) {
          if ("DROP_PENDING" === e.phase) return e;
          Rn(e) || ft(!1);
          var b = t.payload.client;
          return Et(b, e.current.client.selection) ? e : zn({
            state: e,
            clientSelection: b,
            impact: Kn(e) ? e.impact : null
          });
        }
        if ("UPDATE_DROPPABLE_SCROLL" === t.type) {
          if ("DROP_PENDING" === e.phase) return Yn(e);
          if ("COLLECTING" === e.phase) return Yn(e);
          Rn(e) || ft(!1);
          var h = t.payload,
            y = h.id,
            w = h.newScroll,
            x = e.dimensions.droppables[y];
          if (!x) return e;
          var E = Rt(x, w);
          return Qn(e, E, !1);
        }
        if ("UPDATE_DROPPABLE_IS_ENABLED" === t.type) {
          if ("DROP_PENDING" === e.phase) return e;
          Rn(e) || ft(!1);
          var C = t.payload,
            S = C.id,
            T = C.isEnabled,
            O = e.dimensions.droppables[S];
          O || ft(!1), O.isEnabled === T && ft(!1);
          var k = g({}, O, {
            isEnabled: T
          });
          return Qn(e, k, !0);
        }
        if ("UPDATE_DROPPABLE_IS_COMBINE_ENABLED" === t.type) {
          if ("DROP_PENDING" === e.phase) return e;
          Rn(e) || ft(!1);
          var P = t.payload,
            D = P.id,
            I = P.isCombineEnabled,
            N = e.dimensions.droppables[D];
          N || ft(!1), N.isCombineEnabled === I && ft(!1);
          var R = g({}, N, {
            isCombineEnabled: I
          });
          return Qn(e, R, !0);
        }
        if ("MOVE_BY_WINDOW_SCROLL" === t.type) {
          if ("DROP_PENDING" === e.phase || "DROP_ANIMATING" === e.phase) return e;
          Rn(e) || ft(!1), e.isWindowScrollAllowed || ft(!1);
          var _ = t.payload.newScroll;
          if (Et(e.viewport.scroll.current, _)) return Yn(e);
          var A = hn(e.viewport, _);
          return Kn(e) ? Wn({
            state: e,
            viewport: A
          }) : zn({
            state: e,
            viewport: A
          });
        }
        if ("UPDATE_VIEWPORT_MAX_SCROLL" === t.type) {
          if (!Rn(e)) return e;
          var L = t.payload.maxScroll;
          if (Et(L, e.viewport.scroll.max)) return e;
          var j = g({}, e.viewport, {
            scroll: g({}, e.viewport.scroll, {
              max: L
            })
          });
          return g({
            phase: "DRAGGING"
          }, e, {
            viewport: j
          });
        }
        if ("MOVE_UP" === t.type || "MOVE_DOWN" === t.type || "MOVE_LEFT" === t.type || "MOVE_RIGHT" === t.type) {
          if ("COLLECTING" === e.phase || "DROP_PENDING" === e.phase) return e;
          "DRAGGING" !== e.phase && ft(!1);
          var M = Nn({
            state: e,
            type: t.type
          });
          return M ? zn({
            state: e,
            impact: M.impact,
            clientSelection: M.clientSelection,
            scrollJumpRequest: M.scrollJumpRequest
          }) : e;
        }
        if ("DROP_PENDING" === t.type) {
          var B,
            F = t.payload.reason;
          return "COLLECTING" !== e.phase && ft(!1), g({
            phase: "DROP_PENDING"
          }, e, ((B = {}).phase = "DROP_PENDING", B.isWaiting = !0, B.reason = F, B));
        }
        if ("DROP_ANIMATE" === t.type) {
          var z = t.payload,
            U = z.completed,
            G = z.dropDuration,
            W = z.newHomeClientOffset;
          return "DRAGGING" !== e.phase && "DROP_PENDING" !== e.phase && ft(!1), {
            phase: "DROP_ANIMATING",
            completed: U,
            dropDuration: G,
            newHomeClientOffset: W,
            dimensions: e.dimensions
          };
        }
        return "DROP_COMPLETE" === t.type ? {
          phase: "IDLE",
          completed: t.payload.completed,
          shouldFlush: !1
        } : e;
      },
      Zn = function Zn(e) {
        return {
          type: "LIFT",
          payload: e
        };
      },
      er = function er(e) {
        return {
          type: "PUBLISH_WHILE_DRAGGING",
          payload: e
        };
      },
      tr = function tr() {
        return {
          type: "COLLECTION_STARTING",
          payload: null
        };
      },
      nr = function nr(e) {
        return {
          type: "UPDATE_DROPPABLE_SCROLL",
          payload: e
        };
      },
      rr = function rr(e) {
        return {
          type: "UPDATE_DROPPABLE_IS_ENABLED",
          payload: e
        };
      },
      ir = function ir(e) {
        return {
          type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
          payload: e
        };
      },
      or = function or(e) {
        return {
          type: "MOVE",
          payload: e
        };
      },
      ar = function ar() {
        return {
          type: "MOVE_UP",
          payload: null
        };
      },
      lr = function lr() {
        return {
          type: "MOVE_DOWN",
          payload: null
        };
      },
      ur = function ur() {
        return {
          type: "MOVE_RIGHT",
          payload: null
        };
      },
      cr = function cr() {
        return {
          type: "MOVE_LEFT",
          payload: null
        };
      },
      sr = function sr() {
        return {
          type: "FLUSH",
          payload: null
        };
      },
      dr = function dr(e) {
        return {
          type: "DROP_COMPLETE",
          payload: e
        };
      },
      fr = function fr(e) {
        return {
          type: "DROP",
          payload: e
        };
      },
      pr = function pr() {
        return {
          type: "DROP_ANIMATION_FINISHED",
          payload: null
        };
      };
    var mr = {
        outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
        drop: "cubic-bezier(.2,1,.1,1)"
      },
      gr = {
        opacity: {
          drop: 0,
          combining: .7
        },
        scale: {
          drop: .75
        }
      },
      vr = .33,
      br = .55,
      hr = .2 + "s " + mr.outOfTheWay,
      yr = {
        fluid: "opacity " + hr,
        snap: "transform " + hr + ", opacity " + hr,
        drop: function drop(e) {
          var t = e + "s " + mr.drop;
          return "transform " + t + ", opacity " + t;
        },
        outOfTheWay: "transform " + hr,
        placeholder: "height " + hr + ", width " + hr + ", margin " + hr
      },
      wr = function wr(e) {
        return Et(e, yt) ? null : "translate(" + e.x + "px, " + e.y + "px)";
      },
      xr = {
        moveTo: wr,
        drop: function drop(e, t) {
          var n = wr(e);
          return n ? t ? n + " scale(" + gr.scale.drop + ")" : n : null;
        }
      },
      Er = vr,
      Cr = br,
      Sr = Cr - Er,
      Tr = function Tr(e) {
        var t = e.getState,
          n = e.dispatch;
        return function (e) {
          return function (r) {
            if ("DROP" === r.type) {
              var i = t(),
                o = r.payload.reason;
              if ("COLLECTING" !== i.phase) {
                if ("IDLE" !== i.phase) {
                  "DROP_PENDING" === i.phase && i.isWaiting && ft(!1), "DRAGGING" !== i.phase && "DROP_PENDING" !== i.phase && ft(!1);
                  var a = i.critical,
                    l = i.dimensions,
                    u = l.draggables[i.critical.draggable.id],
                    c = function (e) {
                      var t = e.draggables,
                        n = e.reason,
                        r = e.lastImpact,
                        i = e.home,
                        o = e.viewport,
                        a = e.onLiftImpact;
                      return r.at && "DROP" === n ? "REORDER" === r.at.type ? {
                        impact: r,
                        didDropInsideDroppable: !0
                      } : {
                        impact: g({}, r, {
                          displaced: $t
                        }),
                        didDropInsideDroppable: !0
                      } : {
                        impact: Un({
                          draggables: t,
                          impact: a,
                          destination: i,
                          viewport: o,
                          forceShouldAnimate: !0
                        }),
                        didDropInsideDroppable: !1
                      };
                    }({
                      reason: o,
                      lastImpact: i.impact,
                      afterCritical: i.afterCritical,
                      onLiftImpact: i.onLiftImpact,
                      home: i.dimensions.droppables[i.critical.droppable.id],
                      viewport: i.viewport,
                      draggables: i.dimensions.draggables
                    }),
                    s = c.impact,
                    d = c.didDropInsideDroppable,
                    f = d ? Gt(s) : null,
                    p = d ? Wt(s) : null,
                    m = {
                      index: a.draggable.index,
                      droppableId: a.droppable.id
                    },
                    v = {
                      draggableId: u.descriptor.id,
                      type: u.descriptor.type,
                      source: m,
                      reason: o,
                      mode: i.movementMode,
                      destination: f,
                      combine: p
                    },
                    b = function (e) {
                      var t = e.impact,
                        n = e.draggable,
                        r = e.dimensions,
                        i = e.viewport,
                        o = e.afterCritical,
                        a = r.draggables,
                        l = r.droppables,
                        u = In(t),
                        c = u ? l[u] : null,
                        s = l[n.descriptor.droppableId],
                        d = Gn({
                          impact: t,
                          draggable: n,
                          draggables: a,
                          afterCritical: o,
                          droppable: c || s,
                          viewport: i
                        });
                      return xt(d, n.client.borderBox.center);
                    }({
                      impact: s,
                      draggable: u,
                      dimensions: l,
                      viewport: i.viewport,
                      afterCritical: i.afterCritical
                    }),
                    h = {
                      critical: i.critical,
                      afterCritical: i.afterCritical,
                      result: v,
                      impact: s
                    };
                  if (!Et(i.current.client.offset, b) || Boolean(v.combine)) {
                    var y = function (e) {
                      var t = e.current,
                        n = e.destination,
                        r = e.reason,
                        i = Tt(t, n);
                      if (i <= 0) return Er;
                      if (i >= 1500) return Cr;
                      var o = Er + Sr * (i / 1500);
                      return Number(("CANCEL" === r ? .6 * o : o).toFixed(2));
                    }({
                      current: i.current.client.offset,
                      destination: b,
                      reason: o
                    });
                    n(function (e) {
                      return {
                        type: "DROP_ANIMATE",
                        payload: e
                      };
                    }({
                      newHomeClientOffset: b,
                      dropDuration: y,
                      completed: h
                    }));
                  } else n(dr({
                    completed: h
                  }));
                }
              } else n(function (e) {
                return {
                  type: "DROP_PENDING",
                  payload: e
                };
              }({
                reason: o
              }));
            } else e(r);
          };
        };
      },
      Or = function Or() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      };
    function kr(e) {
      var t = e.onWindowScroll;
      var n,
        r = Ye(function () {
          t(Or());
        }),
        i = (n = r, {
          eventName: "scroll",
          options: {
            passive: !0,
            capture: !1
          },
          fn: function fn(e) {
            e.target !== window && e.target !== window.document || n();
          }
        }),
        o = lt;
      function a() {
        return o !== lt;
      }
      return {
        start: function start() {
          a() && ft(!1), o = ut(window, [i]);
        },
        stop: function stop() {
          a() || ft(!1), r.cancel(), o(), o = lt;
        },
        isActive: a
      };
    }
    var Pr = function Pr(e) {
        var t = kr({
          onWindowScroll: function onWindowScroll(t) {
            e.dispatch({
              type: "MOVE_BY_WINDOW_SCROLL",
              payload: {
                newScroll: t
              }
            });
          }
        });
        return function (e) {
          return function (n) {
            t.isActive() || "INITIAL_PUBLISH" !== n.type || t.start(), t.isActive() && function (e) {
              return "DROP_COMPLETE" === e.type || "DROP_ANIMATE" === e.type || "FLUSH" === e.type;
            }(n) && t.stop(), e(n);
          };
        };
      },
      Dr = function Dr() {
        var e = [];
        return {
          add: function add(t) {
            var n = setTimeout(function () {
                return function (t) {
                  var n = At(e, function (e) {
                    return e.timerId === t;
                  });
                  -1 === n && ft(!1), e.splice(n, 1)[0].callback();
                }(n);
              }),
              r = {
                timerId: n,
                callback: t
              };
            e.push(r);
          },
          flush: function flush() {
            if (e.length) {
              var t = [].concat(e);
              e.length = 0, t.forEach(function (e) {
                clearTimeout(e.timerId), e.callback();
              });
            }
          }
        };
      },
      Ir = function Ir(e, t) {
        Vn(e), t(), qn(e);
      },
      Nr = function Nr(e, t) {
        return {
          draggableId: e.draggable.id,
          type: e.droppable.type,
          source: {
            droppableId: e.droppable.id,
            index: e.draggable.index
          },
          mode: t
        };
      },
      Rr = function Rr(e, t, n, r) {
        if (e) {
          var i = function (e) {
            var t = !1,
              n = !1,
              r = setTimeout(function () {
                n = !0;
              }),
              i = function i(_i2) {
                t || n || (t = !0, e(_i2), clearTimeout(r));
              };
            return i.wasCalled = function () {
              return t;
            }, i;
          }(n);
          e(t, {
            announce: i
          }), i.wasCalled() || n(r(t));
        } else n(r(t));
      },
      _r = function _r(e, t) {
        var n = function (e, t) {
          var n = Dr(),
            r = null,
            i = function i(n) {
              r || ft(!1), r = null, Ir("onDragEnd", function () {
                return Rr(e().onDragEnd, n, t, ht.onDragEnd);
              });
            };
          return {
            beforeCapture: function beforeCapture(t, n) {
              r && ft(!1), Ir("onBeforeCapture", function () {
                var r = e().onBeforeCapture;
                r && r({
                  draggableId: t,
                  mode: n
                });
              });
            },
            beforeStart: function beforeStart(t, n) {
              r && ft(!1), Ir("onBeforeDragStart", function () {
                var r = e().onBeforeDragStart;
                r && r(Nr(t, n));
              });
            },
            start: function start(i, o) {
              r && ft(!1);
              var a = Nr(i, o);
              r = {
                mode: o,
                lastCritical: i,
                lastLocation: a.source,
                lastCombine: null
              }, n.add(function () {
                Ir("onDragStart", function () {
                  return Rr(e().onDragStart, a, t, ht.onDragStart);
                });
              });
            },
            update: function update(i, o) {
              var a = Gt(o),
                l = Wt(o);
              r || ft(!1);
              var u = !function (e, t) {
                if (e === t) return !0;
                var n = e.draggable.id === t.draggable.id && e.draggable.droppableId === t.draggable.droppableId && e.draggable.type === t.draggable.type && e.draggable.index === t.draggable.index,
                  r = e.droppable.id === t.droppable.id && e.droppable.type === t.droppable.type;
                return n && r;
              }(i, r.lastCritical);
              u && (r.lastCritical = i);
              var c,
                s,
                d = (c = r.lastLocation, s = a, !(null == c && null == s || null != c && null != s && c.droppableId === s.droppableId && c.index === s.index));
              d && (r.lastLocation = a);
              var f = !function (e, t) {
                return null == e && null == t || null != e && null != t && e.draggableId === t.draggableId && e.droppableId === t.droppableId;
              }(r.lastCombine, l);
              if (f && (r.lastCombine = l), u || d || f) {
                var p = g({}, Nr(i, r.mode), {
                  combine: l,
                  destination: a
                });
                n.add(function () {
                  Ir("onDragUpdate", function () {
                    return Rr(e().onDragUpdate, p, t, ht.onDragUpdate);
                  });
                });
              }
            },
            flush: function flush() {
              r || ft(!1), n.flush();
            },
            drop: i,
            abort: function abort() {
              if (r) {
                var e = g({}, Nr(r.lastCritical, r.mode), {
                  combine: null,
                  destination: null,
                  reason: "CANCEL"
                });
                i(e);
              }
            }
          };
        }(e, t);
        return function (e) {
          return function (t) {
            return function (r) {
              if ("BEFORE_INITIAL_CAPTURE" !== r.type) {
                if ("INITIAL_PUBLISH" === r.type) {
                  var i = r.payload.critical;
                  return n.beforeStart(i, r.payload.movementMode), t(r), void n.start(i, r.payload.movementMode);
                }
                if ("DROP_COMPLETE" === r.type) {
                  var o = r.payload.completed.result;
                  return n.flush(), t(r), void n.drop(o);
                }
                if (t(r), "FLUSH" !== r.type) {
                  var a = e.getState();
                  "DRAGGING" === a.phase && n.update(a.critical, a.impact);
                } else n.abort();
              } else n.beforeCapture(r.payload.draggableId, r.payload.movementMode);
            };
          };
        };
      },
      Ar = function Ar(e) {
        return function (t) {
          return function (n) {
            if ("DROP_ANIMATION_FINISHED" === n.type) {
              var r = e.getState();
              "DROP_ANIMATING" !== r.phase && ft(!1), e.dispatch(dr({
                completed: r.completed
              }));
            } else t(n);
          };
        };
      },
      Lr = function Lr(e) {
        var t = null,
          n = null;
        return function (r) {
          return function (i) {
            if ("FLUSH" !== i.type && "DROP_COMPLETE" !== i.type && "DROP_ANIMATION_FINISHED" !== i.type || (n && (cancelAnimationFrame(n), n = null), t && (t(), t = null)), r(i), "DROP_ANIMATE" === i.type) {
              var o = {
                eventName: "scroll",
                options: {
                  capture: !0,
                  passive: !1,
                  once: !0
                },
                fn: function fn() {
                  "DROP_ANIMATING" === e.getState().phase && e.dispatch({
                    type: "DROP_ANIMATION_FINISHED",
                    payload: null
                  });
                }
              };
              n = requestAnimationFrame(function () {
                n = null, t = ut(window, [o]);
              });
            }
          };
        };
      },
      jr = function jr(e) {
        return function (t) {
          return function (n) {
            if (t(n), "PUBLISH_WHILE_DRAGGING" === n.type) {
              var r = e.getState();
              "DROP_PENDING" === r.phase && (r.isWaiting || e.dispatch(fr({
                reason: r.reason
              })));
            }
          };
        };
      },
      Mr = O,
      Br = function Br(e) {
        var t,
          n = e.dimensionMarshal,
          r = e.focusMarshal,
          i = e.styleMarshal,
          o = e.getResponders,
          a = e.announce,
          l = e.autoScroller;
        return w(Jn, Mr(function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return function (e) {
            return function () {
              var n = e.apply(void 0, arguments),
                r = function r() {
                  throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
                },
                i = {
                  getState: n.getState,
                  dispatch: function dispatch() {
                    return r.apply(void 0, arguments);
                  }
                },
                o = t.map(function (e) {
                  return e(i);
                });
              return T({}, n, {
                dispatch: r = O.apply(void 0, o)(n.dispatch)
              });
            };
          };
        }((t = i, function () {
          return function (e) {
            return function (n) {
              "INITIAL_PUBLISH" === n.type && t.dragging(), "DROP_ANIMATE" === n.type && t.dropping(n.payload.completed.result.reason), "FLUSH" !== n.type && "DROP_COMPLETE" !== n.type || t.resting(), e(n);
            };
          };
        }), function (e) {
          return function () {
            return function (t) {
              return function (n) {
                "DROP_COMPLETE" !== n.type && "FLUSH" !== n.type && "DROP_ANIMATE" !== n.type || e.stopPublishing(), t(n);
              };
            };
          };
        }(n), function (e) {
          return function (t) {
            var n = t.getState,
              r = t.dispatch;
            return function (t) {
              return function (i) {
                if ("LIFT" === i.type) {
                  var o = i.payload,
                    a = o.id,
                    l = o.clientSelection,
                    u = o.movementMode,
                    c = n();
                  "DROP_ANIMATING" === c.phase && r(dr({
                    completed: c.completed
                  })), "IDLE" !== n().phase && ft(!1), r(sr()), r({
                    type: "BEFORE_INITIAL_CAPTURE",
                    payload: {
                      draggableId: a,
                      movementMode: u
                    }
                  });
                  var s = {
                      draggableId: a,
                      scrollOptions: {
                        shouldPublishImmediately: "SNAP" === u
                      }
                    },
                    d = e.startPublishing(s),
                    f = d.critical,
                    p = d.dimensions,
                    m = d.viewport;
                  r(function (e) {
                    return {
                      type: "INITIAL_PUBLISH",
                      payload: e
                    };
                  }({
                    critical: f,
                    dimensions: p,
                    clientSelection: l,
                    movementMode: u,
                    viewport: m
                  }));
                } else t(i);
              };
            };
          };
        }(n), Tr, Ar, Lr, jr, function (e) {
          return function (t) {
            return function (n) {
              return function (r) {
                if (function (e) {
                  return "DROP_COMPLETE" === e.type || "DROP_ANIMATE" === e.type || "FLUSH" === e.type;
                }(r)) return e.stop(), void n(r);
                if ("INITIAL_PUBLISH" === r.type) {
                  n(r);
                  var i = t.getState();
                  return "DRAGGING" !== i.phase && ft(!1), void e.start(i);
                }
                n(r), e.scroll(t.getState());
              };
            };
          };
        }(l), Pr, function (e) {
          var t = !1;
          return function () {
            return function (n) {
              return function (r) {
                if ("INITIAL_PUBLISH" === r.type) return t = !0, e.tryRecordFocus(r.payload.critical.draggable.id), n(r), void e.tryRestoreFocusRecorded();
                if (n(r), t) {
                  if ("FLUSH" === r.type) return t = !1, void e.tryRestoreFocusRecorded();
                  if ("DROP_COMPLETE" === r.type) {
                    t = !1;
                    var i = r.payload.completed.result;
                    i.combine && e.tryShiftRecord(i.draggableId, i.combine.draggableId), e.tryRestoreFocusRecorded();
                  }
                }
              };
            };
          };
        }(r), _r(o, a))));
      },
      Fr = function Fr() {
        return {
          additions: {},
          removals: {},
          modified: {}
        };
      },
      zr = "Publish collection from DOM";
    var Ur = function Ur(e) {
        var t = e.scrollHeight,
          n = e.scrollWidth,
          r = e.height,
          i = e.width,
          o = xt({
            x: n,
            y: t
          }, {
            x: i,
            y: r
          });
        return {
          x: Math.max(0, o.x),
          y: Math.max(0, o.y)
        };
      },
      Gr = function Gr() {
        var e = document.documentElement;
        return e || ft(!1), e;
      },
      Wr = function Wr() {
        var e = Gr();
        return Ur({
          scrollHeight: e.scrollHeight,
          scrollWidth: e.scrollWidth,
          width: e.clientWidth,
          height: e.clientHeight
        });
      },
      Hr = function Hr(e) {
        var t = e.critical,
          n = e.scrollOptions,
          r = e.registry;
        Vn("Initial collection from DOM");
        var i,
          o,
          a,
          l,
          u,
          c,
          s,
          d = (i = Or(), o = Wr(), a = i.y, l = i.x, u = Gr(), c = u.clientWidth, s = u.clientHeight, {
            frame: Ae({
              top: a,
              left: l,
              right: l + c,
              bottom: a + s
            }),
            scroll: {
              initial: i,
              current: i,
              max: o,
              diff: {
                value: yt,
                displacement: yt
              }
            }
          }),
          f = d.scroll.current,
          p = t.droppable,
          m = r.droppable.getAllByType(p.type).map(function (e) {
            return e.callbacks.getDimensionAndWatchScroll(f, n);
          }),
          g = r.draggable.getAllByType(t.draggable.type).map(function (e) {
            return e.getDimension(f);
          }),
          v = {
            draggables: Bt(g),
            droppables: Mt(m)
          };
        return qn("Initial collection from DOM"), {
          dimensions: v,
          critical: t,
          viewport: d
        };
      };
    function Vr(e, t, n) {
      return n.descriptor.id !== t.id && n.descriptor.type === t.type && "virtual" === e.droppable.getById(n.descriptor.droppableId).descriptor.mode;
    }
    var qr,
      $r,
      Kr = function Kr(e, t) {
        var n = null,
          r = function (e) {
            var t = e.registry,
              n = e.callbacks,
              r = Fr(),
              i = null,
              o = function o() {
                i || (n.collectionStarting(), i = requestAnimationFrame(function () {
                  i = null, Vn(zr);
                  var e = r,
                    o = e.additions,
                    a = e.removals,
                    l = e.modified,
                    u = Qe()(o).map(function (e) {
                      return t.draggable.getById(e).getDimension(yt);
                    }).sort(function (e, t) {
                      return e.descriptor.index - t.descriptor.index;
                    }),
                    c = Qe()(l).map(function (e) {
                      return {
                        droppableId: e,
                        scroll: t.droppable.getById(e).callbacks.getScrollWhileDragging()
                      };
                    }),
                    s = {
                      additions: u,
                      removals: Qe()(a),
                      modified: c
                    };
                  r = Fr(), qn(zr), n.publish(s);
                }));
              };
            return {
              add: function add(e) {
                var t = e.descriptor.id;
                r.additions[t] = e, r.modified[e.descriptor.droppableId] = !0, r.removals[t] && delete r.removals[t], o();
              },
              remove: function remove(e) {
                var t = e.descriptor;
                r.removals[t.id] = !0, r.modified[t.droppableId] = !0, r.additions[t.id] && delete r.additions[t.id], o();
              },
              stop: function stop() {
                i && (cancelAnimationFrame(i), i = null, r = Fr());
              }
            };
          }({
            callbacks: {
              publish: t.publishWhileDragging,
              collectionStarting: t.collectionStarting
            },
            registry: e
          }),
          i = function i(t) {
            n || ft(!1);
            var i = n.critical.draggable;
            "ADDITION" === t.type && Vr(e, i, t.value) && r.add(t.value), "REMOVAL" === t.type && Vr(e, i, t.value) && r.remove(t.value);
          };
        return {
          updateDroppableIsEnabled: function updateDroppableIsEnabled(r, i) {
            e.droppable.exists(r) || ft(!1), n && t.updateDroppableIsEnabled({
              id: r,
              isEnabled: i
            });
          },
          updateDroppableIsCombineEnabled: function updateDroppableIsCombineEnabled(r, i) {
            n && (e.droppable.exists(r) || ft(!1), t.updateDroppableIsCombineEnabled({
              id: r,
              isCombineEnabled: i
            }));
          },
          scrollDroppable: function scrollDroppable(t, r) {
            n && e.droppable.getById(t).callbacks.scroll(r);
          },
          updateDroppableScroll: function updateDroppableScroll(r, i) {
            n && (e.droppable.exists(r) || ft(!1), t.updateDroppableScroll({
              id: r,
              newScroll: i
            }));
          },
          startPublishing: function startPublishing(t) {
            n && ft(!1);
            var r = e.draggable.getById(t.draggableId),
              o = e.droppable.getById(r.descriptor.droppableId),
              a = {
                draggable: r.descriptor,
                droppable: o.descriptor
              },
              l = e.subscribe(i);
            return n = {
              critical: a,
              unsubscribe: l
            }, Hr({
              critical: a,
              registry: e,
              scrollOptions: t.scrollOptions
            });
          },
          stopPublishing: function stopPublishing() {
            if (n) {
              r.stop();
              var t = n.critical.droppable;
              e.droppable.getAllByType(t.type).forEach(function (e) {
                return e.callbacks.dragStopped();
              }), n.unsubscribe(), n = null;
            }
          }
        };
      },
      Qr = function Qr(e, t) {
        return "IDLE" === e.phase || "DROP_ANIMATING" === e.phase && e.completed.result.draggableId !== t && "DROP" === e.completed.result.reason;
      },
      Yr = function Yr(e) {
        window.scrollBy(e.x, e.y);
      },
      Xr = Ve(function (e) {
        return Ft(e).filter(function (e) {
          return !!e.isEnabled && !!e.frame;
        });
      }),
      Jr = function Jr(e) {
        var t = e.center,
          n = e.destination,
          r = e.droppables;
        if (n) {
          var i = r[n];
          return i.frame ? i : null;
        }
        return function (e, t) {
          return Lt(Xr(t), function (t) {
            return t.frame || ft(!1), _n(t.frame.pageMarginBox)(e);
          });
        }(t, r);
      },
      Zr = .25,
      ei = .05,
      ti = 28,
      ni = function ni(e) {
        return Math.pow(e, 2);
      },
      ri = {
        stopDampeningAt: 1200,
        accelerateAt: 360
      },
      ii = function ii(e) {
        var t = e.startOfRange,
          n = e.endOfRange,
          r = e.current,
          i = n - t;
        return 0 === i ? 0 : (r - t) / i;
      },
      oi = ri.accelerateAt,
      ai = ri.stopDampeningAt,
      li = function li(e) {
        var t = e.distanceToEdge,
          n = e.thresholds,
          r = e.dragStartTime,
          i = e.shouldUseTimeDampening,
          o = function (e, t) {
            if (e > t.startScrollingFrom) return 0;
            if (e <= t.maxScrollValueAt) return ti;
            if (e === t.startScrollingFrom) return 1;
            var n = ii({
                startOfRange: t.maxScrollValueAt,
                endOfRange: t.startScrollingFrom,
                current: e
              }),
              r = ti * ni(1 - n);
            return Math.ceil(r);
          }(t, n);
        return 0 === o ? 0 : i ? Math.max(function (e, t) {
          var n = t,
            r = ai,
            i = Je()() - n;
          if (i >= ai) return e;
          if (i < oi) return 1;
          var o = ii({
              startOfRange: oi,
              endOfRange: r,
              current: i
            }),
            a = e * ni(o);
          return Math.ceil(a);
        }(o, r), 1) : o;
      },
      ui = function ui(e) {
        var t = e.container,
          n = e.distanceToEdges,
          r = e.dragStartTime,
          i = e.axis,
          o = e.shouldUseTimeDampening,
          a = function (e, t) {
            return {
              startScrollingFrom: e[t.size] * Zr,
              maxScrollValueAt: e[t.size] * ei
            };
          }(t, i);
        return n[i.end] < n[i.start] ? li({
          distanceToEdge: n[i.end],
          thresholds: a,
          dragStartTime: r,
          shouldUseTimeDampening: o
        }) : -1 * li({
          distanceToEdge: n[i.start],
          thresholds: a,
          dragStartTime: r,
          shouldUseTimeDampening: o
        });
      },
      ci = kt(function (e) {
        return 0 === e ? 0 : e;
      }),
      si = function si(e) {
        var t = e.dragStartTime,
          n = e.container,
          r = e.subject,
          i = e.center,
          o = e.shouldUseTimeDampening,
          a = {
            top: i.y - n.top,
            right: n.right - i.x,
            bottom: n.bottom - i.y,
            left: i.x - n.left
          },
          l = ui({
            container: n,
            distanceToEdges: a,
            dragStartTime: t,
            axis: Jt,
            shouldUseTimeDampening: o
          }),
          u = ui({
            container: n,
            distanceToEdges: a,
            dragStartTime: t,
            axis: Zt,
            shouldUseTimeDampening: o
          }),
          c = ci({
            x: u,
            y: l
          });
        if (Et(c, yt)) return null;
        var s = function (e) {
          var t = e.container,
            n = e.subject,
            r = e.proposedScroll,
            i = n.height > t.height,
            o = n.width > t.width;
          return o || i ? o && i ? null : {
            x: o ? 0 : r.x,
            y: i ? 0 : r.y
          } : r;
        }({
          container: n,
          subject: r,
          proposedScroll: c
        });
        return s ? Et(s, yt) ? null : s : null;
      },
      di = kt(function (e) {
        return 0 === e ? 0 : e > 0 ? 1 : -1;
      }),
      fi = (qr = function qr(e, t) {
        return e < 0 ? e : e > t ? e - t : 0;
      }, function (e) {
        var t = e.current,
          n = e.max,
          r = e.change,
          i = wt(t, r),
          o = {
            x: qr(i.x, n.x),
            y: qr(i.y, n.y)
          };
        return Et(o, yt) ? null : o;
      }),
      pi = function pi(e) {
        var t = e.max,
          n = e.current,
          r = e.change,
          i = {
            x: Math.max(n.x, t.x),
            y: Math.max(n.y, t.y)
          },
          o = di(r),
          a = fi({
            max: i,
            current: n,
            change: o
          });
        return !a || 0 !== o.x && 0 === a.x || 0 !== o.y && 0 === a.y;
      },
      mi = function mi(e, t) {
        return pi({
          current: e.scroll.current,
          max: e.scroll.max,
          change: t
        });
      },
      gi = function gi(e, t) {
        var n = e.frame;
        return !!n && pi({
          current: n.scroll.current,
          max: n.scroll.max,
          change: t
        });
      },
      vi = function vi(e) {
        var t = e.state,
          n = e.dragStartTime,
          r = e.shouldUseTimeDampening,
          i = e.scrollWindow,
          o = e.scrollDroppable,
          a = t.current.page.borderBoxCenter,
          l = t.dimensions.draggables[t.critical.draggable.id].page.marginBox;
        if (t.isWindowScrollAllowed) {
          var u = function (e) {
            var t = e.viewport,
              n = e.subject,
              r = e.center,
              i = e.dragStartTime,
              o = e.shouldUseTimeDampening,
              a = si({
                dragStartTime: i,
                container: t.frame,
                subject: n,
                center: r,
                shouldUseTimeDampening: o
              });
            return a && mi(t, a) ? a : null;
          }({
            dragStartTime: n,
            viewport: t.viewport,
            subject: l,
            center: a,
            shouldUseTimeDampening: r
          });
          if (u) return void i(u);
        }
        var c = Jr({
          center: a,
          destination: In(t.impact),
          droppables: t.dimensions.droppables
        });
        if (c) {
          var s = function (e) {
            var t = e.droppable,
              n = e.subject,
              r = e.center,
              i = e.dragStartTime,
              o = e.shouldUseTimeDampening,
              a = t.frame;
            if (!a) return null;
            var l = si({
              dragStartTime: i,
              container: a.pageMarginBox,
              subject: n,
              center: r,
              shouldUseTimeDampening: o
            });
            return l && gi(t, l) ? l : null;
          }({
            dragStartTime: n,
            droppable: c,
            subject: l,
            center: a,
            shouldUseTimeDampening: r
          });
          s && o(c.descriptor.id, s);
        }
      },
      bi = function bi(e) {
        var t = e.move,
          n = e.scrollDroppable,
          r = e.scrollWindow,
          i = function i(e, t) {
            if (!gi(e, t)) return t;
            var r = function (e, t) {
              var n = e.frame;
              return n && gi(e, t) ? fi({
                current: n.scroll.current,
                max: n.scroll.max,
                change: t
              }) : null;
            }(e, t);
            if (!r) return n(e.descriptor.id, t), null;
            var i = xt(t, r);
            return n(e.descriptor.id, i), xt(t, i);
          },
          o = function o(e, t, n) {
            if (!e) return n;
            if (!mi(t, n)) return n;
            var i = function (e, t) {
              if (!mi(e, t)) return null;
              var n = e.scroll.max,
                r = e.scroll.current;
              return fi({
                current: r,
                max: n,
                change: t
              });
            }(t, n);
            if (!i) return r(n), null;
            var o = xt(n, i);
            return r(o), xt(n, o);
          };
        return function (e) {
          var n = e.scrollJumpRequest;
          if (n) {
            var r = In(e.impact);
            r || ft(!1);
            var a = i(e.dimensions.droppables[r], n);
            if (a) {
              var l = e.viewport,
                u = o(e.isWindowScrollAllowed, l, a);
              u && function (e, n) {
                var r = wt(e.current.client.selection, n);
                t({
                  client: r
                });
              }(e, u);
            }
          }
        };
      },
      hi = function hi(e) {
        var t = e.scrollDroppable,
          n = e.scrollWindow,
          r = e.move,
          i = function (e) {
            var t = e.scrollWindow,
              n = e.scrollDroppable,
              r = Ye(t),
              i = Ye(n),
              o = null,
              a = function a(e) {
                o || ft(!1);
                var t = o,
                  n = t.shouldUseTimeDampening,
                  a = t.dragStartTime;
                vi({
                  state: e,
                  scrollWindow: r,
                  scrollDroppable: i,
                  dragStartTime: a,
                  shouldUseTimeDampening: n
                });
              };
            return {
              start: function start(e) {
                Vn("starting fluid scroller"), o && ft(!1);
                var t = Je()(),
                  n = !1,
                  r = function r() {
                    n = !0;
                  };
                vi({
                  state: e,
                  dragStartTime: 0,
                  shouldUseTimeDampening: !1,
                  scrollWindow: r,
                  scrollDroppable: r
                }), o = {
                  dragStartTime: t,
                  shouldUseTimeDampening: n
                }, qn("starting fluid scroller"), n && a(e);
              },
              stop: function stop() {
                o && (r.cancel(), i.cancel(), o = null);
              },
              scroll: a
            };
          }({
            scrollWindow: n,
            scrollDroppable: t
          }),
          o = bi({
            move: r,
            scrollWindow: n,
            scrollDroppable: t
          });
        return {
          scroll: function scroll(e) {
            "DRAGGING" === e.phase && ("FLUID" !== e.movementMode ? e.scrollJumpRequest && o(e) : i.scroll(e));
          },
          start: i.start,
          stop: i.stop
        };
      },
      yi = "data-rbd",
      wi = {
        base: $r = yi + "-drag-handle",
        draggableId: $r + "-draggable-id",
        contextId: $r + "-context-id"
      },
      xi = function () {
        var e = yi + "-draggable";
        return {
          base: e,
          contextId: e + "-context-id",
          id: e + "-id"
        };
      }(),
      Ei = function () {
        var e = yi + "-droppable";
        return {
          base: e,
          contextId: e + "-context-id",
          id: e + "-id"
        };
      }(),
      Ci = {
        contextId: yi + "-scroll-container-context-id"
      },
      Si = function Si(e, t) {
        return e.map(function (e) {
          var n = e.styles[t];
          return n ? e.selector + " { " + n + " }" : "";
        }).join(" ");
      },
      Ti = function Ti(e) {
        var t,
          n,
          r,
          i = (t = e, function (e) {
            return "[" + e + '="' + t + '"]';
          }),
          o = (n = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ", {
            selector: i(wi.contextId),
            styles: {
              always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
              resting: n,
              dragging: "pointer-events: none;",
              dropAnimating: n
            }
          }),
          a = [(r = "\n      transition: " + yr.outOfTheWay + ";\n    ", {
            selector: i(xi.contextId),
            styles: {
              dragging: r,
              dropAnimating: r,
              userCancel: r
            }
          }), o, {
            selector: i(Ei.contextId),
            styles: {
              always: "overflow-anchor: none;"
            }
          }, {
            selector: "body",
            styles: {
              dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
            }
          }];
        return {
          always: Si(a, "always"),
          resting: Si(a, "resting"),
          dragging: Si(a, "dragging"),
          dropAnimating: Si(a, "dropAnimating"),
          userCancel: Si(a, "userCancel")
        };
      },
      Oi = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? r.useLayoutEffect : r.useEffect,
      ki = function ki() {
        var e = document.querySelector("head");
        return e || ft(!1), e;
      },
      Pi = function Pi(e) {
        var t = document.createElement("style");
        return e && t.setAttribute("nonce", e), t.type = "text/css", t;
      };
    var Di = function Di(e) {
      return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
    };
    function Ii(e) {
      return e instanceof Di(e).HTMLElement;
    }
    function Ni(e, t) {
      var n = "[" + wi.contextId + '="' + e + '"]',
        r = jt(document.querySelectorAll(n));
      if (!r.length) return null;
      var i = Lt(r, function (e) {
        return e.getAttribute(wi.draggableId) === t;
      });
      return i && Ii(i) ? i : null;
    }
    function Ri() {
      var e = {
          draggables: {},
          droppables: {}
        },
        t = [];
      function n(e) {
        t.length && t.forEach(function (t) {
          return t(e);
        });
      }
      function r(t) {
        return e.draggables[t] || null;
      }
      function i(t) {
        return e.droppables[t] || null;
      }
      return {
        draggable: {
          register: function register(t) {
            e.draggables[t.descriptor.id] = t, n({
              type: "ADDITION",
              value: t
            });
          },
          update: function update(t, n) {
            var r = e.draggables[n.descriptor.id];
            r && r.uniqueId === t.uniqueId && (delete e.draggables[n.descriptor.id], e.draggables[t.descriptor.id] = t);
          },
          unregister: function unregister(t) {
            var i = t.descriptor.id,
              o = r(i);
            o && t.uniqueId === o.uniqueId && (delete e.draggables[i], n({
              type: "REMOVAL",
              value: t
            }));
          },
          getById: function getById(e) {
            var t = r(e);
            return t || ft(!1), t;
          },
          findById: r,
          exists: function exists(e) {
            return Boolean(r(e));
          },
          getAllByType: function getAllByType(t) {
            return _t(e.draggables).filter(function (e) {
              return e.descriptor.type === t;
            });
          }
        },
        droppable: {
          register: function register(t) {
            e.droppables[t.descriptor.id] = t;
          },
          unregister: function unregister(t) {
            var n = i(t.descriptor.id);
            n && t.uniqueId === n.uniqueId && delete e.droppables[t.descriptor.id];
          },
          getById: function getById(e) {
            var t = i(e);
            return t || ft(!1), t;
          },
          findById: i,
          exists: function exists(e) {
            return Boolean(i(e));
          },
          getAllByType: function getAllByType(t) {
            return _t(e.droppables).filter(function (e) {
              return e.descriptor.type === t;
            });
          }
        },
        subscribe: function subscribe(e) {
          return t.push(e), function () {
            var n = t.indexOf(e);
            -1 !== n && t.splice(n, 1);
          };
        },
        clean: function clean() {
          e.draggables = {}, e.droppables = {}, t.length = 0;
        }
      };
    }
    var _i = i.a.createContext(null),
      Ai = function Ai() {
        var e = document.body;
        return e || ft(!1), e;
      },
      Li = {
        position: "absolute",
        width: "1px",
        height: "1px",
        margin: "-1px",
        border: "0",
        padding: "0",
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        "clip-path": "inset(100%)"
      },
      ji = function ji(e) {
        return "rbd-announcement-" + e;
      };
    var Mi = function Mi(e) {
      return "rbd-lift-instruction-" + e;
    };
    var Bi = i.a.createContext(null);
    function Fi(e) {
      0;
    }
    function zi(e, t) {
      Fi();
    }
    function Ui(e) {
      var t = Object(r.useRef)(e);
      return Object(r.useEffect)(function () {
        t.current = e;
      }), t;
    }
    var Gi,
      Wi = 27,
      Hi = 32,
      Vi = 37,
      qi = 38,
      $i = 39,
      Ki = 40,
      Qi = ((Gi = {})[13] = !0, Gi[9] = !0, Gi),
      Yi = function Yi(e) {
        Qi[e.keyCode] && e.preventDefault();
      },
      Xi = function () {
        var e = "visibilitychange";
        return "undefined" == typeof document ? e : Lt([e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], function (e) {
          return "on" + e in document;
        }) || e;
      }(),
      Ji = 0,
      Zi = 5;
    var eo,
      to = {
        type: "IDLE"
      };
    function no(e) {
      var t = e.cancel,
        n = e.completed,
        r = e.getPhase,
        i = e.setPhase;
      return [{
        eventName: "mousemove",
        fn: function fn(e) {
          var t = e.button,
            n = e.clientX,
            o = e.clientY;
          if (t === Ji) {
            var a = {
                x: n,
                y: o
              },
              l = r();
            if ("DRAGGING" === l.type) return e.preventDefault(), void l.actions.move(a);
            "PENDING" !== l.type && ft(!1);
            var u = l.point;
            if (c = u, s = a, Math.abs(s.x - c.x) >= Zi || Math.abs(s.y - c.y) >= Zi) {
              var c, s;
              e.preventDefault();
              var d = l.actions.fluidLift(a);
              i({
                type: "DRAGGING",
                actions: d
              });
            }
          }
        }
      }, {
        eventName: "mouseup",
        fn: function fn(e) {
          var i = r();
          "DRAGGING" === i.type ? (e.preventDefault(), i.actions.drop({
            shouldBlockNextClick: !0
          }), n()) : t();
        }
      }, {
        eventName: "mousedown",
        fn: function fn(e) {
          "DRAGGING" === r().type && e.preventDefault(), t();
        }
      }, {
        eventName: "keydown",
        fn: function fn(e) {
          if ("PENDING" !== r().type) return e.keyCode === Wi ? (e.preventDefault(), void t()) : void Yi(e);
          t();
        }
      }, {
        eventName: "resize",
        fn: t
      }, {
        eventName: "scroll",
        options: {
          passive: !0,
          capture: !1
        },
        fn: function fn() {
          "PENDING" === r().type && t();
        }
      }, {
        eventName: "webkitmouseforcedown",
        fn: function fn(e) {
          var n = r();
          "IDLE" === n.type && ft(!1), n.actions.shouldRespectForcePress() ? t() : e.preventDefault();
        }
      }, {
        eventName: Xi,
        fn: t
      }];
    }
    function ro() {}
    var io = ((eo = {})[34] = !0, eo[33] = !0, eo[36] = !0, eo[35] = !0, eo);
    function oo(e, t) {
      function n() {
        t(), e.cancel();
      }
      return [{
        eventName: "keydown",
        fn: function fn(r) {
          return r.keyCode === Wi ? (r.preventDefault(), void n()) : r.keyCode === Hi ? (r.preventDefault(), t(), void e.drop()) : r.keyCode === Ki ? (r.preventDefault(), void e.moveDown()) : r.keyCode === qi ? (r.preventDefault(), void e.moveUp()) : r.keyCode === $i ? (r.preventDefault(), void e.moveRight()) : r.keyCode === Vi ? (r.preventDefault(), void e.moveLeft()) : void (io[r.keyCode] ? r.preventDefault() : Yi(r));
        }
      }, {
        eventName: "mousedown",
        fn: n
      }, {
        eventName: "mouseup",
        fn: n
      }, {
        eventName: "click",
        fn: n
      }, {
        eventName: "touchstart",
        fn: n
      }, {
        eventName: "resize",
        fn: n
      }, {
        eventName: "wheel",
        fn: n,
        options: {
          passive: !0
        }
      }, {
        eventName: Xi,
        fn: n
      }];
    }
    var ao = {
        type: "IDLE"
      },
      lo = 120,
      uo = .15;
    var co = {
      input: !0,
      button: !0,
      textarea: !0,
      select: !0,
      option: !0,
      optgroup: !0,
      video: !0,
      audio: !0
    };
    function so(e, t) {
      var n = t.target;
      return !!Ii(n) && function e(t, n) {
        if (null == n) return !1;
        if (Boolean(co[n.tagName.toLowerCase()])) return !0;
        var r = n.getAttribute("contenteditable");
        return "true" === r || "" === r || n !== t && e(t, n.parentElement);
      }(e, n);
    }
    var fo = function fo(e) {
      return Ae(e.getBoundingClientRect()).center;
    };
    var po = "undefined" == typeof document ? "matches" : Lt(["matches", "msMatchesSelector", "webkitMatchesSelector"], function (e) {
      return e in Element.prototype;
    }) || "matches";
    function mo(e, t) {
      return e.closest ? e.closest(t) : function e(t, n) {
        return null == t ? null : t[po](n) ? t : e(t.parentElement, n);
      }(e, t);
    }
    function go(e, t) {
      var n,
        r = t.target;
      if (!((n = r) instanceof Di(n).Element)) return null;
      var i = mo(r, function (e) {
        return "[" + wi.contextId + '="' + e + '"]';
      }(e));
      return i && Ii(i) ? i : null;
    }
    function vo(e) {
      e.preventDefault();
    }
    function bo(e) {
      var t = e.expected,
        n = e.phase,
        r = e.isLockActive;
      e.shouldWarn;
      return !!r() && t === n;
    }
    function ho(e) {
      var t = e.lockAPI,
        n = e.store,
        r = e.registry,
        i = e.draggableId;
      if (t.isClaimed()) return !1;
      var o = r.draggable.findById(i);
      return !!o && !!o.options.isEnabled && !!Qr(n.getState(), i);
    }
    function yo(e) {
      var t = e.lockAPI,
        n = e.contextId,
        r = e.store,
        i = e.registry,
        o = e.draggableId,
        a = e.forceSensorStop,
        l = e.sourceEvent;
      if (!ho({
        lockAPI: t,
        store: r,
        registry: i,
        draggableId: o
      })) return null;
      var u = i.draggable.getById(o),
        c = function (e, t) {
          var n = "[" + xi.contextId + '="' + e + '"]',
            r = Lt(jt(document.querySelectorAll(n)), function (e) {
              return e.getAttribute(xi.id) === t;
            });
          return r && Ii(r) ? r : null;
        }(n, u.descriptor.id);
      if (!c) return null;
      if (l && !u.options.canDragInteractiveElements && so(c, l)) return null;
      var s = t.claim(a || lt),
        d = "PRE_DRAG";
      function f() {
        return u.options.shouldRespectForcePress;
      }
      function p() {
        return t.isActive(s);
      }
      var m = function (e, t) {
        bo({
          expected: e,
          phase: d,
          isLockActive: p,
          shouldWarn: !0
        }) && r.dispatch(t());
      }.bind(this, "DRAGGING");
      function v(e) {
        function n() {
          t.release(), d = "COMPLETED";
        }
        function i(t, i) {
          if (void 0 === i && (i = {
            shouldBlockNextClick: !1
          }), e.cleanup(), i.shouldBlockNextClick) {
            var o = ut(window, [{
              eventName: "click",
              fn: vo,
              options: {
                once: !0,
                passive: !1,
                capture: !0
              }
            }]);
            setTimeout(o);
          }
          n(), r.dispatch(fr({
            reason: t
          }));
        }
        return "PRE_DRAG" !== d && (n(), "PRE_DRAG" !== d && ft(!1)), r.dispatch(Zn(e.liftActionArgs)), d = "DRAGGING", g({
          isActive: function isActive() {
            return bo({
              expected: "DRAGGING",
              phase: d,
              isLockActive: p,
              shouldWarn: !1
            });
          },
          shouldRespectForcePress: f,
          drop: function drop(e) {
            return i("DROP", e);
          },
          cancel: function cancel(e) {
            return i("CANCEL", e);
          }
        }, e.actions);
      }
      return {
        isActive: function isActive() {
          return bo({
            expected: "PRE_DRAG",
            phase: d,
            isLockActive: p,
            shouldWarn: !1
          });
        },
        shouldRespectForcePress: f,
        fluidLift: function fluidLift(e) {
          var t = Ye(function (e) {
            m(function () {
              return or({
                client: e
              });
            });
          });
          return g({}, v({
            liftActionArgs: {
              id: o,
              clientSelection: e,
              movementMode: "FLUID"
            },
            cleanup: function cleanup() {
              return t.cancel();
            },
            actions: {
              move: t
            }
          }), {
            move: t
          });
        },
        snapLift: function snapLift() {
          var e = {
            moveUp: function moveUp() {
              return m(ar);
            },
            moveRight: function moveRight() {
              return m(ur);
            },
            moveDown: function moveDown() {
              return m(lr);
            },
            moveLeft: function moveLeft() {
              return m(cr);
            }
          };
          return v({
            liftActionArgs: {
              id: o,
              clientSelection: fo(c),
              movementMode: "SNAP"
            },
            cleanup: lt,
            actions: e
          });
        },
        abort: function abort() {
          bo({
            expected: "PRE_DRAG",
            phase: d,
            isLockActive: p,
            shouldWarn: !0
          }) && t.release();
        }
      };
    }
    var wo = [function (e) {
      var t = Object(r.useRef)(to),
        n = Object(r.useRef)(lt),
        i = u(function () {
          return {
            eventName: "mousedown",
            fn: function fn(t) {
              if (!t.defaultPrevented && t.button === Ji && !(t.ctrlKey || t.metaKey || t.shiftKey || t.altKey)) {
                var r = e.findClosestDraggableId(t);
                if (r) {
                  var i = e.tryGetLock(r, l, {
                    sourceEvent: t
                  });
                  if (i) {
                    t.preventDefault();
                    var o = {
                      x: t.clientX,
                      y: t.clientY
                    };
                    n.current(), f(i, o);
                  }
                }
              }
            }
          };
        }, [e]),
        o = u(function () {
          return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(t) {
              if (!t.defaultPrevented) {
                var n = e.findClosestDraggableId(t);
                if (n) {
                  var r = e.findOptionsForDraggable(n);
                  r && (r.shouldRespectForcePress || e.canGetLock(n) && t.preventDefault());
                }
              }
            }
          };
        }, [e]),
        a = c(function () {
          n.current = ut(window, [o, i], {
            passive: !1,
            capture: !0
          });
        }, [o, i]),
        l = c(function () {
          "IDLE" !== t.current.type && (t.current = to, n.current(), a());
        }, [a]),
        s = c(function () {
          var e = t.current;
          l(), "DRAGGING" === e.type && e.actions.cancel({
            shouldBlockNextClick: !0
          }), "PENDING" === e.type && e.actions.abort();
        }, [l]),
        d = c(function () {
          var e = no({
            cancel: s,
            completed: l,
            getPhase: function getPhase() {
              return t.current;
            },
            setPhase: function setPhase(e) {
              t.current = e;
            }
          });
          n.current = ut(window, e, {
            capture: !0,
            passive: !1
          });
        }, [s, l]),
        f = c(function (e, n) {
          "IDLE" !== t.current.type && ft(!1), t.current = {
            type: "PENDING",
            point: n,
            actions: e
          }, d();
        }, [d]);
      Oi(function () {
        return a(), function () {
          n.current();
        };
      }, [a]);
    }, function (e) {
      var t = Object(r.useRef)(ro),
        n = u(function () {
          return {
            eventName: "keydown",
            fn: function fn(n) {
              if (!n.defaultPrevented && n.keyCode === Hi) {
                var r = e.findClosestDraggableId(n);
                if (r) {
                  var o = e.tryGetLock(r, u, {
                    sourceEvent: n
                  });
                  if (o) {
                    n.preventDefault();
                    var a = !0,
                      l = o.snapLift();
                    t.current(), t.current = ut(window, oo(l, u), {
                      capture: !0,
                      passive: !1
                    });
                  }
                }
              }
              function u() {
                a || ft(!1), a = !1, t.current(), i();
              }
            }
          };
        }, [e]),
        i = c(function () {
          t.current = ut(window, [n], {
            passive: !1,
            capture: !0
          });
        }, [n]);
      Oi(function () {
        return i(), function () {
          t.current();
        };
      }, [i]);
    }, function (e) {
      var t = Object(r.useRef)(ao),
        n = Object(r.useRef)(lt),
        i = c(function () {
          return t.current;
        }, []),
        o = c(function (e) {
          t.current = e;
        }, []),
        a = u(function () {
          return {
            eventName: "touchstart",
            fn: function fn(t) {
              if (!t.defaultPrevented) {
                var r = e.findClosestDraggableId(t);
                if (r) {
                  var i = e.tryGetLock(r, s, {
                    sourceEvent: t
                  });
                  if (i) {
                    var o = t.touches[0],
                      a = {
                        x: o.clientX,
                        y: o.clientY
                      };
                    n.current(), m(i, a);
                  }
                }
              }
            }
          };
        }, [e]),
        l = c(function () {
          n.current = ut(window, [a], {
            capture: !0,
            passive: !1
          });
        }, [a]),
        s = c(function () {
          var e = t.current;
          "IDLE" !== e.type && ("PENDING" === e.type && clearTimeout(e.longPressTimerId), o(ao), n.current(), l());
        }, [l, o]),
        d = c(function () {
          var e = t.current;
          s(), "DRAGGING" === e.type && e.actions.cancel({
            shouldBlockNextClick: !0
          }), "PENDING" === e.type && e.actions.abort();
        }, [s]),
        f = c(function () {
          var e = {
              capture: !0,
              passive: !1
            },
            t = {
              cancel: d,
              completed: s,
              getPhase: i
            },
            r = ut(window, function (e) {
              var t = e.cancel,
                n = e.completed,
                r = e.getPhase;
              return [{
                eventName: "touchmove",
                options: {
                  capture: !1
                },
                fn: function fn(e) {
                  var n = r();
                  if ("DRAGGING" === n.type) {
                    n.hasMoved = !0;
                    var i = e.touches[0],
                      o = {
                        x: i.clientX,
                        y: i.clientY
                      };
                    e.preventDefault(), n.actions.move(o);
                  } else t();
                }
              }, {
                eventName: "touchend",
                fn: function fn(e) {
                  var i = r();
                  "DRAGGING" === i.type ? (e.preventDefault(), i.actions.drop({
                    shouldBlockNextClick: !0
                  }), n()) : t();
                }
              }, {
                eventName: "touchcancel",
                fn: function fn(e) {
                  "DRAGGING" === r().type ? (e.preventDefault(), t()) : t();
                }
              }, {
                eventName: "touchforcechange",
                fn: function fn(e) {
                  var n = r();
                  "IDLE" === n.type && ft(!1);
                  var i = e.touches[0];
                  if (i && i.force >= uo) {
                    var o = n.actions.shouldRespectForcePress();
                    if ("PENDING" !== n.type) return o ? n.hasMoved ? void e.preventDefault() : void t() : void e.preventDefault();
                    o && t();
                  }
                }
              }, {
                eventName: Xi,
                fn: t
              }];
            }(t), e),
            o = ut(window, function (e) {
              var t = e.cancel,
                n = e.getPhase;
              return [{
                eventName: "orientationchange",
                fn: t
              }, {
                eventName: "resize",
                fn: t
              }, {
                eventName: "contextmenu",
                fn: function fn(e) {
                  e.preventDefault();
                }
              }, {
                eventName: "keydown",
                fn: function fn(e) {
                  "DRAGGING" === n().type ? (e.keyCode === Wi && e.preventDefault(), t()) : t();
                }
              }, {
                eventName: Xi,
                fn: t
              }];
            }(t), e);
          n.current = function () {
            r(), o();
          };
        }, [d, i, s]),
        p = c(function () {
          var e = i();
          "PENDING" !== e.type && ft(!1);
          var t = e.actions.fluidLift(e.point);
          o({
            type: "DRAGGING",
            actions: t,
            hasMoved: !1
          });
        }, [i, o]),
        m = c(function (e, t) {
          "IDLE" !== i().type && ft(!1);
          var n = setTimeout(p, lo);
          o({
            type: "PENDING",
            point: t,
            actions: e,
            longPressTimerId: n
          }), f();
        }, [f, i, o, p]);
      Oi(function () {
        return l(), function () {
          n.current();
          var e = i();
          "PENDING" === e.type && (clearTimeout(e.longPressTimerId), o(ao));
        };
      }, [i, l, o]), Oi(function () {
        return ut(window, [{
          eventName: "touchmove",
          fn: function fn() {},
          options: {
            capture: !1,
            passive: !1
          }
        }]);
      }, []);
    }];
    function xo(e) {
      var t = e.contextId,
        n = e.store,
        i = e.registry,
        o = e.customSensors,
        a = e.enableDefaultSensors,
        l = [].concat(a ? wo : [], o || []),
        s = Object(r.useState)(function () {
          return function () {
            var e = null;
            function t() {
              e || ft(!1), e = null;
            }
            return {
              isClaimed: function isClaimed() {
                return Boolean(e);
              },
              isActive: function isActive(t) {
                return t === e;
              },
              claim: function claim(t) {
                e && ft(!1);
                var n = {
                  abandon: t
                };
                return e = n, n;
              },
              release: t,
              tryAbandon: function tryAbandon() {
                e && (e.abandon(), t());
              }
            };
          }();
        })[0],
        d = c(function (e, t) {
          e.isDragging && !t.isDragging && s.tryAbandon();
        }, [s]);
      Oi(function () {
        var e = n.getState();
        return n.subscribe(function () {
          var t = n.getState();
          d(e, t), e = t;
        });
      }, [s, n, d]), Oi(function () {
        return s.tryAbandon;
      }, [s.tryAbandon]);
      var f = c(function (e) {
          return ho({
            lockAPI: s,
            registry: i,
            store: n,
            draggableId: e
          });
        }, [s, i, n]),
        p = c(function (e, r, o) {
          return yo({
            lockAPI: s,
            registry: i,
            contextId: t,
            store: n,
            draggableId: e,
            forceSensorStop: r,
            sourceEvent: o && o.sourceEvent ? o.sourceEvent : null
          });
        }, [t, s, i, n]),
        m = c(function (e) {
          return function (e, t) {
            var n = go(e, t);
            return n ? n.getAttribute(wi.draggableId) : null;
          }(t, e);
        }, [t]),
        g = c(function (e) {
          var t = i.draggable.findById(e);
          return t ? t.options : null;
        }, [i.draggable]),
        v = c(s.tryAbandon, [s]),
        b = c(s.isClaimed, [s]),
        h = u(function () {
          return {
            canGetLock: f,
            tryGetLock: p,
            findClosestDraggableId: m,
            findOptionsForDraggable: g,
            tryReleaseLock: v,
            isLockClaimed: b
          };
        }, [f, p, m, g, v, b]);
      Fi();
      for (var y = 0; y < l.length; y++) l[y](h);
    }
    var Eo = function Eo(e) {
      return {
        onBeforeCapture: e.onBeforeCapture,
        onBeforeDragStart: e.onBeforeDragStart,
        onDragStart: e.onDragStart,
        onDragEnd: e.onDragEnd,
        onDragUpdate: e.onDragUpdate
      };
    };
    function Co(e) {
      return e.current || ft(!1), e.current;
    }
    function So(e) {
      var t = e.contextId,
        n = e.setCallbacks,
        o = e.sensors,
        a = e.nonce,
        l = e.liftInstruction,
        s = Object(r.useRef)(null);
      zi();
      var d = Ui(e),
        f = c(function () {
          return Eo(d.current);
        }, [d]),
        p = function (e) {
          var t = u(function () {
              return ji(e);
            }, [e]),
            n = Object(r.useRef)(null);
          return Object(r.useEffect)(function () {
            var e = document.createElement("div");
            return n.current = e, e.id = t, e.setAttribute("aria-live", "assertive"), e.setAttribute("role", "log"), e.setAttribute("aria-atomic", "true"), m()(e.style, Li), Ai().appendChild(e), function () {
              setTimeout(function () {
                Ai().removeChild(e), e === n.current && (n.current = null);
              });
            };
          }, [t]), c(function (e) {
            var t = n.current;
            t && (t.textContent = e);
          }, []);
        }(t),
        v = function (e, t) {
          var n = u(function () {
            return Mi(e);
          }, [e]);
          return Object(r.useEffect)(function () {
            var e = document.createElement("div");
            return e.id = n, e.textContent = t, m()(e.style, {
              display: "none"
            }), Ai().appendChild(e), function () {
              Ai().removeChild(e);
            };
          }, [n, t]), n;
        }(t, l),
        b = function (e, t) {
          var n = u(function () {
              return Ti(e);
            }, [e]),
            i = Object(r.useRef)(null),
            o = Object(r.useRef)(null),
            a = c(Ve(function (e) {
              var t = o.current;
              t || ft(!1), t.textContent = e;
            }), []),
            l = c(function (e) {
              var t = i.current;
              t || ft(!1), t.textContent = e;
            }, []);
          Oi(function () {
            (i.current || o.current) && ft(!1);
            var r = Pi(t),
              u = Pi(t);
            return i.current = r, o.current = u, r.setAttribute(yi + "-always", e), u.setAttribute(yi + "-dynamic", e), ki().appendChild(r), ki().appendChild(u), l(n.always), a(n.resting), function () {
              var e = function e(_e2) {
                var t = _e2.current;
                t || ft(!1), ki().removeChild(t), _e2.current = null;
              };
              e(i), e(o);
            };
          }, [t, l, a, n.always, n.resting, e]);
          var s = c(function () {
              return a(n.dragging);
            }, [a, n.dragging]),
            d = c(function (e) {
              a("DROP" !== e ? n.userCancel : n.dropAnimating);
            }, [a, n.dropAnimating, n.userCancel]),
            f = c(function () {
              o.current && a(n.resting);
            }, [a, n.resting]);
          return u(function () {
            return {
              dragging: s,
              dropping: d,
              resting: f
            };
          }, [s, d, f]);
        }(t, a),
        h = c(function (e) {
          Co(s).dispatch(e);
        }, []),
        y = u(function () {
          return E({
            publishWhileDragging: er,
            updateDroppableScroll: nr,
            updateDroppableIsEnabled: rr,
            updateDroppableIsCombineEnabled: ir,
            collectionStarting: tr
          }, h);
        }, [h]),
        w = function () {
          var e = u(Ri, []);
          return Object(r.useEffect)(function () {
            return function () {
              requestAnimationFrame(e.clean);
            };
          }, [e]), e;
        }(),
        x = u(function () {
          return Kr(w, y);
        }, [w, y]),
        C = u(function () {
          return hi(g({
            scrollWindow: Yr,
            scrollDroppable: x.scrollDroppable
          }, E({
            move: or
          }, h)));
        }, [x.scrollDroppable, h]),
        S = function (e) {
          var t = Object(r.useRef)({}),
            n = Object(r.useRef)(null),
            i = Object(r.useRef)(null),
            o = Object(r.useRef)(!1),
            a = c(function (e, n) {
              var r = {
                id: e,
                focus: n
              };
              return t.current[e] = r, function () {
                var n = t.current;
                n[e] !== r && delete n[e];
              };
            }, []),
            l = c(function (t) {
              var n = Ni(e, t);
              n && n !== document.activeElement && n.focus();
            }, [e]),
            s = c(function (e, t) {
              n.current === e && (n.current = t);
            }, []),
            d = c(function () {
              i.current || o.current && (i.current = requestAnimationFrame(function () {
                i.current = null;
                var e = n.current;
                e && l(e);
              }));
            }, [l]),
            f = c(function (e) {
              n.current = null;
              var t = document.activeElement;
              t && t.getAttribute(wi.draggableId) === e && (n.current = e);
            }, []);
          return Oi(function () {
            return o.current = !0, function () {
              o.current = !1;
              var e = i.current;
              e && cancelAnimationFrame(e);
            };
          }, []), u(function () {
            return {
              register: a,
              tryRecordFocus: f,
              tryRestoreFocusRecorded: d,
              tryShiftRecord: s
            };
          }, [a, f, d, s]);
        }(t),
        T = u(function () {
          return Br({
            announce: p,
            autoScroller: C,
            dimensionMarshal: x,
            focusMarshal: S,
            getResponders: f,
            styleMarshal: b
          });
        }, [p, C, x, S, f, b]);
      s.current = T;
      var O = c(function () {
          var e = Co(s);
          "IDLE" !== e.getState().phase && e.dispatch(sr());
        }, []),
        k = c(function () {
          var e = Co(s).getState();
          return e.isDragging || "DROP_ANIMATING" === e.phase;
        }, []);
      n(u(function () {
        return {
          isDragging: k,
          tryAbort: O
        };
      }, [k, O]));
      var P = c(function (e) {
          return Qr(Co(s).getState(), e);
        }, []),
        D = c(function () {
          return Rn(Co(s).getState());
        }, []),
        I = u(function () {
          return {
            marshal: x,
            focus: S,
            contextId: t,
            canLift: P,
            isMovementAllowed: D,
            liftInstructionId: v,
            registry: w
          };
        }, [t, x, S, P, D, v, w]);
      return xo({
        contextId: t,
        store: T,
        registry: w,
        customSensors: o,
        enableDefaultSensors: !1 !== e.enableDefaultSensors
      }), Object(r.useEffect)(function () {
        return O;
      }, [O]), i.a.createElement(Bi.Provider, {
        value: I
      }, i.a.createElement(j, {
        context: _i,
        store: T
      }, e.children));
    }
    var To = 0;
    function Oo(e) {
      var t = u(function () {
          return "" + To++;
        }, []),
        n = e.liftInstruction || ht.liftInstruction;
      return i.a.createElement(pt, null, function (r) {
        return i.a.createElement(So, {
          nonce: e.nonce,
          contextId: t,
          setCallbacks: r,
          liftInstruction: n,
          enableDefaultSensors: e.enableDefaultSensors,
          sensors: e.sensors,
          onBeforeCapture: e.onBeforeCapture,
          onBeforeDragStart: e.onBeforeDragStart,
          onDragStart: e.onDragStart,
          onDragUpdate: e.onDragUpdate,
          onDragEnd: e.onDragEnd
        }, e.children);
      });
    }
    var ko = function ko(e) {
        return function (t) {
          return e === t;
        };
      },
      Po = ko("scroll"),
      Do = ko("auto"),
      Io = (ko("visible"), function (e, t) {
        return t(e.overflowX) || t(e.overflowY);
      }),
      No = function No(e) {
        var t = window.getComputedStyle(e),
          n = {
            overflowX: t.overflowX,
            overflowY: t.overflowY
          };
        return Io(n, Po) || Io(n, Do);
      },
      Ro = function e(t) {
        return null == t ? null : t === document.body ? null : t === document.documentElement ? null : No(t) ? t : e(t.parentElement);
      },
      _o = function _o(e) {
        return {
          x: e.scrollLeft,
          y: e.scrollTop
        };
      },
      Ao = function Ao(e) {
        return {
          closestScrollable: Ro(e),
          isFixedOnPage: function e(t) {
            return !!t && ("fixed" === window.getComputedStyle(t).position || e(t.parentElement));
          }(e)
        };
      },
      Lo = function Lo(e) {
        var t = e.ref,
          n = e.descriptor,
          r = e.env,
          i = e.windowScroll,
          o = e.direction,
          a = e.isDropDisabled,
          l = e.isCombineEnabled,
          u = e.shouldClipSubject,
          c = r.closestScrollable,
          s = function (e, t) {
            var n = We(e);
            if (!t) return n;
            if (e !== t) return n;
            var r = n.paddingBox.top - t.scrollTop,
              i = n.paddingBox.left - t.scrollLeft,
              o = r + t.scrollHeight,
              a = i + t.scrollWidth,
              l = Le({
                top: r,
                right: a,
                bottom: o,
                left: i
              }, n.border);
            return Be({
              borderBox: l,
              margin: n.margin,
              border: n.border,
              padding: n.padding
            });
          }(t, c),
          d = Ue(s, i),
          f = function () {
            if (!c) return null;
            var e = We(c),
              t = {
                scrollHeight: c.scrollHeight,
                scrollWidth: c.scrollWidth
              };
            return {
              client: e,
              page: Ue(e, i),
              scroll: _o(c),
              scrollSize: t,
              shouldClipSubject: u
            };
          }();
        return function (e) {
          var t = e.descriptor,
            n = e.isEnabled,
            r = e.isCombineEnabled,
            i = e.isFixedOnPage,
            o = e.direction,
            a = e.client,
            l = e.page,
            u = e.closest,
            c = function () {
              if (!u) return null;
              var e = u.scrollSize,
                t = u.client,
                n = Ur({
                  scrollHeight: e.scrollHeight,
                  scrollWidth: e.scrollWidth,
                  height: t.paddingBox.height,
                  width: t.paddingBox.width
                });
              return {
                pageMarginBox: u.page.marginBox,
                frameClient: t,
                scrollSize: e,
                shouldClipSubject: u.shouldClipSubject,
                scroll: {
                  initial: u.scroll,
                  current: u.scroll,
                  max: n,
                  diff: {
                    value: yt,
                    displacement: yt
                  }
                }
              };
            }(),
            s = "vertical" === o ? Jt : Zt;
          return {
            descriptor: t,
            isCombineEnabled: r,
            isFixedOnPage: i,
            axis: s,
            isEnabled: n,
            client: a,
            page: l,
            frame: c,
            subject: Nt({
              page: l,
              withPlaceholder: null,
              axis: s,
              frame: c
            })
          };
        }({
          descriptor: n,
          isEnabled: !a,
          isCombineEnabled: l,
          isFixedOnPage: r.isFixedOnPage,
          direction: o,
          client: s,
          page: d,
          closest: f
        });
      },
      jo = {
        passive: !1
      },
      Mo = {
        passive: !0
      },
      Bo = function Bo(e) {
        return e.shouldPublishImmediately ? jo : Mo;
      };
    function Fo(e) {
      var t = Object(r.useContext)(e);
      return t || ft(!1), t;
    }
    var zo = 0;
    function Uo(e) {
      return e + "::" + Object(r.useRef)(zo++).current;
    }
    var Go = function Go(e) {
      return e && e.env.closestScrollable || null;
    };
    function Wo() {}
    var Ho = {
        width: 0,
        height: 0,
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      },
      Vo = function Vo(e) {
        var t = e.isAnimatingOpenOnMount,
          n = e.placeholder,
          r = e.animate,
          i = function (e) {
            var t = e.isAnimatingOpenOnMount,
              n = e.placeholder,
              r = e.animate;
            return t ? Ho : "close" === r ? Ho : {
              height: n.client.borderBox.height,
              width: n.client.borderBox.width,
              margin: n.client.margin
            };
          }({
            isAnimatingOpenOnMount: t,
            placeholder: n,
            animate: r
          });
        return {
          display: n.display,
          boxSizing: "border-box",
          width: i.width,
          height: i.height,
          marginTop: i.margin.top,
          marginRight: i.margin.right,
          marginBottom: i.margin.bottom,
          marginLeft: i.margin.left,
          flexShrink: "0",
          flexGrow: "0",
          pointerEvents: "none",
          transition: "none" !== r ? yr.placeholder : null
        };
      };
    var qo = i.a.memo(function (e) {
        var t = Object(r.useRef)(null),
          n = c(function () {
            t.current && (clearTimeout(t.current), t.current = null);
          }, []),
          o = e.animate,
          a = e.onTransitionEnd,
          l = e.onClose,
          u = e.contextId,
          s = Object(r.useState)("open" === e.animate),
          d = s[0],
          f = s[1];
        Object(r.useEffect)(function () {
          return d ? "open" !== o ? (n(), f(!1), Wo) : t.current ? Wo : (t.current = setTimeout(function () {
            t.current = null, f(!1);
          }), n) : Wo;
        }, [o, d, n]);
        var p = c(function (e) {
            "height" === e.propertyName && (a(), "close" === o && l());
          }, [o, l, a]),
          m = Vo({
            isAnimatingOpenOnMount: d,
            animate: e.animate,
            placeholder: e.placeholder
          });
        return i.a.createElement(e.placeholder.tagName, {
          style: m,
          "data-rbd-placeholder-context-id": u,
          onTransitionEnd: p,
          ref: e.innerRef
        });
      }),
      $o = i.a.createContext(null);
    var Ko = function (e) {
        function t() {
          for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
          return (t = e.call.apply(e, [this].concat(r)) || this).state = {
            isVisible: Boolean(t.props.on),
            data: t.props.on,
            animate: t.props.shouldAnimate && t.props.on ? "open" : "none"
          }, t.onClose = function () {
            "close" === t.state.animate && t.setState({
              isVisible: !1
            });
          }, t;
        }
        return f(t, e), t.getDerivedStateFromProps = function (e, t) {
          return e.shouldAnimate ? e.on ? {
            isVisible: !0,
            data: e.on,
            animate: "open"
          } : t.isVisible ? {
            isVisible: !0,
            data: t.data,
            animate: "close"
          } : {
            isVisible: !1,
            animate: "close",
            data: null
          } : {
            isVisible: Boolean(e.on),
            data: e.on,
            animate: "none"
          };
        }, t.prototype.render = function () {
          if (!this.state.isVisible) return null;
          var e = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
          };
          return this.props.children(e);
        }, t;
      }(i.a.PureComponent),
      Qo = {
        dragging: 5e3,
        dropAnimating: 4500
      },
      Yo = function Yo(e, t) {
        return t ? yr.drop(t.duration) : e ? yr.snap : yr.fluid;
      },
      Xo = function Xo(e, t) {
        return e ? t ? gr.opacity.drop : gr.opacity.combining : null;
      },
      Jo = function Jo(e) {
        return null != e.forceShouldAnimate ? e.forceShouldAnimate : "SNAP" === e.mode;
      };
    function Zo(e) {
      return "DRAGGING" === e.type ? (r = (n = e).dimension.client, i = n.offset, o = n.combineWith, a = n.dropping, l = Boolean(o), u = Jo(n), c = Boolean(a), s = c ? xr.drop(i, l) : xr.moveTo(i), {
        position: "fixed",
        top: r.marginBox.top,
        left: r.marginBox.left,
        boxSizing: "border-box",
        width: r.borderBox.width,
        height: r.borderBox.height,
        transition: Yo(u, a),
        transform: s,
        opacity: Xo(l, c),
        zIndex: c ? Qo.dropAnimating : Qo.dragging,
        pointerEvents: "none"
      }) : (t = e, {
        transform: xr.moveTo(t.offset),
        transition: t.shouldAnimateDisplacement ? null : "none"
      });
      var t, n, r, i, o, a, l, u, c, s;
    }
    function ea(e) {
      var t = Uo("draggable"),
        n = e.descriptor,
        i = e.registry,
        o = e.getDraggableRef,
        a = e.canDragInteractiveElements,
        l = e.shouldRespectForcePress,
        s = e.isEnabled,
        d = u(function () {
          return {
            canDragInteractiveElements: a,
            shouldRespectForcePress: l,
            isEnabled: s
          };
        }, [a, s, l]),
        f = c(function (e) {
          var t = o();
          return t || ft(!1), function (e, t, n) {
            void 0 === n && (n = yt);
            var r = window.getComputedStyle(t),
              i = t.getBoundingClientRect(),
              o = Ge(i, r),
              a = Ue(o, n);
            return {
              descriptor: e,
              placeholder: {
                client: o,
                tagName: t.tagName.toLowerCase(),
                display: r.display
              },
              displaceBy: {
                x: o.marginBox.width,
                y: o.marginBox.height
              },
              client: o,
              page: a
            };
          }(n, t, e);
        }, [n, o]),
        p = u(function () {
          return {
            uniqueId: t,
            descriptor: n,
            options: d,
            getDimension: f
          };
        }, [n, f, d, t]),
        m = Object(r.useRef)(p),
        g = Object(r.useRef)(!0);
      Oi(function () {
        return i.draggable.register(m.current), function () {
          return i.draggable.unregister(m.current);
        };
      }, [i.draggable]), Oi(function () {
        if (g.current) g.current = !1;else {
          var e = m.current;
          m.current = p, i.draggable.update(p, e);
        }
      }, [p, i.draggable]);
    }
    function ta(e) {
      e.preventDefault();
    }
    var na = function na(e, t) {
        return e === t;
      },
      ra = function ra(e) {
        var t = e.combine,
          n = e.destination;
        return n ? n.droppableId : t ? t.droppableId : null;
      },
      ia = function ia(e) {
        return e.combine ? e.combine.draggableId : null;
      },
      oa = function oa(e) {
        return e.at && "COMBINE" === e.at.type ? e.at.combine.draggableId : null;
      };
    function aa(e) {
      return {
        isDragging: !1,
        isDropAnimating: !1,
        isClone: !1,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: e,
        combineWith: null
      };
    }
    var la = {
      mapped: {
        type: "SECONDARY",
        offset: yt,
        combineTargetFor: null,
        shouldAnimateDisplacement: !0,
        snapshot: aa(null)
      }
    };
    var ua = Ce(function () {
      var e,
        t,
        n,
        r = (e = Ve(function (e, t) {
          return {
            x: e,
            y: t
          };
        }), t = Ve(function (e, t, n, r, i) {
          return {
            isDragging: !0,
            isClone: t,
            isDropAnimating: Boolean(i),
            dropAnimation: i,
            mode: e,
            draggingOver: n,
            combineWith: r,
            combineTargetFor: null
          };
        }), n = Ve(function (e, n, r, i, o, a, l) {
          return {
            mapped: {
              type: "DRAGGING",
              dropping: null,
              draggingOver: o,
              combineWith: a,
              mode: n,
              offset: e,
              dimension: r,
              forceShouldAnimate: l,
              snapshot: t(n, i, o, a, null)
            }
          };
        }), function (r, i) {
          if (r.isDragging) {
            if (r.critical.draggable.id !== i.draggableId) return null;
            var o = r.current.client.offset,
              a = r.dimensions.draggables[i.draggableId],
              l = In(r.impact),
              u = oa(r.impact),
              c = r.forceShouldAnimate;
            return n(e(o.x, o.y), r.movementMode, a, i.isClone, l, u, c);
          }
          if ("DROP_ANIMATING" === r.phase) {
            var s = r.completed;
            if (s.result.draggableId !== i.draggableId) return null;
            var d = i.isClone,
              f = r.dimensions.draggables[i.draggableId],
              p = s.result,
              m = p.mode,
              g = ra(p),
              v = ia(p),
              b = {
                duration: r.dropDuration,
                curve: mr.drop,
                moveTo: r.newHomeClientOffset,
                opacity: v ? gr.opacity.drop : null,
                scale: v ? gr.scale.drop : null
              };
            return {
              mapped: {
                type: "DRAGGING",
                offset: r.newHomeClientOffset,
                dimension: f,
                dropping: b,
                draggingOver: g,
                combineWith: v,
                mode: m,
                forceShouldAnimate: null,
                snapshot: t(m, d, g, v, b)
              }
            };
          }
          return null;
        }),
        i = function () {
          var e = Ve(function (e, t) {
              return {
                x: e,
                y: t
              };
            }),
            t = Ve(aa),
            n = Ve(function (e, n, r) {
              return void 0 === n && (n = null), {
                mapped: {
                  type: "SECONDARY",
                  offset: e,
                  combineTargetFor: n,
                  shouldAnimateDisplacement: r,
                  snapshot: t(n)
                }
              };
            }),
            r = function r(e) {
              return e ? n(yt, e, !0) : null;
            },
            i = function i(t, _i3, o, a) {
              var l = o.displaced.visible[t],
                u = Boolean(a.inVirtualList && a.effected[t]),
                c = Wt(o),
                s = c && c.draggableId === t ? _i3 : null;
              if (!l) {
                if (!u) return r(s);
                if (o.displaced.invisible[t]) return null;
                var d = Ct(a.displacedBy.point),
                  f = e(d.x, d.y);
                return n(f, s, !0);
              }
              if (u) return r(s);
              var p = o.displacedBy.point,
                m = e(p.x, p.y);
              return n(m, s, l.shouldAnimate);
            };
          return function (e, t) {
            if (e.isDragging) return e.critical.draggable.id === t.draggableId ? null : i(t.draggableId, e.critical.draggable.id, e.impact, e.afterCritical);
            if ("DROP_ANIMATING" === e.phase) {
              var n = e.completed;
              return n.result.draggableId === t.draggableId ? null : i(t.draggableId, n.result.draggableId, n.impact, n.afterCritical);
            }
            return null;
          };
        }();
      return function (e, t) {
        return r(e, t) || i(e, t) || la;
      };
    }, {
      dropAnimationFinished: pr
    }, null, {
      context: _i,
      pure: !0,
      areStatePropsEqual: na
    })(function (e) {
      var t = Object(r.useRef)(null),
        n = c(function (e) {
          t.current = e;
        }, []),
        i = c(function () {
          return t.current;
        }, []),
        o = Fo(Bi),
        a = o.contextId,
        l = o.liftInstructionId,
        s = o.registry,
        d = Fo($o),
        f = d.type,
        p = d.droppableId,
        m = u(function () {
          return {
            id: e.draggableId,
            index: e.index,
            type: f,
            droppableId: p
          };
        }, [e.draggableId, e.index, f, p]),
        g = e.children,
        v = e.draggableId,
        b = e.isEnabled,
        h = e.shouldRespectForcePress,
        y = e.canDragInteractiveElements,
        w = e.isClone,
        x = e.mapped,
        E = e.dropAnimationFinished;
      zi(), Fi(), w || ea(u(function () {
        return {
          descriptor: m,
          registry: s,
          getDraggableRef: i,
          canDragInteractiveElements: y,
          shouldRespectForcePress: h,
          isEnabled: b
        };
      }, [m, s, i, y, h, b]));
      var C = u(function () {
          return b ? {
            tabIndex: 0,
            "data-rbd-drag-handle-draggable-id": v,
            "data-rbd-drag-handle-context-id": a,
            "aria-labelledby": l,
            draggable: !1,
            onDragStart: ta
          } : null;
        }, [a, v, b, l]),
        S = c(function (e) {
          "DRAGGING" === x.type && x.dropping && "transform" === e.propertyName && E();
        }, [E, x]),
        T = u(function () {
          var e = Zo(x),
            t = "DRAGGING" === x.type && x.dropping ? S : null;
          return {
            innerRef: n,
            draggableProps: {
              "data-rbd-draggable-context-id": a,
              "data-rbd-draggable-id": v,
              style: e,
              onTransitionEnd: t
            },
            dragHandleProps: C
          };
        }, [a, C, v, x, S, n]),
        O = u(function () {
          return {
            draggableId: m.id,
            type: m.type,
            source: {
              index: m.index,
              droppableId: m.droppableId
            }
          };
        }, [m.droppableId, m.id, m.index, m.type]);
      return g(T, x.snapshot, O);
    });
    function ca(e) {
      return Fo($o).isUsingCloneFor !== e.draggableId || e.isClone ? i.a.createElement(ua, e) : null;
    }
    function sa(e) {
      var t = "boolean" != typeof e.isDragDisabled || !e.isDragDisabled,
        n = Boolean(e.disableInteractiveElementBlocking),
        r = Boolean(e.shouldRespectForcePress);
      return i.a.createElement(ca, g({}, e, {
        isClone: !1,
        isEnabled: t,
        canDragInteractiveElements: n,
        shouldRespectForcePress: r
      }));
    }
    var da = function da(e, t) {
        return e === t.droppable.type;
      },
      fa = function fa(e, t) {
        return t.draggables[e.draggable.id];
      };
    var pa = {
        mode: "standard",
        type: "DEFAULT",
        direction: "vertical",
        isDropDisabled: !1,
        isCombineEnabled: !1,
        ignoreContainerClipping: !1,
        renderClone: null,
        getContainerForClone: function getContainerForClone() {
          return document.body || ft(!1), document.body;
        }
      },
      ma = Ce(function () {
        var e = {
            placeholder: null,
            shouldAnimatePlaceholder: !0,
            snapshot: {
              isDraggingOver: !1,
              draggingOverWith: null,
              draggingFromThisWith: null,
              isUsingPlaceholder: !1
            },
            useClone: null
          },
          t = g({}, e, {
            shouldAnimatePlaceholder: !1
          }),
          n = Ve(function (e) {
            return {
              draggableId: e.id,
              type: e.type,
              source: {
                index: e.index,
                droppableId: e.droppableId
              }
            };
          }),
          r = Ve(function (r, i, o, a, l, u) {
            var c = l.descriptor.id;
            if (l.descriptor.droppableId === r) {
              var s = u ? {
                  render: u,
                  dragging: n(l.descriptor)
                } : null,
                d = {
                  isDraggingOver: o,
                  draggingOverWith: o ? c : null,
                  draggingFromThisWith: c,
                  isUsingPlaceholder: !0
                };
              return {
                placeholder: l.placeholder,
                shouldAnimatePlaceholder: !1,
                snapshot: d,
                useClone: s
              };
            }
            if (!i) return t;
            if (!a) return e;
            var f = {
              isDraggingOver: o,
              draggingOverWith: c,
              draggingFromThisWith: null,
              isUsingPlaceholder: !0
            };
            return {
              placeholder: l.placeholder,
              shouldAnimatePlaceholder: !0,
              snapshot: f,
              useClone: null
            };
          });
        return function (n, i) {
          var o = i.droppableId,
            a = i.type,
            l = !i.isDropDisabled,
            u = i.renderClone;
          if (n.isDragging) {
            var c = n.critical;
            if (!da(a, c)) return t;
            var s = fa(c, n.dimensions),
              d = In(n.impact) === o;
            return r(o, l, d, d, s, u);
          }
          if ("DROP_ANIMATING" === n.phase) {
            var f = n.completed;
            if (!da(a, f.critical)) return t;
            var p = fa(f.critical, n.dimensions);
            return r(o, l, ra(f.result) === o, In(f.impact) === o, p, u);
          }
          if ("IDLE" === n.phase && n.completed && !n.shouldFlush) {
            var m = n.completed;
            if (!da(a, m.critical)) return t;
            var g = In(m.impact) === o,
              v = Boolean(m.impact.at && "COMBINE" === m.impact.at.type),
              b = m.critical.droppable.id === o;
            return g ? v ? e : t : b ? e : t;
          }
          return t;
        };
      }, {
        updateViewportMaxScroll: function updateViewportMaxScroll(e) {
          return {
            type: "UPDATE_VIEWPORT_MAX_SCROLL",
            payload: e
          };
        }
      }, null, {
        context: _i,
        pure: !0,
        areStatePropsEqual: na
      })(function (e) {
        var t = Object(r.useContext)(Bi);
        t || ft(!1);
        var n = t.contextId,
          o = t.isMovementAllowed,
          a = Object(r.useRef)(null),
          l = Object(r.useRef)(null),
          s = e.children,
          d = e.droppableId,
          f = e.type,
          p = e.mode,
          m = e.direction,
          g = e.ignoreContainerClipping,
          v = e.isDropDisabled,
          b = e.isCombineEnabled,
          h = e.snapshot,
          y = e.useClone,
          w = e.updateViewportMaxScroll,
          x = e.getContainerForClone,
          E = c(function () {
            return a.current;
          }, []),
          C = c(function (e) {
            a.current = e;
          }, []),
          S = (c(function () {
            return l.current;
          }, []), c(function (e) {
            l.current = e;
          }, []));
        zi();
        var T = c(function () {
          o() && w({
            maxScroll: Wr()
          });
        }, [o, w]);
        !function (e) {
          var t = Object(r.useRef)(null),
            n = Fo(Bi),
            i = Uo("droppable"),
            o = n.registry,
            a = n.marshal,
            l = Ui(e),
            s = u(function () {
              return {
                id: e.droppableId,
                type: e.type,
                mode: e.mode
              };
            }, [e.droppableId, e.mode, e.type]),
            d = Object(r.useRef)(s),
            f = u(function () {
              return Ve(function (e, n) {
                t.current || ft(!1);
                var r = {
                  x: e,
                  y: n
                };
                a.updateDroppableScroll(s.id, r);
              });
            }, [s.id, a]),
            p = c(function () {
              var e = t.current;
              return e && e.env.closestScrollable ? _o(e.env.closestScrollable) : yt;
            }, []),
            m = c(function () {
              var e = p();
              f(e.x, e.y);
            }, [p, f]),
            g = u(function () {
              return Ye(m);
            }, [m]),
            v = c(function () {
              var e = t.current,
                n = Go(e);
              e && n || ft(!1), e.scrollOptions.shouldPublishImmediately ? m() : g();
            }, [g, m]),
            b = c(function (e, r) {
              t.current && ft(!1);
              var i = l.current,
                o = i.getDroppableRef();
              o || ft(!1);
              var a = Ao(o),
                u = {
                  ref: o,
                  descriptor: s,
                  env: a,
                  scrollOptions: r
                };
              t.current = u;
              var c = Lo({
                  ref: o,
                  descriptor: s,
                  env: a,
                  windowScroll: e,
                  direction: i.direction,
                  isDropDisabled: i.isDropDisabled,
                  isCombineEnabled: i.isCombineEnabled,
                  shouldClipSubject: !i.ignoreContainerClipping
                }),
                d = a.closestScrollable;
              return d && (d.setAttribute(Ci.contextId, n.contextId), d.addEventListener("scroll", v, Bo(u.scrollOptions))), c;
            }, [n.contextId, s, v, l]),
            h = c(function () {
              var e = t.current,
                n = Go(e);
              return e && n || ft(!1), _o(n);
            }, []),
            y = c(function () {
              var e = t.current;
              e || ft(!1);
              var n = Go(e);
              t.current = null, n && (g.cancel(), n.removeAttribute(Ci.contextId), n.removeEventListener("scroll", v, Bo(e.scrollOptions)));
            }, [v, g]),
            w = c(function (e) {
              var n = t.current;
              n || ft(!1);
              var r = Go(n);
              r || ft(!1), r.scrollTop += e.y, r.scrollLeft += e.x;
            }, []),
            x = u(function () {
              return {
                getDimensionAndWatchScroll: b,
                getScrollWhileDragging: h,
                dragStopped: y,
                scroll: w
              };
            }, [y, b, h, w]),
            E = u(function () {
              return {
                uniqueId: i,
                descriptor: s,
                callbacks: x
              };
            }, [x, s, i]);
          Oi(function () {
            return d.current = E.descriptor, o.droppable.register(E), function () {
              t.current && y(), o.droppable.unregister(E);
            };
          }, [x, s, y, E, a, o.droppable]), Oi(function () {
            t.current && a.updateDroppableIsEnabled(d.current.id, !e.isDropDisabled);
          }, [e.isDropDisabled, a]), Oi(function () {
            t.current && a.updateDroppableIsCombineEnabled(d.current.id, e.isCombineEnabled);
          }, [e.isCombineEnabled, a]);
        }({
          droppableId: d,
          type: f,
          mode: p,
          direction: m,
          isDropDisabled: v,
          isCombineEnabled: b,
          ignoreContainerClipping: g,
          getDroppableRef: E
        });
        var O = i.a.createElement(Ko, {
            on: e.placeholder,
            shouldAnimate: e.shouldAnimatePlaceholder
          }, function (e) {
            var t = e.onClose,
              r = e.data,
              o = e.animate;
            return i.a.createElement(qo, {
              placeholder: r,
              onClose: t,
              innerRef: S,
              animate: o,
              contextId: n,
              onTransitionEnd: T
            });
          }),
          k = u(function () {
            return {
              innerRef: C,
              placeholder: O,
              droppableProps: {
                "data-rbd-droppable-id": d,
                "data-rbd-droppable-context-id": n
              }
            };
          }, [n, d, O, C]),
          P = y ? y.dragging.draggableId : null,
          D = u(function () {
            return {
              droppableId: d,
              type: f,
              isUsingCloneFor: P
            };
          }, [d, P, f]);
        return i.a.createElement($o.Provider, {
          value: D
        }, s(k, h), function () {
          if (!y) return null;
          var e = y.dragging,
            t = y.render,
            n = i.a.createElement(ca, {
              draggableId: e.draggableId,
              index: e.source.index,
              isClone: !0,
              isEnabled: !0,
              shouldRespectForcePress: !1,
              canDragInteractiveElements: !0
            }, function (n, r) {
              return t(n, r, e);
            });
          return Ie.a.createPortal(n, x());
        }());
      });
    function ga() {
      return (ga = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }).apply(this, arguments);
    }
    function va() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  display: inline-block;\n  white-space: normal;\n"]);
      return va = function va() {
        return e;
      }, e;
    }
    ma.defaultProps = pa;
    var ba = a.a.div(va());
    var ha = function ha(e) {
      var t = e.children,
        n = e.index,
        r = e.renderCard,
        o = e.disableCardDrag;
      return i.a.createElement(sa, {
        draggableId: String(t.id),
        index: n,
        isDragDisabled: o
      }, function (e, t) {
        var n = t.isDragging;
        return i.a.createElement("div", ga({
          ref: e.innerRef
        }, e.draggableProps, e.dragHandleProps, {
          "data-testid": "card"
        }), i.a.createElement(ba, null, r(n)));
      });
    };
    function ya() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  box-sizing: border-box;\n  max-width: 250px;\n  min-width: 250px;\n"]);
      return ya = function ya() {
        return e;
      }, e;
    }
    var wa = a.a.div(ya());
    function xa() {
      return (xa = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }).apply(this, arguments);
    }
    function Ea(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = function (e, t) {
          if (null == e) return {};
          var n,
            r,
            i = {},
            o = Object.keys(e);
          for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
          return i;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
      }
      return i;
    }
    var Ca = function Ca(e) {
      return function (t) {
        var n = t.children,
          r = Ea(t, ["children"]);
        return i.a.createElement(ma, r, function (t) {
          return i.a.createElement(e, xa({
            ref: t.innerRef
          }, t.droppableProps), n, t.placeholder);
        });
      };
    };
    function Sa() {
      return (Sa = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }).apply(this, arguments);
    }
    function Ta() {
      var e = ka(["\n  min-height: 28px;\n"]);
      return Ta = function Ta() {
        return e;
      }, e;
    }
    function Oa() {
      var e = ka(["\n  height: 100%;\n  display: inline-block;\n  padding: 15px;\n  border-radius: 2px;\n  background-color: #eee;\n  margin: 5px;\n  vertical-align: top;\n"]);
      return Oa = function Oa() {
        return e;
      }, e;
    }
    function ka(e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }
    var Pa = a.a.div(Oa()),
      Da = Ca(a.a.div(Ta()));
    var Ia = function Ia(e) {
      var t = e.children,
        n = e.index,
        r = e.renderCard,
        o = e.renderLaneHeader,
        a = e.disableLaneDrag,
        l = e.disableCardDrag;
      return i.a.createElement(sa, {
        draggableId: "lane-draggable-".concat(t.id),
        index: n,
        isDragDisabled: a
      }, function (e) {
        return i.a.createElement(Pa, Sa({
          ref: e.innerRef
        }, e.draggableProps, {
          "data-testid": "lane"
        }), i.a.createElement("div", Sa({}, e.dragHandleProps, {
          "data-testid": "lane-header"
        }), o(t)), i.a.createElement(Da, {
          droppableId: String(t.id)
        }, t.cards.length ? t.cards.map(function (e, n) {
          return i.a.createElement(ha, {
            key: e.id,
            index: n,
            renderCard: function renderCard(n) {
              return r(t, e, n);
            },
            disableCardDrag: l
          }, e);
        }) : i.a.createElement(wa, null)));
      });
    };
    function Na(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }
    function Ra(e) {
      for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
      return function () {
        for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++) r[i] = arguments[i];
        return e.apply(void 0, r.concat(n));
      };
    }
    function _a(e, t, n) {
      var r = Na(e);
      return r.splice(n, 0, t), r;
    }
    function Aa(e, t) {
      return e.reduce(function (e, n, r) {
        return r === t ? e : [].concat(Na(e), [n]);
      }, []);
    }
    function La(e, t, n) {
      return function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return function (e) {
          return t.reduce(function (e, t) {
            return t(e);
          }, e);
        };
      }(Ra(Aa, t), Ra(_a, e[t], n))(e);
    }
    function ja(e) {
      return e;
    }
    function Ma(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ja;
      return function (n) {
        if (t(e)) return n(e);
      };
    }
    function Ba(e) {
      return function (t) {
        return e.map(function (e) {
          return t.when(e) ? t.for(e) : e;
        });
      };
    }
    function Fa() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  min-width: 230px;\n\n  form {\n    display: flex;\n    justify-content: space-between;\n  }\n"]);
      return Fa = function Fa() {
        return e;
      }, e;
    }
    var za = a()(Pa)(Fa());
    var Ua = function Ua(e) {
      var t = e.onConfirm,
        n = e.onCancel,
        r = i.a.createRef();
      return i.a.createElement(za, null, i.a.createElement("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault(), Ma(r.current.value)(t);
        }
      }, i.a.createElement("input", {
        type: "text",
        ref: r,
        autoFocus: !0
      }), i.a.createElement("button", {
        type: "submit"
      }, "Add"), i.a.createElement("button", {
        type: "button",
        onClick: n
      }, "Cancel")));
    };
    function Ga(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (var a, l = e[Symbol.iterator](); !(r = (a = l.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
        } catch (e) {
          i = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    function Wa() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  border: 2px dashed #eee;\n  min-width: 230px;\n  height: 132px;\n  margin: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);
      return Wa = function Wa() {
        return e;
      }, e;
    }
    var Ha = a.a.div(Wa());
    var Va = function Va(e) {
      var t = e.onConfirm,
        n = Ga(Object(r.useState)(!1), 2),
        o = n[0],
        a = n[1];
      return o ? i.a.createElement(Ua, {
        onConfirm: function onConfirm(e) {
          t(e), a(!1);
        },
        onCancel: function onCancel() {
          return a(!1);
        }
      }) : i.a.createElement(Ha, {
        onClick: function onClick() {
          return a(!0);
        },
        role: "button"
      }, "➕");
    };
    function qa() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  cursor: pointer;\n"]);
      return qa = function qa() {
        return e;
      }, e;
    }
    var $a = a.a.span(qa());
    function Ka(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (var a, l = e[Symbol.iterator](); !(r = (a = l.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
        } catch (e) {
          i = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    function Qa() {
      var e = Ja(["\n  :focus {\n    outline: none;\n  }\n"]);
      return Qa = function Qa() {
        return e;
      }, e;
    }
    function Ya() {
      var e = Ja(["\n  color: #333333;\n  background-color: #ffffff;\n  border-color: #cccccc;\n\n  :hover,\n  :focus,\n  :active {\n    background-color: #e6e6e6;\n  }\n"]);
      return Ya = function Ya() {
        return e;
      }, e;
    }
    function Xa() {
      var e = Ja(["\n  padding-bottom: 10px;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n\n  span:nth-child(2) {\n    cursor: pointer;\n  }\n"]);
      return Xa = function Xa() {
        return e;
      }, e;
    }
    function Ja(e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }
    var Za = a.a.div(Xa()),
      el = a.a.button(Ya()),
      tl = a.a.input(Qa());
    function nl(e) {
      var t = e.allowRenameLane,
        n = e.onClick,
        r = e.children;
      return t ? i.a.createElement($a, {
        onClick: n
      }, r) : i.a.createElement("span", null, r);
    }
    var rl = function rl(e) {
      var t = e.children,
        n = e.allowRemoveLane,
        o = e.onLaneRemove,
        a = e.allowRenameLane,
        l = e.onLaneRename,
        u = function (e) {
          var t = Ka(Object(r.useState)(e), 2),
            n = t[0],
            i = t[1];
          return [n, function () {
            i(!n);
          }];
        }(!1),
        c = Ka(u, 2),
        s = c[0],
        d = c[1],
        f = Ka(Object(r.useState)(t.title), 2),
        p = f[0],
        m = f[1],
        g = Ka(Object(r.useState)(""), 2),
        v = g[0],
        b = g[1];
      function h() {
        b(p), d();
      }
      return i.a.createElement(Za, null, s ? i.a.createElement("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault(), l(t, v), m(v), d();
        }
      }, i.a.createElement("span", null, i.a.createElement(tl, {
        type: "text",
        value: v,
        onChange: function onChange(e) {
          var t = e.target.value;
          return b(t);
        },
        autoFocus: !0
      })), i.a.createElement("span", null, i.a.createElement(el, {
        type: "submit"
      }, "Rename"), i.a.createElement(el, {
        type: "button",
        onClick: h
      }, "Cancel"))) : i.a.createElement(i.a.Fragment, null, i.a.createElement(nl, {
        allowRenameLane: a,
        onClick: h
      }, p), n && i.a.createElement("span", {
        onClick: function onClick() {
          return o(t);
        }
      }, "×")));
    };
    function il() {
      var e = ll(["\n  padding-top: 10px;\n"]);
      return il = function il() {
        return e;
      }, e;
    }
    function ol() {
      var e = ll(["\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n"]);
      return ol = function ol() {
        return e;
      }, e;
    }
    function al() {
      var e = ll(["\n  border-radius: 3px;\n  background-color: #fff;\n  padding: 10px;\n  margin-bottom: 7px;\n\n  ", "\n"]);
      return al = function al() {
        return e;
      }, e;
    }
    function ll(e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }
    var ul = a()(wa)(al(), function (e) {
        return e.dragging && "\n    box-shadow: 2px 2px grey;\n  ";
      }),
      cl = a.a.div(ol()),
      sl = a.a.div(il()),
      dl = function dl(e) {
        var t = e.children,
          n = e.dragging,
          r = e.allowRemoveCard,
          o = e.onCardRemove;
        return i.a.createElement(ul, {
          dragging: n
        }, i.a.createElement("span", null, i.a.createElement(cl, null, i.a.createElement("span", null, t.title), r && i.a.createElement($a, {
          onClick: function onClick() {
            return o(t);
          }
        }, "×"))), i.a.createElement(sl, null, t.description));
      };
    function fl(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function pl(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? fl(Object(n), !0).forEach(function (t) {
          ml(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fl(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function ml(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function gl(e) {
      return "BOARD" === e;
    }
    function vl(e, t) {
      return e.lanes.find(function (e) {
        return e.id === t.fromLaneId;
      }).cards[t.fromPosition];
    }
    function bl(e, t) {
      return e.lanes.find(function (e) {
        var n = e.id;
        return String(n) === t;
      });
    }
    function hl(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function yl(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? hl(Object(n), !0).forEach(function (t) {
          wl(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hl(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function wl(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function xl(e, t) {
      return yl({}, e, {
        cards: t(e.cards)
      });
    }
    function El(e, t, n) {
      var r = t.fromPosition,
        i = n.toPosition;
      return yl({}, e, {
        lanes: La(e.lanes, r, i)
      });
    }
    function Cl(e, t, n) {
      var r = t.fromPosition,
        i = t.fromLaneId,
        o = n.toPosition,
        a = n.toLaneId,
        l = e.lanes.find(function (e) {
          return e.id === i;
        }),
        u = e.lanes.find(function (e) {
          return e.id === a;
        }),
        c = function c(t) {
          return yl({}, e, {
            lanes: e.lanes.map(t)
          });
        },
        s = xl.bind(null, l),
        d = xl.bind(null, u);
      if (l.id === u.id) {
        var f = s(function (e) {
          return La(e, r, o);
        });
        return c(function (e) {
          return e.id === l.id ? f : e;
        });
      }
      var p = s(function (e) {
          return Aa(e, r);
        }),
        m = d(function (e) {
          return _a(e, l.cards[r], o);
        });
      return c(function (e) {
        return e.id === l.id ? p : e.id === u.id ? m : e;
      });
    }
    function Sl(e, t) {
      return yl({}, e, {
        lanes: _a(e.lanes, t, e.lanes.length)
      });
    }
    function Tl(e, t) {
      return yl({}, e, {
        lanes: e.lanes.filter(function (e) {
          return e.id !== t.id;
        })
      });
    }
    function Ol(e, t, n) {
      var r = Ba(e.lanes)({
        when: function when(e) {
          return e.id === t.id;
        },
        for: function _for(e) {
          return yl({}, e, {
            title: n
          });
        }
      });
      return yl({}, e, {
        lanes: r
      });
    }
    function kl(e, t, n) {
      var r = (arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}).on,
        i = e.lanes.find(function (e) {
          return e.id === t.id;
        }),
        o = _a(i.cards, n, "top" === r ? 0 : i.cards.length),
        a = Ba(e.lanes)({
          when: function when(e) {
            var n = e.id;
            return t.id === n;
          },
          for: function _for(e) {
            return yl({}, e, {
              cards: o
            });
          }
        });
      return yl({}, e, {
        lanes: a
      });
    }
    function Pl(e, t, n) {
      var r = e.lanes.find(function (e) {
          return e.id === t.id;
        }),
        i = r.cards.filter(function (e) {
          var t = e.id;
          return n.id !== t;
        }),
        o = yl({}, r, {
          cards: i
        }),
        a = e.lanes.map(function (e) {
          return t.id === e.id ? o : e;
        });
      return yl({}, e, {
        lanes: a
      });
    }
    function Dl() {
      return (Dl = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      }).apply(this, arguments);
    }
    function Il(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Nl(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Il(Object(n), !0).forEach(function (t) {
          Rl(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Il(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function Rl(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function _l(e, t, n, r, i, o, a) {
      try {
        var l = e[o](a),
          u = l.value;
      } catch (e) {
        return void n(e);
      }
      l.done ? t(u) : Promise.resolve(u).then(r, i);
    }
    function Al(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (var a, l = e[Symbol.iterator](); !(r = (a = l.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
        } catch (e) {
          i = !0, o = e;
        } finally {
          try {
            r || null == l.return || l.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    function Ll() {
      var e = Ml(["\n  white-space: nowrap;\n"]);
      return Ll = function Ll() {
        return e;
      }, e;
    }
    function jl() {
      var e = Ml(["\n  padding: 5px;\n  overflow-y: hidden;\n  display: flex;\n  align-items: flex-start;\n"]);
      return jl = function jl() {
        return e;
      }, e;
    }
    function Ml(e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }
    var Bl = a.a.div(jl()),
      Fl = Ca(a.a.div(Ll()));
    function zl(e) {
      var t = e.initialBoard,
        n = e.onCardDragEnd,
        o = e.onLaneDragEnd,
        a = e.allowAddLane,
        l = e.renderLaneAdder,
        u = e.onNewLaneConfirm,
        c = e.onLaneRemove,
        s = e.renderLaneHeader,
        d = e.allowRemoveLane,
        f = e.allowRenameLane,
        p = e.onLaneRename,
        m = e.onCardNew,
        g = e.renderCard,
        v = e.allowRemoveCard,
        b = e.onCardRemove,
        h = e.onLaneNew,
        y = e.disableCardDrag,
        w = e.disableLaneDrag,
        x = Al(Object(r.useState)(t), 2),
        E = x[0],
        C = x[1],
        S = Ra(O, {
          moveCallback: Cl,
          notifyCallback: n
        }),
        T = Ra(O, {
          moveCallback: El,
          notifyCallback: o
        });
      function O(e, t) {
        var n = e.source,
          r = e.destination,
          i = e.card,
          o = t.moveCallback,
          a = t.notifyCallback,
          l = o(E, n, r);
        Ma(a)(function (e) {
          return i ? e(l, i, n, r) : e(l, n, r);
        }), C(l);
      }
      function k(e) {
        return P.apply(this, arguments);
      }
      function P() {
        var e;
        return e = /*#__PURE__*/_regeneratorRuntime().mark(function e(_e3) {
          var t, n;
          return _regeneratorRuntime().wrap(function e$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!l) {
                  _context.next = 4;
                  break;
                }
                _context.t0 = _e3;
                _context.next = 7;
                break;
              case 4:
                _context.next = 6;
                return u(_e3);
              case 6:
                _context.t0 = _context.sent;
              case 7:
                t = _context.t0;
                n = Sl(E, t);
                h(n, t), C(n);
              case 10:
              case "end":
                return _context.stop();
            }
          }, e);
        }), (P = function P() {
          var t = this,
            n = arguments;
          return new Promise(function (r, i) {
            var o = e.apply(t, n);
            function a(e) {
              _l(o, r, i, a, l, "next", e);
            }
            function l(e) {
              _l(o, r, i, a, l, "throw", e);
            }
            a(void 0);
          });
        }).apply(this, arguments);
      }
      function D(e) {
        var t = Tl(E, e);
        c(t, e), C(t);
      }
      function I(e, t) {
        var n = Ol(E, e, t);
        p(n, Nl({}, e, {
          title: t
        })), C(n);
      }
      function N(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = kl(E, e, t, n);
        m(r, r.lanes.find(function (t) {
          return t.id === e.id;
        }), t), C(r);
      }
      function R(e, t) {
        var n = Pl(E, e, t);
        b(n, n.lanes.find(function (t) {
          return t.id === e.id;
        }), t), C(n);
      }
      return i.a.createElement(Gl, Dl({
        onCardDragEnd: S,
        onLaneDragEnd: T,
        renderLaneAdder: function renderLaneAdder() {
          return a ? l ? l({
            addLane: k
          }) : u ? i.a.createElement(Va, {
            onConfirm: function onConfirm(e) {
              return k({
                title: e,
                cards: []
              });
            }
          }) : null : null;
        }
      }, s && {
        renderLaneHeader: function renderLaneHeader(e) {
          return s(e, {
            removeLane: D.bind(null, e),
            renameLane: I.bind(null, e),
            addCard: N.bind(null, e)
          });
        }
      }, {
        renderCard: function renderCard(e, t, n) {
          return g ? g(t, {
            removeCard: R.bind(null, e, t),
            dragging: n
          }) : i.a.createElement(dl, {
            dragging: n,
            allowRemoveCard: v,
            onCardRemove: function onCardRemove(t) {
              return R(e, t);
            }
          }, t);
        },
        allowRemoveLane: d,
        onLaneRemove: D,
        allowRenameLane: f,
        onLaneRename: I,
        disableLaneDrag: w,
        disableCardDrag: y
      }), E);
    }
    function Ul(e) {
      var t = e.children,
        n = e.onCardDragEnd,
        r = e.onLaneDragEnd,
        o = e.allowAddLane,
        a = e.renderLaneAdder,
        l = e.onNewLaneConfirm,
        u = e.onLaneRemove,
        c = e.renderLaneHeader,
        s = e.allowRemoveLane,
        d = e.allowRenameLane,
        f = e.onLaneRename,
        p = e.renderCard,
        m = e.allowRemoveCard,
        g = e.onCardRemove,
        v = e.disableCardDrag,
        b = e.disableLaneDrag;
      return i.a.createElement(Gl, Dl({
        onCardDragEnd: function onCardDragEnd(e) {
          var t = e.source,
            r = e.destination,
            i = e.card;
          Ma(n)(function (e) {
            return e(i, t, r);
          });
        },
        onLaneDragEnd: function onLaneDragEnd(e) {
          var t = e.source,
            n = e.destination;
          Ma(r)(function (e) {
            return e(t, n);
          });
        },
        renderLaneAdder: function renderLaneAdder() {
          return o ? a ? a() : l ? i.a.createElement(Va, {
            onConfirm: function onConfirm(e) {
              return l({
                title: e,
                cards: []
              });
            }
          }) : null : null;
        }
      }, c && {
        renderLaneHeader: c
      }, {
        renderCard: function renderCard(e, t, n) {
          return p ? p(t, {
            dragging: n
          }) : i.a.createElement(dl, {
            dragging: n,
            allowRemoveCard: m,
            onCardRemove: g
          }, t);
        },
        allowRemoveLane: s,
        onLaneRemove: u,
        allowRenameLane: d,
        onLaneRename: f,
        disableLaneDrag: b,
        disableCardDrag: v
      }), t);
    }
    function Gl(e) {
      var t = e.children,
        n = e.renderCard,
        r = e.disableLaneDrag,
        o = e.disableCardDrag,
        a = e.renderLaneHeader,
        l = e.renderLaneAdder,
        u = e.allowRemoveLane,
        c = e.onLaneRemove,
        s = e.allowRenameLane,
        d = e.onLaneRename,
        f = e.onLaneDragEnd,
        p = e.onCardDragEnd;
      return i.a.createElement(Oo, {
        onDragEnd: function onDragEnd(e) {
          var n = function (e, t) {
            if (null === e.destination) return {};
            var n = {
                fromPosition: e.source.index
              },
              r = {
                toPosition: e.destination.index
              };
            return gl(e.type) ? {
              source: n,
              destination: r
            } : {
              source: pl({}, n, {
                fromLaneId: bl(t, e.source.droppableId).id
              }),
              destination: pl({}, r, {
                toLaneId: bl(t, e.destination.droppableId).id
              })
            };
          }(e, t);
          n.source && (gl(e.type) ? f(n) : p(Nl({}, n, {
            card: vl(t, n.source)
          })));
        }
      }, i.a.createElement(Bl, null, i.a.createElement(Fl, {
        droppableId: "board-droppable",
        direction: "horizontal",
        type: "BOARD"
      }, t.lanes.map(function (e, t) {
        return i.a.createElement(Ia, {
          key: e.id,
          index: t,
          renderCard: n,
          renderLaneHeader: function renderLaneHeader(e) {
            return a ? a(e) : i.a.createElement(rl, {
              allowRemoveLane: u,
              onLaneRemove: c,
              allowRenameLane: s,
              onLaneRename: d
            }, e);
          },
          disableLaneDrag: r,
          disableCardDrag: o
        }, e);
      })), l()));
    }
    var Wl = function Wl(e) {
      return e.initialBoard ? i.a.createElement(zl, e) : i.a.createElement(Ul, e);
    };
    n.d(t, "default", function () {
      return Wl;
    }), n.d(t, "moveLane", function () {
      return El;
    }), n.d(t, "moveCard", function () {
      return Cl;
    }), n.d(t, "addLane", function () {
      return Sl;
    }), n.d(t, "removeLane", function () {
      return Tl;
    }), n.d(t, "renameLane", function () {
      return Ol;
    }), n.d(t, "addCard", function () {
      return kl;
    }), n.d(t, "removeCard", function () {
      return Pl;
    });
  }]);
});